export const CategoryMapNeimeng =
[
  {
    'children': [
      {
        'code': 'lgss_231',
        'id': '231',
        'name': '中央纪委',
        'parentId': '230'
      },
      {
        'code': 'lgss_232',
        'id': '232',
        'name': '省市区纪委',
        'parentId': '230'
      },
      {
        'code': 'lgss_233',
        'id': '233',
        'name': '地市州纪委',
        'parentId': '230'
      },
      {
        'code': 'lgss_234',
        'id': '234',
        'name': '县市区纪委',
        'parentId': '230'
      },
      {
        'code': 'lgss_235',
        'id': '235',
        'name': '中央纪委派驻纪检组',
        'parentId': '230'
      },
      {
        'code': 'lgss_236',
        'id': '236',
        'name': '省区市纪委派驻纪检组',
        'parentId': '230'
      },
      {
        'code': 'lgss_237',
        'id': '237',
        'name': '地市州纪委派驻纪检组',
        'parentId': '230'
      },
      {
        'code': 'lgss_238',
        'id': '238',
        'name': '党和国家机关内设纪检组',
        'parentId': '230'
      },
      {
        'code': 'lgss_239',
        'id': '239',
        'name': '国有大型企业纪委纪检组',
        'parentId': '230'
      },
      {
        'code': 'lgss_240',
        'id': '240',
        'name': '中央和国务院直属事业单位纪委',
        'parentId': '230'
      },
      {
        'code': 'lgss_860',
        'id': '860',
        'name': '中央和国家机关直属纪工委',
        'parentId': '230'
      },
      {
        'code': 'lgss_861',
        'id': '861',
        'name': '省级纪工委',
        'parentId': '230'
      },
      {
        'code': 'lgss_1249',
        'id': '1249',
        'name': '中央企业纪委纪检组',
        'parentId': '230'
      }
    ],
    'code': 'lgss',
    'id': '230',
    'name': '实施机关_两规',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'lzss_242',
        'id': '242',
        'name': '监察部',
        'parentId': '241'
      },
      {
        'code': 'lzss_243',
        'id': '243',
        'name': '省区市监察厅局',
        'parentId': '241'
      },
      {
        'code': 'lzss_244',
        'id': '244',
        'name': '地市州监察局',
        'parentId': '241'
      },
      {
        'code': 'lzss_245',
        'id': '245',
        'name': '县市区监察局',
        'parentId': '241'
      },
      {
        'code': 'lzss_246',
        'id': '246',
        'name': '监察部派驻监察局监察专员办公室',
        'parentId': '241'
      },
      {
        'code': 'lzss_247',
        'id': '247',
        'name': '省区市监察厅（局）派驻监察室',
        'parentId': '241'
      },
      {
        'code': 'lzss_248',
        'id': '248',
        'name': '地市州监察局派驻监察室',
        'parentId': '241'
      },
      {
        'code': 'lzss_1294',
        'id': '1294',
        'name': '中央纪委派驻纪检组',
        'parentId': '241'
      }
    ],
    'code': 'lzss',
    'id': '241',
    'name': '实施机关_两指',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'xl_250',
        'id': '250',
        'name': '博士研究生',
        'parentId': '249'
      },
      {
        'code': 'xl_251',
        'id': '251',
        'name': '硕士研究生',
        'parentId': '249'
      },
      {
        'code': 'xl_252',
        'id': '252',
        'name': '大学本科',
        'parentId': '249'
      },
      {
        'code': 'xl_253',
        'id': '253',
        'name': '大专',
        'parentId': '249'
      },
      {
        'code': 'xl_254',
        'id': '254',
        'name': '中专',
        'parentId': '249'
      },
      {
        'code': 'xl_255',
        'id': '255',
        'name': '高中',
        'parentId': '249'
      },
      {
        'code': 'xl_256',
        'id': '256',
        'name': '初中以下',
        'parentId': '249'
      }
    ],
    'code': 'xl',
    'id': '249',
    'name': '学历',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'mz_258',
        'id': '258',
        'name': '汉族',
        'parentId': '257'
      },
      {
        'code': 'mz_259',
        'id': '259',
        'name': '蒙古族',
        'parentId': '257'
      },
      {
        'code': 'mz_260',
        'id': '260',
        'name': '回族',
        'parentId': '257'
      },
      {
        'code': 'mz_261',
        'id': '261',
        'name': '藏族',
        'parentId': '257'
      },
      {
        'code': 'mz_262',
        'id': '262',
        'name': '维吾尔族',
        'parentId': '257'
      },
      {
        'code': 'mz_263',
        'id': '263',
        'name': '苗族',
        'parentId': '257'
      },
      {
        'code': 'mz_264',
        'id': '264',
        'name': '彝族',
        'parentId': '257'
      },
      {
        'code': 'mz_265',
        'id': '265',
        'name': '壮族',
        'parentId': '257'
      },
      {
        'code': 'mz_266',
        'id': '266',
        'name': '布依族',
        'parentId': '257'
      },
      {
        'code': 'mz_267',
        'id': '267',
        'name': '朝鲜族',
        'parentId': '257'
      },
      {
        'code': 'mz_268',
        'id': '268',
        'name': '满族',
        'parentId': '257'
      },
      {
        'code': 'mz_269',
        'id': '269',
        'name': '侗族',
        'parentId': '257'
      },
      {
        'code': 'mz_270',
        'id': '270',
        'name': '瑶族',
        'parentId': '257'
      },
      {
        'code': 'mz_271',
        'id': '271',
        'name': '白族',
        'parentId': '257'
      },
      {
        'code': 'mz_272',
        'id': '272',
        'name': '土家族',
        'parentId': '257'
      },
      {
        'code': 'mz_273',
        'id': '273',
        'name': '哈尼族',
        'parentId': '257'
      },
      {
        'code': 'mz_274',
        'id': '274',
        'name': '哈萨克族',
        'parentId': '257'
      },
      {
        'code': 'mz_275',
        'id': '275',
        'name': '傣族',
        'parentId': '257'
      },
      {
        'code': 'mz_276',
        'id': '276',
        'name': '黎族',
        'parentId': '257'
      },
      {
        'code': 'mz_277',
        'id': '277',
        'name': '傈僳族',
        'parentId': '257'
      },
      {
        'code': 'mz_278',
        'id': '278',
        'name': '佤族',
        'parentId': '257'
      },
      {
        'code': 'mz_279',
        'id': '279',
        'name': '畲族',
        'parentId': '257'
      },
      {
        'code': 'mz_280',
        'id': '280',
        'name': '高山族',
        'parentId': '257'
      },
      {
        'code': 'mz_281',
        'id': '281',
        'name': '拉祜族',
        'parentId': '257'
      },
      {
        'code': 'mz_282',
        'id': '282',
        'name': '水族',
        'parentId': '257'
      },
      {
        'code': 'mz_283',
        'id': '283',
        'name': '东乡族',
        'parentId': '257'
      },
      {
        'code': 'mz_284',
        'id': '284',
        'name': '纳西族',
        'parentId': '257'
      },
      {
        'code': 'mz_285',
        'id': '285',
        'name': '景颇族',
        'parentId': '257'
      },
      {
        'code': 'mz_286',
        'id': '286',
        'name': '柯尔克孜族',
        'parentId': '257'
      },
      {
        'code': 'mz_287',
        'id': '287',
        'name': '土族',
        'parentId': '257'
      },
      {
        'code': 'mz_288',
        'id': '288',
        'name': '达斡尔族',
        'parentId': '257'
      },
      {
        'code': 'mz_289',
        'id': '289',
        'name': '仫佬族',
        'parentId': '257'
      },
      {
        'code': 'mz_290',
        'id': '290',
        'name': '羌族',
        'parentId': '257'
      },
      {
        'code': 'mz_291',
        'id': '291',
        'name': '布朗族',
        'parentId': '257'
      },
      {
        'code': 'mz_292',
        'id': '292',
        'name': '撒拉族',
        'parentId': '257'
      },
      {
        'code': 'mz_293',
        'id': '293',
        'name': '毛南族',
        'parentId': '257'
      },
      {
        'code': 'mz_294',
        'id': '294',
        'name': '仡佬族',
        'parentId': '257'
      },
      {
        'code': 'mz_295',
        'id': '295',
        'name': '锡伯族',
        'parentId': '257'
      },
      {
        'code': 'mz_296',
        'id': '296',
        'name': '阿昌族',
        'parentId': '257'
      },
      {
        'code': 'mz_297',
        'id': '297',
        'name': '普米族',
        'parentId': '257'
      },
      {
        'code': 'mz_298',
        'id': '298',
        'name': '塔吉克族',
        'parentId': '257'
      },
      {
        'code': 'mz_299',
        'id': '299',
        'name': '怒族',
        'parentId': '257'
      },
      {
        'code': 'mz_300',
        'id': '300',
        'name': '乌孜别克族',
        'parentId': '257'
      },
      {
        'code': 'mz_301',
        'id': '301',
        'name': '俄罗斯族',
        'parentId': '257'
      },
      {
        'code': 'mz_302',
        'id': '302',
        'name': '鄂温克族',
        'parentId': '257'
      },
      {
        'code': 'mz_303',
        'id': '303',
        'name': '德昂族',
        'parentId': '257'
      },
      {
        'code': 'mz_304',
        'id': '304',
        'name': '保安族',
        'parentId': '257'
      },
      {
        'code': 'mz_305',
        'id': '305',
        'name': '裕固族',
        'parentId': '257'
      },
      {
        'code': 'mz_306',
        'id': '306',
        'name': '京族',
        'parentId': '257'
      },
      {
        'code': 'mz_307',
        'id': '307',
        'name': '塔塔尔族',
        'parentId': '257'
      },
      {
        'code': 'mz_308',
        'id': '308',
        'name': '独龙族',
        'parentId': '257'
      },
      {
        'code': 'mz_309',
        'id': '309',
        'name': '鄂伦春族',
        'parentId': '257'
      },
      {
        'code': 'mz_310',
        'id': '310',
        'name': '赫哲族',
        'parentId': '257'
      },
      {
        'code': 'mz_311',
        'id': '311',
        'name': '门巴族',
        'parentId': '257'
      },
      {
        'code': 'mz_312',
        'id': '312',
        'name': '珞巴族',
        'parentId': '257'
      },
      {
        'code': 'mz_313',
        'id': '313',
        'name': '基诺族',
        'parentId': '257'
      }
    ],
    'code': 'mz',
    'id': '257',
    'name': '民族',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'zzmm_321',
            'id': '321',
            'name': '正式党员',
            'parentId': '315'
          },
          {
            'code': 'zzmm_322',
            'id': '322',
            'name': '预备党员',
            'parentId': '315'
          }
        ],
        'code': 'zzmm_315',
        'id': '315',
        'name': '党员',
        'parentId': '314'
      },
      {
        'code': 'zzmm_316',
        'id': '316',
        'name': '团员',
        'parentId': '314'
      },
      {
        'children': [
          {
            'code': 'zzmm_323',
            'id': '323',
            'name': '中国国民党革命委员会',
            'parentId': '317'
          },
          {
            'code': 'zzmm_324',
            'id': '324',
            'name': '中国民主同盟',
            'parentId': '317'
          },
          {
            'code': 'zzmm_325',
            'id': '325',
            'name': '中国民主建国会',
            'parentId': '317'
          },
          {
            'code': 'zzmm_326',
            'id': '326',
            'name': '中国民主促进会',
            'parentId': '317'
          },
          {
            'code': 'zzmm_327',
            'id': '327',
            'name': '中国农工民主党',
            'parentId': '317'
          },
          {
            'code': 'zzmm_328',
            'id': '328',
            'name': '中国致公党',
            'parentId': '317'
          },
          {
            'code': 'zzmm_329',
            'id': '329',
            'name': '九三学社',
            'parentId': '317'
          },
          {
            'code': 'zzmm_330',
            'id': '330',
            'name': '台湾民主自治同盟',
            'parentId': '317'
          }
        ],
        'code': 'zzmm_317',
        'id': '317',
        'name': '民主党派',
        'parentId': '314'
      },
      {
        'code': 'zzmm_318',
        'id': '318',
        'name': '其他',
        'parentId': '314'
      },
      {
        'code': 'zzmm_319',
        'id': '319',
        'name': '党组织',
        'parentId': '314'
      },
      {
        'code': 'zzmm_320',
        'id': '320',
        'name': '法人',
        'parentId': '314'
      },
      {
        'code': 'zzmm_862',
        'id': '862',
        'name': '无党派',
        'parentId': '314'
      }
    ],
    'code': 'zzmm',
    'id': '314',
    'name': '政治面貌',
    'parentId': '0'
  },
  {
    'children': [
      // {
      //   'children': [
      //     {
      //       'code': 'rank_338',
      //       'id': '338',
      //       'name': '领导职务正级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'rank_339',
      //       'id': '339',
      //       'name': '非领导职务正级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'rank_340',
      //       'id': '340',
      //       'name': '领导职务副级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'rank_341',
      //       'id': '341',
      //       'name': '非领导职务副级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'rank_848',
      //       'id': '848',
      //       'name': '正级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'rank_849',
      //       'id': '849',
      //       'name': '副级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'cluesecondrank_946',
      //       'id': '946',
      //       'name': '正省部级以上',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'cluesecondrank_947',
      //       'id': '947',
      //       'name': '正省部级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'cluesecondrank_948',
      //       'id': '948',
      //       'name': '副省部级',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'cluesecondrank_949',
      //       'id': '949',
      //       'name': '中管企业主要负责人',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'cluesecondrank_950',
      //       'id': '950',
      //       'name': '中央金融机构正职',
      //       'parentId': '332'
      //     },
      //     {
      //       'code': 'cluesecondrank_951',
      //       'id': '951',
      //       'name': '中央金融机构副职',
      //       'parentId': '332'
      //     }
      //   ],
      //   'code': 'rank_332',
      //   'id': '332',
      //   'name': '省部级及以上',
      //   'parentId': '331'
      // },
      // {
      //   'children': [
      //     {
      //       'code': 'rank_342',
      //       'id': '342',
      //       'name': '领导职务正级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'rank_343',
      //       'id': '343',
      //       'name': '非领导职务正级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'rank_344',
      //       'id': '344',
      //       'name': '领导职务副级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'rank_345',
      //       'id': '345',
      //       'name': '非领导职务副级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'rank_850',
      //       'id': '850',
      //       'name': '正级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'rank_851',
      //       'id': '851',
      //       'name': '副级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'cluesecondrank_952',
      //       'id': '952',
      //       'name': '正地厅级',
      //       'parentId': '333'
      //     },
      //     {
      //       'code': 'cluesecondrank_953',
      //       'id': '953',
      //       'name': '副地厅级',
      //       'parentId': '333'
      //     }
      //   ],
      //   'code': 'rank_333',
      //   'id': '333',
      //   'name': '厅局级',
      //   'parentId': '331'
      // },
      {
        'children': [
          {
            'code': 'rank_346',
            'id': '346',
            'name': '领导职务正级',
            'parentId': '334'
          },
          {
            'code': 'rank_347',
            'id': '347',
            'name': '非领导职务正级',
            'parentId': '334'
          },
          {
            'code': 'rank_348',
            'id': '348',
            'name': '领导职务副级',
            'parentId': '334'
          },
          {
            'code': 'rank_349',
            'id': '349',
            'name': '非领导职务副级',
            'parentId': '334'
          },
          {
            'code': 'rank_852',
            'id': '852',
            'name': '正级',
            'parentId': '334'
          },
          {
            'code': 'rank_853',
            'id': '853',
            'name': '副级',
            'parentId': '334'
          },
          {
            'code': 'cluesecondrank_954',
            'id': '954',
            'name': '正县处级',
            'parentId': '334'
          },
          {
            'code': 'cluesecondrank_955',
            'id': '955',
            'name': '副县处级',
            'parentId': '334'
          }
        ],
        'code': 'rank_334',
        'id': '334',
        'name': '县处级',
        'parentId': '331'
      },
      {
        'children': [
          {
            'code': 'rank_350',
            'id': '350',
            'name': '领导职务正级',
            'parentId': '335'
          },
          {
            'code': 'rank_351',
            'id': '351',
            'name': '非领导职务正级',
            'parentId': '335'
          },
          {
            'code': 'rank_352',
            'id': '352',
            'name': '领导职务副级',
            'parentId': '335'
          },
          {
            'code': 'rank_353',
            'id': '353',
            'name': '非领导职务副级',
            'parentId': '335'
          },
          {
            'code': 'rank_854',
            'id': '854',
            'name': '正级',
            'parentId': '335'
          },
          {
            'code': 'rank_855',
            'id': '855',
            'name': '副级',
            'parentId': '335'
          },
          {
            'code': 'cluesecondrank_956',
            'id': '956',
            'name': '正乡科级',
            'parentId': '335'
          },
          {
            'code': 'cluesecondrank_957',
            'id': '957',
            'name': '副乡科级',
            'parentId': '335'
          }
        ],
        'code': 'rank_335',
        'id': '335',
        'name': '乡科级',
        'parentId': '331'
      },
      {
        'code': 'rank_336',
        'id': '336',
        'name': '一般干部',
        'parentId': '331'
      },
      {
        'children': [
          {
            'code': 'rank_354',
            'id': '354',
            'name': '军队',
            'parentId': '337'
          },
          {
            'code': 'rank_355',
            'id': '355',
            'name': '企业',
            'parentId': '337'
          },
          {
            'code': 'rank_356',
            'id': '356',
            'name': '农村',
            'parentId': '337'
          },
          {
            'code': 'rank_357',
            'id': '357',
            'name': '其他',
            'parentId': '337'
          }
        ],
        'code': 'rank_337',
        'id': '337',
        'name': '其他人员',
        'parentId': '331'
      }
    ],
    'code': 'rank',
    'id': '331',
    'name': '职级',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'deputy_1648',
        'id': '1648',
        'name': '否',
        'parentId': '358'
      },
      {
        'code': 'deputy_359',
        'id': '359',
        'name': '全国人大代表',
        'parentId': '358'
      },
      {
        'code': 'deputy_360',
        'id': '360',
        'name': '省级人大代表',
        'parentId': '358'
      },
      {
        'code': 'deputy_361',
        'id': '361',
        'name': '市级人大代表',
        'parentId': '358'
      },
      {
        'code': 'deputy_362',
        'id': '362',
        'name': '县级人大代表',
        'parentId': '358'
      },
      {
        'code': 'deputy_363',
        'id': '363',
        'name': '乡级人大代表',
        'parentId': '358'
      }
    ],
    'code': 'deputy',
    'id': '358',
    'name': '人大代表',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'commissioner_1647',
        'id': '1647',
        'name': '否',
        'parentId': '364'
      },
      {
        'code': 'commissioner_365',
        'id': '365',
        'name': '全国政协委员',
        'parentId': '364'
      },
      {
        'code': 'commissioner_366',
        'id': '366',
        'name': '省级政协委员',
        'parentId': '364'
      },
      {
        'code': 'commissioner_367',
        'id': '367',
        'name': '市级政协委员',
        'parentId': '364'
      },
      {
        'code': 'commissioner_368',
        'id': '368',
        'name': '县级政协委员',
        'parentId': '364'
      }
    ],
    'code': 'commissioner',
    'id': '364',
    'name': '政协委员',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'casereso_370',
        'id': '370',
        'name': '信访举报',
        'parentId': '369'
      },
      {
        'code': 'casereso_499',
        'id': '3331',
        'name': '上级转办',
        'parentId': '369'
      },
      {
        'code': 'casereso_371',
        'id': '371',
        'name': '上级交办',
        'parentId': '369'
      },
      {
        'code': 'casereso_9302',
        'id': '9302',
        'name': '指定管辖',
        'parentId': '369'
      },
      {
        'code': 'casereso_372',
        'id': '372',
        'name': '公检法等机关移送',
        'parentId': '369'
      },
      {
        'code': 'casereso_373',
        'id': '373',
        'name': '监督检查中发现',
        'parentId': '369'
      },
      {
        'code': 'casereso_374',
        'id': '374',
        'name': '审查调查中发现',
        'parentId': '369'
      },
      {
        'code': 'casereso_375',
        'id': '375',
        'name': '审计中发现',
        'parentId': '369'
      },
      {
        'code': 'casereso_376',
        'id': '376',
        'name': '巡视巡察中发现',
        'parentId': '369'
      },
      {
        'code': 'casereso_1502',
        'id': '1502',
        'name': '其他行政执法机关移送',
        'parentId': '369'
      },
      {
        'code': 'casereso_378',
        'id': '378',
        'name': '留置谈话中发现',
        'parentId': '369'
      },
      {
        'code': 'casereso_377',
        'id': '377',
        'name': '其他',
        'parentId': '369'
      }
    ],
    'code': 'casereso',
    'id': '369',
    'name': '案件来源',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'depttype_390',
            'id': '390',
            'name': '组织',
            'parentId': '379'
          },
          {
            'code': 'depttype_391',
            'id': '391',
            'name': '宣传',
            'parentId': '379'
          },
          {
            'code': 'depttype_392',
            'id': '392',
            'name': '政法委',
            'parentId': '379'
          },
          {
            'code': 'depttype_393',
            'id': '393',
            'name': '纪检监察',
            'parentId': '379'
          },
          {
            'code': 'depttype_857',
            'id': '857',
            'name': '统战部',
            'parentId': '379'
          },
          {
            'code': 'depttype_858',
            'id': '858',
            'name': '机关工委',
            'parentId': '379'
          },
          {
            'code': 'depttype_2394',
            'id': '2394',
            'name': '统战',
            'parentId': '379'
          },
          {
            'code': 'depttype_2395',
            'id': '2395',
            'name': '巡视巡察',
            'parentId': '379'
          },
          {
            'code': 'depttype_2396',
            'id': '2396',
            'name': '其他',
            'parentId': '379'
          }
        ],
        'code': 'depttype_379',
        'id': '379',
        'name': '党务机关',
        'parentId': '378'
      },
      {
        'code': 'depttype_380',
        'id': '380',
        'name': '政府机关',
        'parentId': '378'
      },
      {
        'code': 'depttype_381',
        'id': '381',
        'name': '人大机关',
        'parentId': '378'
      },
      {
        'code': 'depttype_382',
        'id': '382',
        'name': '政协机关',
        'parentId': '378'
      },
      {
        'code': 'depttype_383',
        'id': '383',
        'name': '审判机关',
        'parentId': '378'
      },
      {
        'code': 'depttype_384',
        'id': '384',
        'name': '检察机关',
        'parentId': '378'
      },
      {
        'children': [
          {
            'code': 'depttype_394',
            'id': '394',
            'name': '工会',
            'parentId': '385'
          },
          {
            'code': 'depttype_395',
            'id': '395',
            'name': '共青团',
            'parentId': '385'
          },
          {
            'code': 'depttype_396',
            'id': '396',
            'name': '妇联',
            'parentId': '385'
          },
          {
            'code': 'depttype_397',
            'id': '397',
            'name': '民主党派',
            'parentId': '385'
          },
          {
            'code': 'depttype_398',
            'id': '398',
            'name': '工商联',
            'parentId': '385'
          },
          {
            'code': 'depttype_399',
            'id': '399',
            'name': '残联',
            'parentId': '385'
          },
          {
            'code': 'depttype_400',
            'id': '400',
            'name': '其他群众性组织',
            'parentId': '385'
          }
        ],
        'code': 'depttype_385',
        'id': '385',
        'name': '人民团体',
        'parentId': '378'
      },
      {
        'children': [
          {
            'code': 'depttype_401',
            'id': '401',
            'name': '中央或国务院直属',
            'parentId': '386'
          },
          {
            'code': 'depttype_402',
            'id': '402',
            'name': '非中央或国务院直属',
            'parentId': '386'
          }
        ],
        'code': 'depttype_386',
        'id': '386',
        'name': '事业单位',
        'parentId': '378'
      },
      {
        'code': 'depttype_387',
        'id': '387',
        'name': '企业单位',
        'parentId': '378'
      },
      {
        'children': [
          {
            'code': 'depttype_403',
            'id': '403',
            'name': '村支书村主任',
            'parentId': '388'
          },
          {
            'code': 'depttype_404',
            'id': '404',
            'name': '其他村组干部',
            'parentId': '388'
          },
          {
            'code': 'depttype_405',
            'id': '405',
            'name': '其他党员干部',
            'parentId': '388'
          }
        ],
        'code': 'depttype_388',
        'id': '388',
        'name': '农村',
        'parentId': '378'
      },
      {
        'code': 'depttype_389',
        'id': '389',
        'name': '其他',
        'parentId': '378'
      }
    ],
    'code': 'depttype',
    'id': '378',
    'name': '部门分类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'depttypenew_407',
        'id': '407',
        'name': '教育',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_408',
        'id': '408',
        'name': '民族事务',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_409',
        'id': '409',
        'name': '公安',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_410',
        'id': '410',
        'name': '国家安全',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_411',
        'id': '411',
        'name': '民政',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_412',
        'id': '412',
        'name': '科学技术',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_413',
        'id': '413',
        'name': '司法',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_414',
        'id': '414',
        'name': '财政',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_415',
        'id': '415',
        'name': '人力资源和社会保障',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_416',
        'id': '416',
        'name': '自然资源',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_417',
        'id': '417',
        'name': '生态环境',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_418',
        'id': '418',
        'name': '住房和城乡建设',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_419',
        'id': '419',
        'name': '交通运输',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_420',
        'id': '420',
        'name': '水利',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_421',
        'id': '421',
        'name': '农业农村',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_422',
        'id': '422',
        'name': '商务',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_423',
        'id': '423',
        'name': '文化和旅游',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_424',
        'id': '424',
        'name': '卫生健康',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_425',
        'id': '425',
        'name': '退役军人事务',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_426',
        'id': '426',
        'name': '应急管理',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_427',
        'id': '427',
        'name': '人民银行',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_428',
        'id': '428',
        'name': '审计',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_429',
        'id': '429',
        'name': '国有资产监督管理',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_430',
        'id': '430',
        'name': '海关',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_431',
        'id': '431',
        'name': '税务',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_432',
        'id': '432',
        'name': '市场监督管理',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_433',
        'id': '433',
        'name': '广播电视',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_434',
        'id': '434',
        'name': '体育',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_435',
        'id': '435',
        'name': '统计',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2200',
        'id': '2200',
        'name': '外交',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2201',
        'id': '2201',
        'name': '发改',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2202',
        'id': '2202',
        'name': '工业和信息化',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2203',
        'id': '2203',
        'name': '银行保险监督',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2204',
        'id': '2204',
        'name': '证券监督',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2205',
        'id': '2205',
        'name': '气象',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2206',
        'id': '2206',
        'name': '信访',
        'parentId': '406'
      },
      {
        'code': 'depttypenew_2207',
        'id': '2207',
        'name': '其他',
        'parentId': '406'
      }
    ],
    'code': 'depttypenew',
    'id': '406',
    'name': '部门分类二',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'deptowner_442',
            'id': '442',
            'name': '中央管理正职企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_443',
            'id': '443',
            'name': '国务院国资委管理正职企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_444',
            'id': '444',
            'name': '省委管理正职企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_445',
            'id': '445',
            'name': '省国资委管理正职企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_446',
            'id': '446',
            'name': '市委管理正职企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_447',
            'id': '447',
            'name': '市国资委管理正职企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_448',
            'id': '448',
            'name': '中央金融企业',
            'parentId': '437'
          },
          {
            'code': 'deptowner_449',
            'id': '449',
            'name': '其他',
            'parentId': '437'
          }
        ],
        'code': 'deptowner_437',
        'id': '437',
        'name': '国有或国有控股企业',
        'parentId': '436'
      },
      {
        'code': 'deptowner_438',
        'id': '438',
        'name': '集体企业',
        'parentId': '436'
      },
      {
        'code': 'deptowner_439',
        'id': '439',
        'name': '私营企业',
        'parentId': '436'
      },
      {
        'code': 'deptowner_440',
        'id': '440',
        'name': '其他内资企业',
        'parentId': '436'
      },
      {
        'code': 'deptowner_441',
        'id': '441',
        'name': '外商及港澳台投资企业',
        'parentId': '436'
      }
    ],
    'code': 'deptowner',
    'id': '436',
    'name': '企业性质',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'ranktype_451',
        'id': '451',
        'name': '企业领导人员',
        'parentId': '450'
      },
      {
        'code': 'ranktype_452',
        'id': '452',
        'name': '中层管理人员',
        'parentId': '450'
      },
      {
        'code': 'ranktype_453',
        'id': '453',
        'name': '其他人员',
        'parentId': '450'
      }
    ],
    'code': 'ranktype',
    'id': '450',
    'name': '企业人员类别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'partypunis_459',
        'id': '459',
        'name': '警告',
        'parentId': '458'
      },
      {
        'code': 'partypunis_460',
        'id': '460',
        'name': '严重警告',
        'parentId': '458'
      },
      {
        'code': 'partypunis_461',
        'id': '461',
        'name': '撤销党内职务',
        'parentId': '458'
      },
      {
        'code': 'partypunis_462',
        'id': '462',
        'name': '留党察看',
        'parentId': '458'
      },
      {
        'code': 'partypunis_463',
        'id': '463',
        'name': '开除党籍',
        'parentId': '458'
      }
    ],
    'code': 'partypunis',
    'id': '458',
    'name': '党纪处分',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'adminpunis_465',
        'id': '465',
        'name': '警告',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_466',
        'id': '466',
        'name': '记过',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_467',
        'id': '467',
        'name': '记大过',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_468',
        'id': '468',
        'name': '降级',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_469',
        'id': '469',
        'name': '降职',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_470',
        'id': '470',
        'name': '撤职',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_471',
        'id': '471',
        'name': '开除留用察看',
        'parentId': '464'
      },
      {
        'code': 'adminpunis_472',
        'id': '472',
        'name': '开除',
        'parentId': '464'
      }
    ],
    'code': 'adminpunis',
    'id': '464',
    'name': '政务处分',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'rebukeresu_474',
        'id': '474',
        'name': '维持',
        'parentId': '473'
      },
      {
        'code': 'rebukeresu_475',
        'id': '475',
        'name': '变更',
        'parentId': '473'
      },
      {
        'code': 'rebukeresu_476',
        'id': '476',
        'name': '撤销',
        'parentId': '473'
      },
      {
        'code': 'rebukeresu_477',
        'id': '477',
        'name': '其他',
        'parentId': '473'
      }
    ],
    'code': 'rebukeresu',
    'id': '473',
    'name': '申诉结论',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'rebukemode_479',
        'id': '479',
        'name': '党纪申诉',
        'parentId': '478'
      },
      {
        'code': 'rebukemode_480',
        'id': '480',
        'name': '政务申诉',
        'parentId': '478'
      },
      {
        'code': 'rebukemode_481',
        'id': '481',
        'name': '双重申诉',
        'parentId': '478'
      },
      {
        'code': 'rebukemode_482',
        'id': '482',
        'name': '其他申诉',
        'parentId': '478'
      }
    ],
    'code': 'rebukemode',
    'id': '478',
    'name': '申诉类别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'children': [
              {
                'code': 'report method_real_494',
                'id': '494',
                'name': '来信',
                'parentId': '492'
              },
              {
                'code': 'report method_real_495',
                'id': '495',
                'name': '来电',
                'parentId': '492'
              },
              {
                'code': 'report method_real_496',
                'id': '496',
                'name': '来访',
                'parentId': '492'
              },
              {
                'code': 'report method_real_497',
                'id': '497',
                'name': '网络举报',
                'parentId': '492'
              },
              {
                'code': 'report method_real_498',
                'id': '498',
                'name': '其他',
                'parentId': '492'
              }
            ],
            'code': 'report_type_492',
            'id': '492',
            'name': '实名举报',
            'parentId': '484'
          },
          {
            'children': [
              {
                'code': 'report method_anonymous_499',
                'id': '499',
                'name': '来信',
                'parentId': '493'
              },
              {
                'code': 'report method_anonymous_500',
                'id': '500',
                'name': '来电',
                'parentId': '493'
              },
              {
                'code': 'report method_anonymous_501',
                'id': '501',
                'name': '来访',
                'parentId': '493'
              },
              {
                'code': 'report method_anonymous_502',
                'id': '502',
                'name': '网络举报',
                'parentId': '493'
              },
              {
                'code': 'report method_anonymous_503',
                'id': '503',
                'name': '其他',
                'parentId': '493'
              }
            ],
            'code': 'report_type_493',
            'id': '493',
            'name': '匿名举报',
            'parentId': '484'
          }
        ],
        'code': 'source_484',
        'id': '484',
        'name': '信访举报',
        'parentId': '483'
      },
      {
        'code': 'source_485',
        'id': '485',
        'name': '上级交办',
        'parentId': '483'
      },
      {
        'code': 'source_486',
        'id': '486',
        'name': '公检法等机关移送',
        'parentId': '483'
      },
      {
        'code': 'source_487',
        'id': '487',
        'name': '监督检查中发现',
        'parentId': '483'
      },
      {
        'code': 'source_488',
        'id': '488',
        'name': '审查调查中发现',
        'parentId': '483'
      },
      {
        'code': 'source_489',
        'id': '489',
        'name': '审计中发现',
        'parentId': '483'
      },
      {
        'code': 'source_490',
        'id': '490',
        'name': '巡视巡察中发现',
        'parentId': '483'
      },
      {
        'code': 'source_491',
        'id': '491',
        'name': '其他',
        'parentId': '483'
      },
      {
        'code': 'source_1485',
        'id': '1485',
        'name': '打私反腐“一案双查”',
        'parentId': '483'
      },
      {
        'code': 'source_1645',
        'id': '1645',
        'name': '公检法机关移送',
        'parentId': '483'
      },
      {
        'code': 'source_1646',
        'id': '1646',
        'name': '其他行政执法机关移送',
        'parentId': '483'
      },
    ],
    'code': 'source',
    'id': '483',
    'name': '线索来源',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'rerebcreas_505',
        'id': '505',
        'name': '事实不符',
        'parentId': '504'
      },
      {
        'code': 'rerebcreas_506',
        'id': '506',
        'name': '证据不足',
        'parentId': '504'
      },
      {
        'code': 'rerebcreas_507',
        'id': '507',
        'name': '定性不准',
        'parentId': '504'
      },
      {
        'code': 'rerebcreas_508',
        'id': '508',
        'name': '处分不当',
        'parentId': '504'
      },
      {
        'code': 'rerebcreas_509',
        'id': '509',
        'name': '违反程序',
        'parentId': '504'
      }
    ],
    'code': 'rerebcreas',
    'id': '504',
    'name': '变更、撤消理由',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'lgplacetype_511',
        'id': '511',
        'name': '自建办案点',
        'parentId': '510'
      },
      {
        'code': 'lgplacetype_512',
        'id': '512',
        'name': '租用宾馆',
        'parentId': '510'
      },
      {
        'code': 'lgplacetype_513',
        'id': '513',
        'name': '使用上级纪检机关办案点',
        'parentId': '510'
      },
      {
        'code': 'lgplacetype_514',
        'id': '514',
        'name': '其他',
        'parentId': '510'
      }
    ],
    'code': 'lgplacetype',
    'id': '510',
    'name': '采取措施地点分类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'sfcl_518',
            'id': '518',
            'name': '死刑立即执行',
            'parentId': '516'
          },
          {
            'code': 'sfcl_519',
            'id': '519',
            'name': '死刑缓期执行',
            'parentId': '516'
          },
          {
            'code': 'sfcl_520',
            'id': '520',
            'name': '无期徒刑',
            'parentId': '516'
          },
          {
            'code': 'sfcl_521',
            'id': '521',
            'name': '有期徒刑',
            'parentId': '516'
          },
          {
            'code': 'sfcl_522',
            'id': '522',
            'name': '管制',
            'parentId': '516'
          },
          {
            'code': 'sfcl_523',
            'id': '523',
            'name': '拘役',
            'parentId': '516'
          },
          {
            'code': 'sfcl_524',
            'id': '524',
            'name': '罚金',
            'parentId': '516'
          },
          {
            'code': 'sfcl_525',
            'id': '525',
            'name': '剥夺政治权利',
            'parentId': '516'
          },
          {
            'code': 'sfcl_526',
            'id': '526',
            'name': '没收财产',
            'parentId': '516'
          }
        ],
        'code': 'sfcl_516',
        'id': '516',
        'name': '刑事处理',
        'parentId': '515'
      },
      {
        'children': [
          {
            'code': 'sfcl_527',
            'id': '527',
            'name': '不起诉',
            'parentId': '517'
          },
          {
            'code': 'sfcl_528',
            'id': '528',
            'name': '免予刑事处罚',
            'parentId': '517'
          },
          {
            'code': 'sfcl_529',
            'id': '529',
            'name': '行政拘留',
            'parentId': '517'
          },
          {
            'code': 'sfcl_530',
            'id': '530',
            'name': '劳动教养',
            'parentId': '517'
          },
          {
            'code': 'sfcl_531',
            'id': '531',
            'name': '其他',
            'parentId': '517'
          }
        ],
        'code': 'sfcl_517',
        'id': '517',
        'name': '其他处罚',
        'parentId': '515'
      }
    ],
    'code': 'sfcl',
    'id': '515',
    'name': '公检法处理',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'verifyresu_533',
        'id': '533',
        'name': '转本级立案',
        'parentId': '532'
      },
      {
        'code': 'verifyresu_534',
        'id': '534',
        'name': '了结',
        'parentId': '532'
      },
      {
        'code': 'verifyresu_535',
        'id': '535',
        'name': '转下级立案',
        'parentId': '532'
      },
      {
        'code': 'verifyresu_749',
        'id': '749',
        'name': '销案',
        'parentId': '532'
      },
      {
        'code': 'verifyresu_750',
        'id': '750',
        'name': '结案',
        'parentId': '532'
      }
    ],
    'code': 'verifyresu',
    'id': '532',
    'name': '核实结果',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'censorate_537',
        'id': '537',
        'name': '检察院',
        'parentId': '536'
      },
      {
        'code': 'censorate_538',
        'id': '538',
        'name': '公安',
        'parentId': '536'
      },
      {
        'code': 'censorate_539',
        'id': '539',
        'name': '其他',
        'parentId': '536'
      }
    ],
    'code': 'censorate',
    'id': '536',
    'name': '联合办案',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'conclusion_541',
        'id': '541',
        'name': '失实',
        'parentId': '540'
      },
      {
        'children': [
          {
            'code': 'transacmode_885',
            'id': '885',
            'name': '通报（通报批评）',
            'parentId': '542'
          },
          {
            'code': 'transacmode_886',
            'id': '886',
            'name': '解聘',
            'parentId': '542'
          },
          {
            'code': 'transacmode_887',
            'id': '887',
            'name': '辞退',
            'parentId': '542'
          },
          {
            'code': 'transacmode_888',
            'id': '888',
            'name': '调整（调离）职务（岗位）',
            'parentId': '542'
          },
          {
            'code': 'transacmode_889',
            'id': '889',
            'name': '免职',
            'parentId': '542'
          },
          {
            'code': 'transacmode_890',
            'id': '890',
            'name': '取消预备党员资格',
            'parentId': '542'
          },
          {
            'code': 'transacmode_892',
            'id': '892',
            'name': '诫勉（诫勉谈话）',
            'parentId': '542'
          },
          {
            'code': 'transacmode_893',
            'id': '893',
            'name': '停职（停职检查）',
            'parentId': '542'
          },
          {
            'code': 'transacmode_894',
            'id': '894',
            'name': '责令公开道歉（检讨）',
            'parentId': '542'
          },
          {
            'code': 'transacmode_895',
            'id': '895',
            'name': '引咎辞职',
            'parentId': '542'
          },
          {
            'code': 'transacmode_896',
            'id': '896',
            'name': '责令辞职',
            'parentId': '542'
          },
          {
            'code': 'transacmode_897',
            'id': '897',
            'name': '其它批评教育类措施',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1223',
            'id': '1223',
            'name': '终止党代表资格',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1224',
            'id': '1224',
            'name': '终止（罢免、撤销、责令辞去）人大代表资格',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1225',
            'id': '1225',
            'name': '撤销政协委员资格',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1226',
            'id': '1226',
            'name': '取消（罢免）当选资格',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1227',
            'id': '1227',
            'name': '安排提前退休',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1228',
            'id': '1228',
            'name': '改任非领导职务',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1229',
            'id': '1229',
            'name': '纠正或责令停止违纪行为',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1230',
            'id': '1230',
            'name': '责成退出违纪所得',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1231',
            'id': '1231',
            'name': '批评教育',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1232',
            'id': '1232',
            'name': '提醒谈话',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1233',
            'id': '1233',
            'name': '警示谈话',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1234',
            'id': '1234',
            'name': '召开民主生活会批评帮助',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1235',
            'id': '1235',
            'name': '责令作出口头或书面检查',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1236',
            'id': '1236',
            'name': '限期整改',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1237',
            'id': '1237',
            'name': '取消荣誉称号',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1299',
            'id': '1299',
            'name': '降职',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1300',
            'id': '1300',
            'name': '其它重大职务调整类措施',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1301',
            'id': '1301',
            'name': '组织除名（劝退）',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1302',
            'id': '1302',
            'name': '解除劳动合同',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1303',
            'id': '1303',
            'name': '降低退休待遇',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1304',
            'id': '1304',
            'name': '取消退休待遇',
            'parentId': '542'
          },
          {
            'code': 'transacmode_1305',
            'id': '1305',
            'name': '其它组织调整类措施',
            'parentId': '542'
          }
        ],
        'code': 'conclusion_542',
        'name': '适当处理',
        'parentId': '540'
      },
      {
        'code': 'conclusion_863',
        'id': '863',
        'name': '查无实据',
        'parentId': '540'
      }
    ],
    'code': 'conclusion',
    'id': '540',
    'name': '了结结论',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'phcondition_544',
        'id': '544',
        'name': '武警',
        'parentId': '543'
      },
      {
        'code': 'phcondition_545',
        'id': '545',
        'name': '党和国家机关工作人员',
        'parentId': '543'
      },
      {
        'code': 'phcondition_546',
        'id': '546',
        'name': '其他',
        'parentId': '543'
      }
    ],
    'code': 'phcondition',
    'id': '543',
    'name': '陪护人员情况',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'punishment_548',
        'id': '548',
        'name': '不起诉',
        'parentId': '547'
      },
      {
        'code': 'punishment_549',
        'id': '549',
        'name': '免予刑事处罚',
        'parentId': '547'
      },
      {
        'code': 'punishment_550',
        'id': '550',
        'name': '行政拘留',
        'parentId': '547'
      },
      {
        'code': 'punishment_551',
        'id': '551',
        'name': '劳动教养',
        'parentId': '547'
      },
      {
        'code': 'punishment_552',
        'id': '552',
        'name': '其它行政处罚',
        'parentId': '547'
      }
    ],
    'code': 'punishment',
    'id': '547',
    'name': '其他处罚',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'othertreat_554',
        'id': '554',
        'name': '免予党纪处分',
        'parentId': '553'
      },
      {
        'code': 'othertreat_555',
        'id': '555',
        'name': '免予政务处分',
        'parentId': '553'
      },
      {
        'code': 'othertreat_556',
        'id': '556',
        'name': '不予处分',
        'parentId': '553'
      },
      {
        'code': 'othertreat_557',
        'id': '557',
        'name': '改组党组织',
        'parentId': '553'
      },
      {
        'code': 'othertreat_558',
        'id': '558',
        'name': '解散党组织',
        'parentId': '553'
      },
      {
        'code': 'othertreat_559',
        'id': '559',
        'name': '处分有关人员',
        'parentId': '553'
      },
      {
        'code': 'othertreat_1659',
        'id': '1659',
        'name': '对两非人员不予移送司法机关',
        'parentId': '553'
      }
    ],
    'code': 'othertreat',
    'id': '553',
    'name': '其他处理',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'organizational_process_561',
        'id': '561',
        'name': '通报（通报批评）',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_562',
        'id': '562',
        'name': '解聘',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_563',
        'id': '563',
        'name': '辞退',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_564',
        'id': '564',
        'name': '调整（调离）职务（岗位）',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_565',
        'id': '565',
        'name': '免职',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_566',
        'id': '566',
        'name': '取消预备党员资格',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_567',
        'id': '567',
        'name': '诫勉（诫勉谈话）',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_568',
        'id': '568',
        'name': '停职（停职检查）',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_569',
        'id': '569',
        'name': '责令公开道歉（检讨）',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_570',
        'id': '570',
        'name': '引咎辞职',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_571',
        'id': '571',
        'name': '责令辞职',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_572',
        'id': '572',
        'name': '其它组织调整类措施',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_573',
        'id': '573',
        'name': '降职',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_574',
        'id': '574',
        'name': '终止党代表资格',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_575',
        'id': '575',
        'name': '终止（罢免、撤销、责令辞去）人大代表资格',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1250',
        'id': '1250',
        'name': '撤销政协委员资格',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1251',
        'id': '1251',
        'name': '取消（罢免）当选资格',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1252',
        'id': '1252',
        'name': '安排提前退休',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1253',
        'id': '1253',
        'name': '改任非领导职务',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1254',
        'id': '1254',
        'name': '纠正或责令停止违纪行为',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1255',
        'id': '1255',
        'name': '责成退出违纪所得',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1256',
        'id': '1256',
        'name': '批评教育',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1257',
        'id': '1257',
        'name': '提醒谈话',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1258',
        'id': '1258',
        'name': '警示谈话',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1259',
        'id': '1259',
        'name': '召开民主生活会批评帮助',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1260',
        'id': '1260',
        'name': '责令作出口头或书面检查',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1261',
        'id': '1261',
        'name': '限期整改',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1262',
        'id': '1262',
        'name': '取消荣誉称号',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1263',
        'id': '1263',
        'name': '其它重大职务调整类措施',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1264',
        'id': '1264',
        'name': '组织除名（劝退）',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1265',
        'id': '1265',
        'name': '其它批评教育类措施',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1266',
        'id': '1266',
        'name': '解除劳动合同',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1267',
        'id': '1267',
        'name': '降低退休待遇',
        'parentId': '560'
      },
      {
        'code': 'organizational_process_1295',
        'id': '1295',
        'name': '取消退休待遇',
        'parentId': '560'
      }
    ],
    'code': 'organizational_process',
    'id': '560',
    'name': '组织处理',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'lgtype_577',
        'id': '577',
        'name': '两规',
        'parentId': '576'
      },
      {
        'code': 'lgtype_578',
        'id': '578',
        'name': '两指',
        'parentId': '576'
      }
    ],
    'code': 'lgtype',
    'id': '576',
    'name': '使用措施',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'waca_580',
        'id': '580',
        'name': '窝案',
        'parentId': '579'
      },
      {
        'code': 'waca_581',
        'id': '581',
        'name': '串案',
        'parentId': '579'
      }
    ],
    'code': 'waca',
    'id': '579',
    'name': '窝案串案',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'wadetail_583',
        'id': '583',
        'name': '主要涉案人',
        'parentId': '582'
      },
      {
        'code': 'wadetail_584',
        'id': '584',
        'name': '次要涉案人',
        'parentId': '582'
      }
    ],
    'code': 'wadetail',
    'id': '582',
    'name': '窝案细节',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'handledept_586',
        'id': '586',
        'name': '中央纪委 ',
        'parentId': '585'
      },
      {
        'code': 'handledept_587',
        'id': '587',
        'name': '省区市纪委',
        'parentId': '585'
      },
      {
        'code': 'handledept_588',
        'id': '588',
        'name': '地市州盟纪委',
        'parentId': '585'
      },
      {
        'code': 'handledept_589',
        'id': '589',
        'name': '县市区旗纪委',
        'parentId': '585'
      },
      {
        'code': 'handledept_590',
        'id': '590',
        'name': '乡镇纪委',
        'parentId': '585'
      },
      {
        'code': 'handledept_591',
        'id': '591',
        'name': '军队纪委',
        'parentId': '585'
      },
      {
        'code': 'handledept_592',
        'id': '592',
        'name': '中央纪委派驻纪检组',
        'parentId': '585'
      },
      {
        'code': 'handledept_593',
        'id': '593',
        'name': '省区市纪委派驻纪检组',
        'parentId': '585'
      },
      {
        'code': 'handledept_594',
        'id': '594',
        'name': '地市州盟纪委派驻纪检组',
        'parentId': '585'
      },
      {
        'code': 'handledept_595',
        'id': '595',
        'name': '县市区旗纪委派驻纪检组',
        'parentId': '585'
      },
      {
        'code': 'handledept_596',
        'id': '596',
        'name': '企业单位纪检机构',
        'parentId': '585'
      },
      {
        'code': 'handledept_597',
        'id': '597',
        'name': '事业单位纪检机构',
        'parentId': '585'
      },
      {
        'code': 'handledept_598',
        'id': '598',
        'name': '其他',
        'parentId': '585'
      },
      {
        'code': 'handledept_1503',
        'id': '1503',
        'name': '机关纪委',
        'parentId': '585'
      }
    ],
    'code': 'handledept',
    'id': '585',
    'name': '纪委立案机关',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'beleader_600',
        'id': '600',
        'name': '查处时任一把手',
        'parentId': '599'
      },
      {
        'code': 'beleader_601',
        'id': '601',
        'name': '违纪违法时任一把手',
        'parentId': '599'
      },
      {
        'code': 'beleader_602',
        'id': '602',
        'name': '查处时违纪违法时均任一把手',
        'parentId': '599'
      },
      {
        'code': 'beleader_1650',
        'id': '1650',
        'name': '否',
        'parentId': '599'
      }
    ],
    'code': 'beleader',
    'id': '599',
    'name': '一把手违纪',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'leaderdetail_604',
        'id': '604',
        'name': '中央',
        'parentId': '603'
      },
      {
        'code': 'leaderdetail_605',
        'id': '605',
        'name': '省区市',
        'parentId': '603'
      },
      {
        'code': 'leaderdetail_606',
        'id': '606',
        'name': '地市州',
        'parentId': '603'
      },
      {
        'code': 'leaderdetail_607',
        'id': '607',
        'name': '县市区',
        'parentId': '603'
      },
      {
        'code': 'leaderdetail_608',
        'id': '608',
        'name': '乡镇',
        'parentId': '603'
      }
    ],
    'code': 'leaderdetail',
    'id': '603',
    'name': '一把手细节',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'leaderdetail1_610',
        'id': '610',
        'name': '党委',
        'parentId': '609'
      },
      {
        'code': 'leaderdetail1_611',
        'id': '611',
        'name': '党委所属部委办局',
        'parentId': '609'
      },
      {
        'code': 'leaderdetail1_612',
        'id': '612',
        'name': '政府',
        'parentId': '609'
      },
      {
        'code': 'leaderdetail1_613',
        'id': '613',
        'name': '政府所属部委办局',
        'parentId': '609'
      }
    ],
    'code': 'leaderdetail1',
    'id': '609',
    'name': '一把手细节二',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'specstat_615',
        'id': '615',
        'name': '商业贿赂',
        'parentId': '614'
      },
      {
        'code': 'specstat_616',
        'id': '616',
        'name': '土地征用',
        'parentId': '614'
      },
      {
        'code': 'specstat_617',
        'id': '617',
        'name': '房屋拆迁',
        'parentId': '614'
      },
      {
        'code': 'specstat_618',
        'id': '618',
        'name': '企业改制、破产',
        'parentId': '614'
      },
      {
        'code': 'specstat_619',
        'id': '619',
        'name': '买官卖官',
        'parentId': '614'
      },
      {
        'code': 'specstat_620',
        'id': '620',
        'name': '拉票贿选',
        'parentId': '614'
      },
      {
        'code': 'specstat_621',
        'id': '621',
        'name': '生活作风问题',
        'parentId': '614'
      },
      {
        'code': 'specstat_622',
        'id': '622',
        'name': '官商勾结',
        'parentId': '614'
      },
      {
        'code': 'specstat_623',
        'id': '623',
        'name': '工程建设领域',
        'parentId': '614'
      },
      {
        'code': 'specstat_624',
        'id': '624',
        'name': '提出问责建议',
        'parentId': '614'
      },
      {
        'code': 'specstat_625',
        'id': '625',
        'name': '设立小金库和使用小金库款项案件',
        'parentId': '614'
      },
      {
        'code': 'specstat_626',
        'id': '626',
        'name': '重大责任事故涉及的失职渎职和背后的腐败问题',
        'parentId': '614'
      },
      {
        'code': 'specstat_627',
        'id': '627',
        'name': '群体性事件涉及的失职渎职和背后的腐败问题',
        'parentId': '614'
      },
      {
        'code': 'specstat_1289',
        'id': '1289',
        'name': '类别一',
        'parentId': '614'
      },
      {
        'code': 'specstat_1290',
        'id': '1290',
        'name': '类别二',
        'parentId': '614'
      },
      {
        'code': 'specstat_1291',
        'id': '1291',
        'name': '类别三',
        'parentId': '614'
      },
      {
        'code': 'specstat_1292',
        'id': '1292',
        'name': '类别四',
        'parentId': '614'
      },
      {
        'code': 'specstat_1293',
        'id': '1293',
        'name': '类别五',
        'parentId': '614'
      }
    ],
    'code': 'specstat',
    'id': '614',
    'name': '专项统计',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'integritypoint_637',
            'id': '637',
            'name': '索取接受或以借为名占用财物',
            'parentId': '629'
          },
          {
            'code': 'integritypoint_638',
            'id': '638',
            'name': '接受可能影响公正执行公务的礼品宴请以及活动安排',
            'parentId': '629'
          },
          {
            'code': 'integritypoint_639',
            'id': '639',
            'name': '在公务活动中接受礼金和各种有价证券支付凭证',
            'parentId': '629'
          },
          {
            'code': 'integritypoint_640',
            'id': '640',
            'name': '以交易委托理财等形式谋取不正当利益',
            'parentId': '629'
          },
          {
            'code': 'integritypoint_641',
            'id': '641',
            'name': '利用知悉或者掌握的内幕信息谋取利益',
            'parentId': '629'
          },
          {
            'code': 'integritypoint_642',
            'id': '642',
            'name': '违规多占住房或者买卖保障性住房',
            'parentId': '629'
          }
        ],
        'code': 'integritypoint_629',
        'id': '629',
        'name': '利用职权和职务上的影响谋取不正当利益',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_643',
            'id': '643',
            'name': '个人或者借他人名义经商办企业',
            'parentId': '630'
          },
          {
            'code': 'integritypoint_644',
            'id': '644',
            'name': '违规拥有非上市公司（企业）的股份或者证券',
            'parentId': '630'
          },
          {
            'code': 'integritypoint_645',
            'id': '645',
            'name': '违规买卖股票或者进行其他证券投资',
            'parentId': '630'
          },
          {
            'code': 'integritypoint_646',
            'id': '646',
            'name': '个人在国（境）外注册公司或者投资入股',
            'parentId': '630'
          },
          {
            'code': 'integritypoint_647',
            'id': '647',
            'name': '违规兼职或者兼职取酬以及从事有偿中介活动',
            'parentId': '630'
          },
          {
            'code': 'integritypoint_648',
            'id': '648',
            'name': '离职或者退休后违规从事营利性活动',
            'parentId': '630'
          }
        ],
        'code': 'integritypoint_630',
        'id': '630',
        'name': '私自从事营利性活动',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_649',
            'id': '649',
            'name': '用公款报销或者支付应由个人负担的费用',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_650',
            'id': '650',
            'name': '违规借用公款公物或者将公款公物借给他人',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_651',
            'id': '651',
            'name': '私存私放公款',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_652',
            'id': '652',
            'name': '用公款旅游或者变相用公款旅游',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_653',
            'id': '653',
            'name': '用公款参与高消费娱乐健身活动和获取俱乐部会员资格',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_654',
            'id': '654',
            'name': '违规用公款购买商业保险缴纳住房公积金滥发津贴补贴奖金等',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_655',
            'id': '655',
            'name': '非法占有公共财物',
            'parentId': '631'
          },
          {
            'code': 'integritypoint_656',
            'id': '656',
            'name': '挪用或者拆借公共资金或者其他财政资金',
            'parentId': '631'
          }
        ],
        'code': 'integritypoint_631',
        'id': '631',
        'name': '违反公共财物管理和使用的规定假公济私化公为私',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_657',
            'id': '657',
            'name': '采取不正当手段为本人或者他人谋取职位',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_658',
            'id': '658',
            'name': '不按照规定程序推荐考察酝酿讨论决定任免干部',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_659',
            'id': '659',
            'name': '私自泄露民主推荐民主测评考察酝酿讨论决定干部等有关情况',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_660',
            'id': '660',
            'name': '在干部考察工作中隐瞒或者歪曲事实真相',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_661',
            'id': '661',
            'name': '在民主推荐民主测评组织考察和选举中搞拉票等非组织活动',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_662',
            'id': '662',
            'name': '利用职务便利私自干预下级或者原任职地区单位干部选拔任用工作',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_663',
            'id': '663',
            'name': '在工作调动机构变动时突击提拔调整干部',
            'parentId': '632'
          },
          {
            'code': 'integritypoint_664',
            'id': '664',
            'name': '在干部选拔任用工作中封官许愿任人唯亲营私舞弊',
            'parentId': '632'
          }
        ],
        'code': 'integritypoint_632',
        'id': '632',
        'name': '违反规定选拔任用干部',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_665',
            'id': '665',
            'name': '要求或者指使提拔亲属及身边工作人员',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_666',
            'id': '666',
            'name': '用公款支付亲属学习等费用或为亲属索取资助',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_667',
            'id': '667',
            'name': '妨碍涉及亲属及身边工作人员案件的调查处理',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_668',
            'id': '668',
            'name': '利用职务之便为他人谋利其亲属以及其他特定关系人收受对方财物',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_669',
            'id': '669',
            'name': '默许纵容授意亲属及身边工作人员以本人名义谋取私利',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_670',
            'id': '670',
            'name': '为亲属或相互为对方亲属经商办企业提供便利条件',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_671',
            'id': '671',
            'name': '允许纵容亲属在本人管辖范围内违规从事经营活动等',
            'parentId': '633'
          },
          {
            'code': 'integritypoint_672',
            'id': '672',
            'name': '允许纵容亲属在异地工商注册登记后到本人管辖范围内违规从事经营活动',
            'parentId': '633'
          }
        ],
        'code': 'integritypoint_633',
        'id': '633',
        'name': '利用职权和职务上的影响为亲属及身边工作人员谋取利益',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_673',
            'id': '673',
            'name': '提供或者接受超标接待或者超标报销相关费用',
            'parentId': '634'
          },
          {
            'code': 'integritypoint_674',
            'id': '674',
            'name': '违规兴建装修楼堂馆所或超标配备使用办公用房和办公用品',
            'parentId': '634'
          },
          {
            'code': 'integritypoint_675',
            'id': '675',
            'name': '擅自用公款包租占用客房供个人使用',
            'parentId': '634'
          },
          {
            'code': 'integritypoint_676',
            'id': '676',
            'name': '违规配备购买更换装饰或者使用小汽车',
            'parentId': '634'
          },
          {
            'code': 'integritypoint_677',
            'id': '677',
            'name': '违规举办各类庆典活动',
            'parentId': '634'
          }
        ],
        'code': 'integritypoint_634',
        'id': '634',
        'name': '讲排场比阔气挥霍公款铺张浪费',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_678',
            'id': '678',
            'name': '干预和插手建设工程项目承发包等市场经济活动',
            'parentId': '635'
          },
          {
            'code': 'integritypoint_679',
            'id': '679',
            'name': '干预和插手国有企业重组改制等事项',
            'parentId': '635'
          },
          {
            'code': 'integritypoint_680',
            'id': '680',
            'name': '干预和插手批办各类行政许可和资金借贷等事项',
            'parentId': '635'
          },
          {
            'code': 'integritypoint_681',
            'id': '681',
            'name': '干预和插手经济纠纷',
            'parentId': '635'
          },
          {
            'code': 'integritypoint_682',
            'id': '682',
            'name': '干预和插手农村集体三资使用分配承包租赁等事项',
            'parentId': '635'
          }
        ],
        'code': 'integritypoint_635',
        'id': '635',
        'name': '干预和插手建设工程项目承发包等市场经济活动',
        'parentId': '628'
      },
      {
        'children': [
          {
            'code': 'integritypoint_683',
            'id': '683',
            'name': '搞形象工程和政绩工程',
            'parentId': '636'
          },
          {
            'code': 'integritypoint_684',
            'id': '684',
            'name': '虚报工作业绩',
            'parentId': '636'
          },
          {
            'code': 'integritypoint_685',
            'id': '685',
            'name': '大办婚丧喜庆事宜或者借机敛财',
            'parentId': '636'
          },
          {
            'code': 'integritypoint_686',
            'id': '686',
            'name': '在社会保障等事项中优亲厚友显失公平',
            'parentId': '636'
          },
          {
            'code': 'integritypoint_687',
            'id': '687',
            'name': '以不正当手段获取荣誉职称学历学位等利益',
            'parentId': '636'
          },
          {
            'code': 'integritypoint_688',
            'id': '688',
            'name': '从事有悖社会公德职业道德家庭美德的活动',
            'parentId': '636'
          }
        ],
        'code': 'integritypoint_636',
        'id': '636',
        'name': '脱离实际弄虚作假损害群众利益和党群干群关系',
        'parentId': '628'
      }
    ],
    'code': 'integritypoint',
    'id': '628',
    'name': '违反廉洁从政行为规范',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'enterpriserank_690',
        'id': '690',
        'name': '一级企业',
        'parentId': '689'
      },
      {
        'code': 'enterpriserank_691',
        'id': '691',
        'name': '二级企业',
        'parentId': '689'
      },
      {
        'code': 'enterpriserank_692',
        'id': '692',
        'name': '三级企业',
        'parentId': '689'
      },
      {
        'code': 'enterpriserank_693',
        'id': '693',
        'name': '其他企业',
        'parentId': '689'
      }
    ],
    'code': 'enterpriserank',
    'id': '689',
    'name': '企业级别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'combriberyfield_695',
        'id': '695',
        'name': '工程建设',
        'parentId': '694'
      },
      {
        'code': 'combriberyfield_696',
        'id': '696',
        'name': '土地出让',
        'parentId': '694'
      },
      {
        'code': 'combriberyfield_697',
        'id': '697',
        'name': '产权交易',
        'parentId': '694'
      },
      {
        'code': 'combriberyfield_698',
        'id': '698',
        'name': '政府采购',
        'parentId': '694'
      },
      {
        'code': 'combriberyfield_699',
        'id': '699',
        'name': '医药购销',
        'parentId': '694'
      },
      {
        'code': 'combriberyfield_700',
        'id': '700',
        'name': '资源开发和经销',
        'parentId': '694'
      },
      {
        'code': 'combriberyfield_701',
        'id': '701',
        'name': '其他',
        'parentId': '694'
      }
    ],
    'code': 'combriberyfield',
    'id': '694',
    'name': '商业贿赂涉及领域',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'elopetrace_703',
        'id': '703',
        'name': '国（境）内',
        'parentId': '702'
      },
      {
        'code': 'elopetrace_704',
        'id': '704',
        'name': '国（境）外',
        'parentId': '702'
      },
      {
        'code': 'elopetrace_705',
        'id': '705',
        'name': '去向不明',
        'parentId': '702'
      }
    ],
    'code': 'elopetrace',
    'id': '702',
    'name': '潜逃去向',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'sjje_707',
        'id': '707',
        'name': '500万元-1000万元',
        'parentId': '706'
      },
      {
        'code': 'sjje_708',
        'id': '708',
        'name': '1000万元-1亿元',
        'parentId': '706'
      },
      {
        'code': 'sjje_709',
        'id': '709',
        'name': '1亿元以上',
        'parentId': '706'
      },
      {
        'code': 'sjje_710',
        'id': '710',
        'name': '10万元-50万元',
        'parentId': '706'
      },
      {
        'code': 'sjje_711',
        'id': '711',
        'name': '50万元-100万元',
        'parentId': '706'
      },
      {
        'code': 'sjje_712',
        'id': '712',
        'name': '100万元-500万元',
        'parentId': '706'
      },
      {
        'code': 'sjje_713',
        'id': '713',
        'name': '1万元以下',
        'parentId': '706'
      },
      {
        'code': 'sjje_714',
        'id': '714',
        'name': '1万元-10万元',
        'parentId': '706'
      }
    ],
    'code': 'sjje',
    'id': '706',
    'name': '涉及金额分段',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'agef_716',
        'id': '716',
        'name': '30岁以下',
        'parentId': '715'
      },
      {
        'code': 'agef_717',
        'id': '717',
        'name': '31岁-45岁',
        'parentId': '715'
      },
      {
        'code': 'agef_718',
        'id': '718',
        'name': '46岁-54岁',
        'parentId': '715'
      },
      {
        'code': 'agef_719',
        'id': '719',
        'name': '55岁-59岁',
        'parentId': '715'
      },
      {
        'code': 'agef_720',
        'id': '720',
        'name': '60岁以上',
        'parentId': '715'
      }
    ],
    'code': 'agef',
    'id': '715',
    'name': '年龄分段',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'clueparty_722',
        'id': '722',
        'name': '中共党员',
        'parentId': '721'
      },
      {
        'code': 'clueparty_723',
        'id': '723',
        'name': '共青团员',
        'parentId': '721'
      },
      {
        'children': [
          {
            'code': 'clueparty_728',
            'id': '728',
            'name': '民革',
            'parentId': '724'
          },
          {
            'code': 'clueparty_729',
            'id': '729',
            'name': '民盟',
            'parentId': '724'
          },
          {
            'code': 'clueparty_730',
            'id': '730',
            'name': '民建',
            'parentId': '724'
          },
          {
            'code': 'clueparty_731',
            'id': '731',
            'name': '民进',
            'parentId': '724'
          },
          {
            'code': 'clueparty_732',
            'id': '732',
            'name': '农工党',
            'parentId': '724'
          },
          {
            'code': 'clueparty_733',
            'id': '733',
            'name': '致公党',
            'parentId': '724'
          },
          {
            'code': 'clueparty_734',
            'id': '734',
            'name': '九三学社',
            'parentId': '724'
          },
          {
            'code': 'clueparty_735',
            'id': '735',
            'name': '台盟',
            'parentId': '724'
          }
        ],
        'code': 'clueparty_724',
        'id': '724',
        'name': '民主党派',
        'parentId': '721'
      },
      {
        'code': 'clueparty_725',
        'id': '725',
        'name': '党组织',
        'parentId': '721'
      },
      {
        'code': 'clueparty_726',
        'id': '726',
        'name': '法人',
        'parentId': '721'
      },
      {
        'code': 'clueparty_727',
        'id': '727',
        'name': '其他',
        'parentId': '721'
      }
    ],
    'code': 'clueparty',
    'id': '721',
    'name': '政治面貌（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'cluerank_737',
        'id': '737',
        'name': '正省部级',
        'parentId': '736'
      },
      {
        'code': 'cluerank_738',
        'id': '738',
        'name': '副省部级',
        'parentId': '736'
      },
      {
        'code': 'cluerank_739',
        'id': '739',
        'name': '正地厅级',
        'parentId': '736'
      },
      {
        'code': 'cluerank_740',
        'id': '740',
        'name': '副地厅级',
        'parentId': '736'
      },
      {
        'code': 'cluerank_741',
        'id': '741',
        'name': '县处级',
        'parentId': '736'
      },
      {
        'code': 'cluerank_742',
        'id': '742',
        'name': '乡科级',
        'parentId': '736'
      },
      {
        'code': 'cluerank_743',
        'id': '743',
        'name': '一般干部',
        'parentId': '736'
      },
      {
        'code': 'cluerank_744',
        'id': '744',
        'name': '其他',
        'parentId': '736'
      },
      {
        'code': 'cluerank_898',
        'id': '898',
        'name': '省部级以上',
        'parentId': '736'
      }
    ],
    'code': 'cluerank',
    'id': '736',
    'name': '职级（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'children': [
              {
                'code': 'transacmode_964',
                'id': '964',
                'name': '发函请作情况说明',
                'parentId': '963'
              },
              {
                'code': 'transacmode_965',
                'id': '965',
                'name': '分管领导或室领导与其谈话',
                'parentId': '963'
              },
              {
                'code': 'transacmode_966',
                'id': '966',
                'name': '请党委主要负责人与其谈话',
                'parentId': '963'
              },
              {
                'code': 'transacmode_967',
                'id': '967',
                'name': '委托下级纪检监察机关谈话',
                'parentId': '963'
              }
            ],
            'code': 'transacmode_963',
            'id': '963',
            'name': '谈话函询',
            'parentId': '746'
          },
          {
            'children': [
              {
                'code': 'transacmode_869',
                'id': '869',
                'name': '直接核实',
                'parentId': '865'
              },
              {
                'code': 'transacmode_870',
                'id': '870',
                'name': '侧面了解',
                'parentId': '865'
              },
              {
                'code': 'transacmode_871',
                'id': '871',
                'name': '发函请被反映人本人作情况说明',
                'parentId': '865'
              },
              {
                'code': 'transacmode_872',
                'id': '872',
                'name': '请所在地方或者部门党委主要负责人与其谈话',
                'parentId': '865'
              },
              {
                'code': 'transacmode_873',
                'id': '873',
                'name': '委托下级纪检检查机关了解',
                'parentId': '865'
              },
              {
                'code': 'transacmode_874',
                'id': '874',
                'name': '其他方式',
                'parentId': '865'
              },
              {
                'code': 'transacmode_881',
                'id': '881',
                'name': '分管领导直接或委托有关室领导与被反映人谈话',
                'parentId': '865'
              },
              {
                'code': 'transacmode_962',
                'id': '962',
                'name': '委托了解和查询等',
                'parentId': '865'
              }
            ],
            'code': 'transacmode_865',
            'id': '865',
            'name': '初步核实',
            'parentId': '746'
          },
          {
            'children': [
              {
                'code': 'transacmode_968',
                'id': '968',
                'name': '因时机等因素不便马上核查',
                'parentId': '866'
              },
              {
                'code': 'transacmode_969',
                'id': '969',
                'name': '重要涉案人一时难以找到',
                'parentId': '866'
              },
              {
                'code': 'transacmode_970',
                'id': '970',
                'name': '曾初核或谈话函询尚不能否定问题存在',
                'parentId': '866'
              },
              {
                'code': 'transacmode_971',
                'id': '971',
                'name': '被反映人年龄过大',
                'parentId': '866'
              },
              {
                'code': 'transacmode_972',
                'id': '972',
                'name': '问题久远且没有新问题举报',
                'parentId': '866'
              },
              {
                'code': 'transacmode_975',
                'id': '975',
                'name': '其他',
                'parentId': '866'
              }
            ],
            'code': 'transacmode_866',
            'id': '866',
            'name': '暂存',
            'parentId': '746'
          },
          {
            'children': [
              {
                'code': 'transacmode_882',
                'id': '882',
                'name': '经过初核失实',
                'parentId': '868'
              },
              {
                'children': [
                  {
                    'code': 'transacmode_885',
                    'id': '885',
                    'name': '通报（通报批评）',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_886',
                    'id': '886',
                    'name': '解聘',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_887',
                    'id': '887',
                    'name': '辞退',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_888',
                    'id': '888',
                    'name': '调整（调离）职务（岗位）',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_889',
                    'id': '889',
                    'name': '免职',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_890',
                    'id': '890',
                    'name': '取消预备党员资格',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_892',
                    'id': '892',
                    'name': '诫勉（诫勉谈话）',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_893',
                    'id': '893',
                    'name': '停职（停职检查）',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_894',
                    'id': '894',
                    'name': '责令公开道歉（检讨）',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_895',
                    'id': '895',
                    'name': '引咎辞职',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_896',
                    'id': '896',
                    'name': '责令辞职',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_897',
                    'id': '897',
                    'name': '其它批评教育类措施',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1223',
                    'id': '1223',
                    'name': '终止党代表资格',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1224',
                    'id': '1224',
                    'name': '终止（罢免、撤销、责令辞去）人大代表资格',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1225',
                    'id': '1225',
                    'name': '撤销政协委员资格',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1226',
                    'id': '1226',
                    'name': '取消（罢免）当选资格',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1227',
                    'id': '1227',
                    'name': '安排提前退休',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1228',
                    'id': '1228',
                    'name': '改任非领导职务',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1229',
                    'id': '1229',
                    'name': '纠正或责令停止违纪行为',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1230',
                    'id': '1230',
                    'name': '责成退出违纪所得',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1231',
                    'id': '1231',
                    'name': '批评教育',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1232',
                    'id': '1232',
                    'name': '提醒谈话',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1233',
                    'id': '1233',
                    'name': '警示谈话',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1234',
                    'id': '1234',
                    'name': '召开民主生活会批评帮助',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1235',
                    'id': '1235',
                    'name': '责令作出口头或书面检查',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1236',
                    'id': '1236',
                    'name': '限期整改',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1237',
                    'id': '1237',
                    'name': '取消荣誉称号',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1299',
                    'id': '1299',
                    'name': '降职',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1300',
                    'id': '1300',
                    'name': '其它重大职务调整类措施',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1301',
                    'id': '1301',
                    'name': '组织除名（劝退）',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1302',
                    'id': '1302',
                    'name': '解除劳动合同',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1303',
                    'id': '1303',
                    'name': '降低退休待遇',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1304',
                    'id': '1304',
                    'name': '取消退休待遇',
                    'parentId': '883'
                  },
                  {
                    'code': 'transacmode_1305',
                    'id': '1305',
                    'name': '其它组织调整类措施',
                    'parentId': '883'
                  }
                ],
                'code': 'transacmode_883',
                'id': '883',
                'name': '适当处理',
                'parentId': '868'
              },
              {
                'code': 'transacmode_884',
                'id': '884',
                'name': '其他',
                'parentId': '868'
              },
              {
                'code': 'transacmode_973',
                'id': '973',
                'name': '经过谈话函询被反映人问题未能认定',
                'parentId': '868'
              },
              {
                'code': 'transacmode_974',
                'id': '974',
                'name': '被反映人已离休或去世',
                'parentId': '868'
              }
            ],
            'code': 'transacmode_868',
            'id': '868',
            'name': '了结',
            'parentId': '746'
          },
          {
            'children': [
              {
                'code': 'transacmode_879',
                'id': '879',
                'name': '本级立案',
                'parentId': '864'
              },
              {
                'code': 'transacmode_880',
                'id': '880',
                'name': '转下级立案',
                'parentId': '864'
              }
            ],
            'code': 'transacmode_864',
            'id': '864',
            'name': '拟立案',
            'parentId': '746'
          },
          {
            'code': 'transacmode_891',
            'id': '891',
            'name': '不立案',
            'parentId': '746'
          }
        ],
        'code': 'transacmode_746',
        'id': '746',
        'name': '本委办理',
        'parentId': '745'
      },
      {
        'code': 'transacmode_747',
        'id': '747',
        'name': '协办',
        'parentId': '745'
      },
      {
        'children': [
          {
            'code': 'transacmode_753',
            'id': '753',
            'name': '转办要结果件',
            'parentId': '748'
          },
          {
            'code': 'transacmode_754',
            'id': '754',
            'name': '转办不要结果件',
            'parentId': '748'
          },
          {
            'code': 'transacmode_755',
            'id': '755',
            'name': '转办其他',
            'parentId': '748'
          }
        ],
        'code': 'transacmode_748',
        'id': '748',
        'name': '转下级办理',
        'parentId': '745'
      }
    ],
    'code': 'transacmode',
    'id': '745',
    'name': '办理方式',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'reportkind_757',
        'id': '757',
        'name': '匿名举报',
        'parentId': '756'
      },
      {
        'code': 'reportkind_758',
        'id': '758',
        'name': '实名举报',
        'parentId': '756'
      }
    ],
    'code': 'reportkind',
    'id': '756',
    'name': '举报类型（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'reportmode_760',
        'id': '760',
        'name': '来信',
        'parentId': '759'
      },
      {
        'code': 'reportmode_761',
        'id': '761',
        'name': '来电',
        'parentId': '759'
      },
      {
        'code': 'reportmode_762',
        'id': '762',
        'name': '来访',
        'parentId': '759'
      },
      {
        'code': 'reportmode_763',
        'id': '763',
        'name': '网络举报',
        'parentId': '759'
      },
      {
        'code': 'reportmode_764',
        'id': '764',
        'name': '其他',
        'parentId': '759'
      }
    ],
    'code': 'reportmode',
    'id': '759',
    'name': '举报方式（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'dealresult_766',
        'id': '766',
        'name': '暂无',
        'parentId': '765'
      },
      {
        'code': 'dealresult_767',
        'id': '767',
        'name': '了结',
        'parentId': '765'
      },
      {
        'code': 'dealresult_768',
        'id': '768',
        'name': '转立案',
        'parentId': '765'
      },
      {
        'code': 'dealresult_769',
        'id': '769',
        'name': '其他',
        'parentId': '765'
      }
    ],
    'code': 'dealresult',
    'id': '765',
    'name': '办理结果（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'clueconclusion_771',
        'id': '771',
        'name': '失实',
        'parentId': '770'
      },
      {
        'code': 'clueconclusion_772',
        'id': '772',
        'name': '属实',
        'parentId': '770'
      }
    ],
    'code': 'clueconclusion',
    'id': '770',
    'name': '了结结论（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'clueorigin_774',
        'id': '774',
        'name': '信访举报',
        'parentId': '773'
      },
      {
        'code': 'clueorigin_775',
        'id': '775',
        'name': '纪律审查中发现',
        'parentId': '773'
      },
      {
        'code': 'clueorigin_776',
        'id': '776',
        'name': '巡视中发现',
        'parentId': '773'
      },
      {
        'code': 'clueorigin_777',
        'id': '777',
        'name': '执法，纠风等工作中发现',
        'parentId': '773'
      },
      {
        'code': 'clueorigin_778',
        'id': '778',
        'name': '公检法等机关移送',
        'parentId': '773'
      },
      {
        'code': 'clueorigin_779',
        'id': '779',
        'name': '审计中发现',
        'parentId': '773'
      },
      {
        'code': 'clueorigin_780',
        'id': '780',
        'name': '其他',
        'parentId': '773'
      }
    ],
    'code': 'clueorigin',
    'id': '773',
    'name': '线索来源（线索用）',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'tryunit_782',
        'id': '782',
        'name': '中央纪委监察部',
        'parentId': '781'
      },
      {
        'code': 'tryunit_783',
        'id': '783',
        'name': '省区市纪委监察厅局',
        'parentId': '781'
      },
      {
        'code': 'tryunit_784',
        'id': '784',
        'name': '地市州纪委监察局',
        'parentId': '781'
      },
      {
        'code': 'tryunit_785',
        'id': '785',
        'name': '县市区纪委监察局',
        'parentId': '781'
      },
      {
        'code': 'tryunit_786',
        'id': '786',
        'name': '乡镇街道纪（工）委',
        'parentId': '781'
      },
      {
        'code': 'tryunit_787',
        'id': '787',
        'name': '军队纪委',
        'parentId': '781'
      },
      {
        'code': 'tryunit_788',
        'id': '788',
        'name': '中央纪委派驻纪检组',
        'parentId': '781'
      },
      {
        'code': 'tryunit_789',
        'id': '789',
        'name': '省区市纪委派驻纪检组',
        'parentId': '781'
      },
      {
        'code': 'tryunit_790',
        'id': '790',
        'name': '地市州纪委派驻纪检组',
        'parentId': '781'
      },
      {
        'code': 'tryunit_791',
        'id': '791',
        'name': '县市区纪委派驻纪检组',
        'parentId': '781'
      },
      {
        'code': 'tryunit_792',
        'id': '792',
        'name': '企业单位纪检监察机构',
        'parentId': '781'
      },
      {
        'code': 'tryunit_793',
        'id': '793',
        'name': '事业单位纪检监察机构',
        'parentId': '781'
      },
      {
        'code': 'tryunit_794',
        'id': '794',
        'name': '其他',
        'parentId': '781'
      }
    ],
    'code': 'tryunit',
    'id': '781',
    'name': '审理机关',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'exeunit_796',
        'id': '796',
        'name': '中央纪委监察部',
        'parentId': '795'
      },
      {
        'code': 'exeunit_797',
        'id': '797',
        'name': '省区市纪委监察厅局',
        'parentId': '795'
      },
      {
        'code': 'exeunit_798',
        'id': '798',
        'name': '地市州纪委监察局',
        'parentId': '795'
      },
      {
        'code': 'exeunit_799',
        'id': '799',
        'name': '县市区纪委监察局',
        'parentId': '795'
      },
      {
        'code': 'exeunit_800',
        'id': '800',
        'name': '乡镇街道纪（工）委',
        'parentId': '795'
      },
      {
        'code': 'exeunit_801',
        'id': '801',
        'name': '军队纪委',
        'parentId': '795'
      },
      {
        'code': 'exeunit_802',
        'id': '802',
        'name': '中央纪委派驻纪检组',
        'parentId': '795'
      },
      {
        'code': 'exeunit_803',
        'id': '803',
        'name': '省区市纪委派驻纪检组',
        'parentId': '795'
      },
      {
        'code': 'exeunit_804',
        'id': '804',
        'name': '地市州纪委派驻纪检组',
        'parentId': '795'
      },
      {
        'code': 'exeunit_805',
        'id': '805',
        'name': '县市区纪委派驻纪检组',
        'parentId': '795'
      },
      {
        'code': 'exeunit_806',
        'id': '806',
        'name': '企业单位纪检监察机构',
        'parentId': '795'
      },
      {
        'code': 'exeunit_807',
        'id': '807',
        'name': '事业单位纪检监察机构',
        'parentId': '795'
      },
      {
        'code': 'exeunit_808',
        'id': '808',
        'name': '其他',
        'parentId': '795'
      }
    ],
    'code': 'exeunit',
    'id': '795',
    'name': '实施机关',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'sex_810',
        'id': '810',
        'name': '男',
        'parentId': '809'
      },
      {
        'code': 'sex_811',
        'id': '811',
        'name': '女',
        'parentId': '809'
      },
      {
        'code': 'sex_812',
        'id': '812',
        'name': '不详',
        'parentId': '809'
      }
    ],
    'code': 'sex',
    'id': '809',
    'name': '性别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'ldckyear_815',
        'id': '815',
        'name': '一年',
        'parentId': '814'
      },
      {
        'code': 'ldckyear_816',
        'id': '816',
        'name': '两年',
        'parentId': '814'
      }
    ],
    'code': 'ldckyear',
    'id': '814',
    'name': '留党察看年限',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'rwlx_818',
        'id': '818',
        'name': '一次性报送',
        'parentId': '817'
      },
      {
        'code': 'rwlx_819',
        'id': '819',
        'name': '月报',
        'parentId': '817'
      },
      {
        'code': 'rwlx_820',
        'id': '820',
        'name': '季报',
        'parentId': '817'
      },
      {
        'code': 'rwlx_821',
        'id': '821',
        'name': '年报',
        'parentId': '817'
      }
    ],
    'code': 'rwlx',
    'id': '817',
    'name': '专项报送任务分类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'auditstate_823',
        'id': '823',
        'name': '未审核',
        'parentId': '822'
      },
      {
        'code': 'auditstate_824',
        'id': '824',
        'name': '审核中',
        'parentId': '822'
      },
      {
        'code': 'auditstate_825',
        'id': '825',
        'name': '已审核',
        'parentId': '822'
      },
      {
        'code': 'auditstate_826',
        'id': '826',
        'name': '撤销审核',
        'parentId': '822'
      },
      {
        'code': 'auditstate_827',
        'id': '827',
        'name': '已锁定',
        'parentId': '822'
      },
      {
        'code': 'auditstate_828',
        'id': '828',
        'name': '已退回',
        'parentId': '822'
      },
      {
        'code': 'auditstate_829',
        'id': '829',
        'name': '已修改',
        'parentId': '822'
      },
      {
        'code': 'auditstate_830',
        'id': '830',
        'name': '已删除',
        'parentId': '822'
      },
      {
        'code': 'auditstate_847',
        'id': '847',
        'name': '已修改待审核',
        'parentId': '822'
      }
    ],
    'code': 'auditstate',
    'id': '822',
    'name': '数据审核状态',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'taskstate_832',
        'id': '832',
        'name': '删除',
        'parentId': '831'
      },
      {
        'code': 'taskstate_833',
        'id': '833',
        'name': '未发布',
        'parentId': '831'
      },
      {
        'code': 'taskstate_834',
        'id': '834',
        'name': '已发布',
        'parentId': '831'
      },
      {
        'code': 'taskstate_835',
        'id': '835',
        'name': '已撤销',
        'parentId': '831'
      },
      {
        'code': 'taskstate_836',
        'id': '836',
        'name': '未接收',
        'parentId': '831'
      },
      {
        'code': 'taskstate_837',
        'id': '837',
        'name': '已接收',
        'parentId': '831'
      },
      {
        'code': 'taskstate_838',
        'id': '838',
        'name': '未上报',
        'parentId': '831'
      },
      {
        'code': 'taskstate_839',
        'id': '839',
        'name': '已上报',
        'parentId': '831'
      },
      {
        'code': 'taskstate_840',
        'id': '840',
        'name': '未转发',
        'parentId': '831'
      },
      {
        'code': 'taskstate_841',
        'id': '841',
        'name': '已转发',
        'parentId': '831'
      },
      {
        'code': 'taskstate_842',
        'id': '842',
        'name': '未汇总',
        'parentId': '831'
      },
      {
        'code': 'taskstate_843',
        'id': '843',
        'name': '已汇总',
        'parentId': '831'
      },
      {
        'code': 'taskstate_844',
        'id': '844',
        'name': '未录入',
        'parentId': '831'
      },
      {
        'code': 'taskstate_845',
        'id': '845',
        'name': '已录入',
        'parentId': '831'
      },
      {
        'code': 'taskstate_846',
        'id': '846',
        'name': '无名单',
        'parentId': '831'
      }
    ],
    'code': 'taskstate',
    'id': '831',
    'name': '专项报送任务状态',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'saxx_876',
        'id': '876',
        'name': '行贿人',
        'parentId': '875'
      },
      {
        'code': 'saxx_877',
        'id': '877',
        'name': '经手人',
        'parentId': '875'
      },
      {
        'code': 'saxx_878',
        'id': '878',
        'name': '参与人',
        'parentId': '875'
      }
    ],
    'code': 'saxx',
    'id': '875',
    'name': '涉案信息',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'dutyType_900',
        'id': '900',
        'name': '纪委书记',
        'parentId': '899'
      },
      {
        'code': 'dutyType_901',
        'id': '901',
        'name': '监察机关正职',
        'parentId': '899'
      },
      {
        'code': 'dutyType_902',
        'id': '902',
        'name': '纪检监察机关副职',
        'parentId': '899'
      },
      {
        'code': 'dutyType_903',
        'id': '903',
        'name': '纪检组长',
        'parentId': '899'
      },
      {
        'code': 'dutyType_904',
        'id': '904',
        'name': '纪检组副组长(监察室主任)',
        'parentId': '899'
      },
      {
        'code': 'dutyType_905',
        'id': '905',
        'name': '纪检监察机关内设机构正副职',
        'parentId': '899'
      },
      {
        'code': 'dutyType_906',
        'id': '906',
        'name': '其他',
        'parentId': '899'
      }
    ],
    'code': 'dutyType',
    'id': '899',
    'name': '职务类型',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'children': [
              {
                'code': 'workPostType_915',
                'id': '915',
                'name': '中央纪委监察部',
                'parentId': '912'
              },
              {
                'code': 'workPostType_916',
                'id': '916',
                'name': '省区市纪委监察厅局',
                'parentId': '912'
              },
              {
                'code': 'workPostType_917',
                'id': '917',
                'name': '地市州盟纪检监察机关',
                'parentId': '912'
              },
              {
                'code': 'workPostType_918',
                'id': '918',
                'name': '县市区旗纪检监察机关',
                'parentId': '912'
              },
              {
                'code': 'workPostType_919',
                'id': '919',
                'name': '乡镇纪委(街道纪工委)',
                'parentId': '912'
              }
            ],
            'code': 'workPostType_912',
            'id': '912',
            'name': '纪检监察机关',
            'parentId': '908'
          },
          {
            'children': [
              {
                'code': 'workPostType_920',
                'id': '920',
                'name': '中央纪委监察部派驻(派出)机构',
                'parentId': '913'
              },
              {
                'code': 'workPostType_921',
                'id': '921',
                'name': '省级纪检监察机关派驻(派出)机构',
                'parentId': '913'
              },
              {
                'code': 'workPostType_922',
                'id': '922',
                'name': '市级纪检监察机关派驻(派出)机构',
                'parentId': '913'
              },
              {
                'code': 'workPostType_923',
                'id': '923',
                'name': '县级纪检监察机关派驻(派出)机构',
                'parentId': '913'
              }
            ],
            'code': 'workPostType_913',
            'id': '913',
            'name': '派驻机构',
            'parentId': '908'
          },
          {
            'children': [
              {
                'code': 'workPostType_924',
                'id': '924',
                'name': '中央和国家机关内设纪检监察机构',
                'parentId': '914'
              },
              {
                'code': 'workPostType_925',
                'id': '925',
                'name': '省直机关内设纪检监察机构',
                'parentId': '914'
              },
              {
                'code': 'workPostType_926',
                'id': '926',
                'name': '市直机关内设纪检监察机构',
                'parentId': '914'
              },
              {
                'code': 'workPostType_927',
                'id': '927',
                'name': '县直机关内设纪检监察机构',
                'parentId': '914'
              }
            ],
            'code': 'workPostType_914',
            'id': '914',
            'name': '内设纪检监察机构',
            'parentId': '908'
          }
        ],
        'code': 'workPostType_908',
        'id': '908',
        'name': '机关性质的纪检监察机构',
        'parentId': '907'
      },
      {
        'code': 'workPostType_909',
        'id': '909',
        'name': '企业单位纪检监察机构',
        'parentId': '907'
      },
      {
        'code': 'workPostType_910',
        'id': '910',
        'name': '事业单位纪检监察机构',
        'parentId': '907'
      },
      {
        'code': 'workPostType_911',
        'id': '911',
        'name': '其他',
        'parentId': '907'
      }
    ],
    'code': 'workPostType',
    'id': '907',
    'name': '单位类型',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'breakCause_929',
        'id': '929',
        'name': '综合协调',
        'parentId': '928'
      },
      {
        'code': 'breakCause_930',
        'id': '930',
        'name': '政策法规研究',
        'parentId': '928'
      },
      {
        'code': 'breakCause_931',
        'id': '931',
        'name': '宣传教育',
        'parentId': '928'
      },
      {
        'code': 'breakCause_932',
        'id': '932',
        'name': '党风政风监督',
        'parentId': '928'
      },
      {
        'code': 'breakCause_933',
        'id': '933',
        'name': '巡视',
        'parentId': '928'
      },
      {
        'code': 'breakCause_934',
        'id': '934',
        'name': '执法效能监督',
        'parentId': '928'
      },
      {
        'code': 'breakCause_935',
        'id': '935',
        'name': '信访举报',
        'parentId': '928'
      },
      {
        'code': 'breakCause_936',
        'id': '936',
        'name': '案件检查',
        'parentId': '928'
      },
      {
        'code': 'breakCause_937',
        'id': '937',
        'name': '案件管理',
        'parentId': '928'
      },
      {
        'code': 'breakCause_938',
        'id': '938',
        'name': '案件审理',
        'parentId': '928'
      },
      {
        'code': 'breakCause_939',
        'id': '939',
        'name': '组织人事',
        'parentId': '928'
      },
      {
        'code': 'breakCause_940',
        'id': '940',
        'name': '后勤保障',
        'parentId': '928'
      },
      {
        'code': 'breakCause_941',
        'id': '941',
        'name': '其他',
        'parentId': '928'
      }
    ],
    'code': 'breakCause',
    'id': '928',
    'name': '因分管或从事哪方面工作违纪',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'breakLinkCount_943',
        'id': '943',
        'name': '办理信访中违纪',
        'parentId': '942'
      },
      {
        'code': 'breakLinkCount_944',
        'id': '944',
        'name': '查办案件中违纪',
        'parentId': '942'
      },
      {
        'code': 'breakLinkCount_945',
        'id': '945',
        'name': '监督检查中违纪',
        'parentId': '942'
      }
    ],
    'code': 'breakLinkCount',
    'id': '942',
    'name': '专项违纪环节统计',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'onjob_959',
        'id': '959',
        'name': '在职',
        'parentId': '958'
      },
      {
        'code': 'onjob_960',
        'id': '960',
        'name': '离休',
        'parentId': '958'
      },
      {
        'code': 'onjob_961',
        'id': '961',
        'name': '退休',
        'parentId': '958'
      }
    ],
    'code': 'onjob',
    'id': '958',
    'name': '是否在职',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjxw_1015',
                'id': '1015',
                'name': '公开发表反对四项基本原则、改革开放决策言论',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1016',
                'id': '1016',
                'name': '传播或帮助传播公开发表反对四项基本原则、改革开放决策言论',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1017',
                'id': '1017',
                'name': '公开发表违背四项基本原则言论',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1018',
                'id': '1018',
                'name': '公开发表违背、歪曲改革开放决策言论',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1019',
                'id': '1019',
                'name': '公开发表其他有严重政治问题言论',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1020',
                'id': '1020',
                'name': '妄议中央大政方针',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1021',
                'id': '1021',
                'name': '丑化党和国家形象',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1022',
                'id': '1022',
                'name': '诋毁、污蔑党和国家领导人、英雄模范',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1023',
                'id': '1023',
                'name': '歪曲党史、国史、军史',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1024',
                'id': '1024',
                'name': '传播或帮助传播违背四项基本原则、改革开放决策等言论',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1025',
                'id': '1025',
                'name': '制作、贩卖、传播政治类有害资料',
                'parentId': '984'
              },
              {
                'code': 'wjxw_1026',
                'id': '1026',
                'name': '私自携带、寄递政治类有害资料入出境',
                'parentId': '984'
              }
            ],
            'code': 'wjxw_984',
            'id': '984',
            'name': '公开发表危害党的言论',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_1027',
                'id': '1027',
                'name': '组织、参加反党集会、游行、示威、讲座、论坛、报告会、座谈会等活动',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1028',
                'id': '1028',
                'name': '制造、散布、传播政治谣言',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1029',
                'id': '1029',
                'name': '支持反党活动',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1030',
                'id': '1030',
                'name': '未经批准参加其他集会、游行、示威等活动',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1031',
                'id': '1031',
                'name': '组织、参加反党、反社会主义、敌视政府等组织',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1032',
                'id': '1032',
                'name': '组织、参加会道门或邪教组织',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1033',
                'id': '1033',
                'name': '组织、参加分裂党的活动',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1034',
                'id': '1034',
                'name': '在党内搞团团伙伙、拉帮结派等活动',
                'parentId': '985'
              },
              {
                'code': 'wjxw_1035',
                'id': '1035',
                'name': '捞取政治资本',
                'parentId': '985'
              },
              {
                'code': 'wjxw_2004',
                'id': '2004',
                'name': '不与党中央保持一致',
                'parentId': '985'
              },
              {
                'code': 'wjxw_2005',
                'id': '2005',
                'name': '对党不忠诚不老实、搞两面派',
                'parentId': '985'
              },
              {
                'code': 'wjxw_2006',
                'id': '2006',
                'name': '诬告造谣',
                'parentId': '985'
              }
            ],
            'code': 'wjxw_985',
            'id': '985',
            'name': '破坏党的团结统一',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_1036',
                'id': '1036',
                'name': '拒不执行党中央确定的大政方针',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1037',
                'id': '1037',
                'name': '违背党中央的大政方针另搞一套',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1038',
                'id': '1038',
                'name': '擅自对应由党中央决定的重大政策问题作出决定和对外发表主张',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1039',
                'id': '1039',
                'name': '挑拨破坏民族关系制造事端或参加民族分裂活动',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1040',
                'id': '1040',
                'name': '其他违反党和国家民族政策行为',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1041',
                'id': '1041',
                'name': '组织、利用宗教活动反党',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1042',
                'id': '1042',
                'name': '其他违反党和国家宗教政策行为',
                'parentId': '986'
              },
              {
                'code': 'wjxw_1043',
                'id': '1043',
                'name': '组织、利用宗族势力对抗党和政府',
                'parentId': '986'
              },
              {
                'code': 'wjxw_2007',
                'id': '2007',
                'name': '落实党中央决策部署不坚决,打折扣、搞变通',
                'parentId': '986'
              },
              {
                'code': 'wjxw_2008',
                'id': '2008',
                'name': '自行其是搞山头主义',
                'parentId': '986'
              }
            ],
            'code': 'wjxw_986',
            'id': '986',
            'name': '损害中央权威妨碍党和国家方针政策实施',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_1044',
                'id': '1044',
                'name': '串供或伪造、销毁、转移、隐匿证据',
                'parentId': '987'
              },
              {
                'code': 'wjxw_1045',
                'id': '1045',
                'name': '阻止他人揭发检举、提供证据材料',
                'parentId': '987'
              },
              {
                'code': 'wjxw_1046',
                'id': '1046',
                'name': '包庇同案人员',
                'parentId': '987'
              },
              {
                'code': 'wjxw_1047',
                'id': '1047',
                'name': '提供虚假情况掩盖事实',
                'parentId': '987'
              },
              {
                'code': 'wjxw_1048',
                'id': '1048',
                'name': '其他对抗组织审查行为',
                'parentId': '987'
              }
            ],
            'code': 'wjxw_987',
            'id': '987',
            'name': '对抗组织审查',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_1049',
                'id': '1049',
                'name': '组织迷信活动',
                'parentId': '988'
              },
              {
                'code': 'wjxw_1050',
                'id': '1050',
                'name': '参加迷信活动',
                'parentId': '988'
              },
              {
                'code': 'wjxw_2011',
                'id': '2011',
                'name': '信仰宗教',
                'parentId': '988'
              },
              {
                'code': 'wjxw_2012',
                'id': '2012',
                'name': '参与利用宗教搞煽动活动',
                'parentId': '988'
              }
            ],
            'code': 'wjxw_988',
            'id': '988',
            'name': '信仰宗教或组织参加迷信活动',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_1051',
                'id': '1051',
                'name': '申请政治避难',
                'parentId': '989'
              },
              {
                'code': 'wjxw_1052',
                'id': '1052',
                'name': '叛逃',
                'parentId': '989'
              },
              {
                'code': 'wjxw_1053',
                'id': '1053',
                'name': '在国（境）外公开发表反对党和政府言论',
                'parentId': '989'
              },
              {
                'code': 'wjxw_1054',
                'id': '1054',
                'name': '故意为叛逃等行为提供方便条件',
                'parentId': '989'
              },
              {
                'code': 'wjxw_1055',
                'id': '1055',
                'name': '涉外活动造成恶劣政治影响',
                'parentId': '989'
              }
            ],
            'code': 'wjxw_989',
            'id': '989',
            'name': '叛逃及在涉外活动中损害党和国家尊严利益',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_1056',
                'id': '1056',
                'name': '搞无原则一团和气',
                'parentId': '990'
              },
              {
                'code': 'wjxw_1057',
                'id': '1057',
                'name': '违反党的优良传统和工作惯例等党的规矩',
                'parentId': '990'
              }
            ],
            'code': 'wjxw_990',
            'id': '990',
            'name': '无原则一团和气违反政治规矩',
            'parentId': '978'
          },
          {
            'code': 'wjxw_2001',
            'id': '2001',
            'name': '不按规定向组织请示报告重大事项',
            'parentId': '978'
          },
          {
            'children': [
              {
                'code': 'wjxw_2009',
                'id': '2009',
                'name': '干扰巡视巡察工作',
                'parentId': '2002'
              },
              {
                'code': 'wjxw_2010',
                'id': '2010',
                'name': '不落实巡视巡察整改要求',
                'parentId': '2002'
              }
            ],
            'code': 'wjxw_2002',
            'id': '2002',
            'name': '干扰巡视巡察或不落实整改要求',
            'parentId': '978'
          },
          {
            'code': 'wjxw_2003',
            'id': '2003',
            'name': '不履行或履行全面从严治党主体责任、监督责任不力',
            'parentId': '978'
          }
        ],
        'code': 'wjxw_978',
        'id': '978',
        'name': '违反政治纪律',
        'parentId': '977'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjxw_1058',
                'id': '1058',
                'name': '拒不执行或擅自改变党组织重大决定',
                'parentId': '991'
              },
              {
                'code': 'wjxw_1059',
                'id': '1059',
                'name': '个人或少数人违反议事规则决定重大问题',
                'parentId': '991'
              },
              {
                'code': 'wjxw_1060',
                'id': '1060',
                'name': '下级党组织拒不执行或擅自改变上级党组织决定',
                'parentId': '991'
              },
              {
                'code': 'wjxw_1061',
                'id': '1061',
                'name': '拒不执行党组织分配、调动、交流等决定',
                'parentId': '991'
              },
              {
                'code': 'wjxw_2014',
                'id': '2014',
                'name': '违规决定“三重一大”事项',
                'parentId': '991'
              },
              {
                'code': 'wjxw_2015',
                'id': '2015',
                'name': '借集体决策名义集体违规',
                'parentId': '991'
              }
            ],
            'code': 'wjxw_991',
            'id': '991',
            'name': '违反民主集中制原则',
            'parentId': '979'
          },
          {
            'children': [
              {
                'code': 'wjxw_1071',
                'id': '1071',
                'name': '侵犯党员表决权、选举权和被选举权',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1072',
                'id': '1072',
                'name': '妨害党员自主行使表决权、选举权和被选举权',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1073',
                'id': '1073',
                'name': '侵犯他人批评权、检举权、控告权',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1074',
                'id': '1074',
                'name': '压制党员申辩、辩护、作证等权利',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1075',
                'id': '1075',
                'name': '压制或不按规定处理党员申诉',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1076',
                'id': '1076',
                'name': '打击报复',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1077',
                'id': '1077',
                'name': '党组织侵犯党员权利',
                'parentId': '992'
              },
              {
                'code': 'wjxw_1078',
                'id': '1078',
                'name': '其他侵犯党员权利行为',
                'parentId': '992'
              }
            ],
            'code': 'wjxw_992',
            'id': '992',
            'name': '侵犯党员权利',
            'parentId': '979'
          },
          {
            'children': [
              {
                'code': 'wjxw_1079',
                'id': '1079',
                'name': '在民主推荐、民主测评、组织考察和党内选举中搞非组织活动',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1080',
                'id': '1080',
                'name': '在法定投票选举中搞非组织活动',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1081',
                'id': '1081',
                'name': '在选举中搞其他违规活动',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1082',
                'id': '1082',
                'name': '违规选拔任用干部',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1083',
                'id': '1083',
                'name': '用人失察失误',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1084',
                'id': '1084',
                'name': '在干部、职工录用、考核等工作中为本人或他人谋利',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1085',
                'id': '1085',
                'name': '骗取职务、待遇、学历、荣誉等',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1086',
                'id': '1086',
                'name': '把不符合党员条件的人发展为党员',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1087',
                'id': '1087',
                'name': '为非党员出具党员身份证明',
                'parentId': '993'
              },
              {
                'code': 'wjxw_1088',
                'id': '1088',
                'name': '违反程序发展党员',
                'parentId': '993'
              },
              {
                'code': 'wjxw_2024',
                'id': '2024',
                'name': '拉票贿选',
                'parentId': '993'
              }
            ],
            'code': 'wjxw_993',
            'id': '993',
            'name': '违反组织工作原则',
            'parentId': '979'
          },
          {
            'children': [
              {
                'code': 'wjxw_1089',
                'id': '1089',
                'name': '违规取得外国国籍、国（境）外居留资格',
                'parentId': '994'
              },
              {
                'code': 'wjxw_1090',
                'id': '1090',
                'name': '违规办理因私出国（境）证件等',
                'parentId': '994'
              },
              {
                'code': 'wjxw_1091',
                'id': '1091',
                'name': '未经批准出入国（边）境',
                'parentId': '994'
              },
              {
                'code': 'wjxw_1092',
                'id': '1092',
                'name': '在国（境）外擅自脱离组织',
                'parentId': '994'
              },
              {
                'code': 'wjxw_1093',
                'id': '1093',
                'name': '在国（境）外违规交往',
                'parentId': '994'
              },
              {
                'code': 'wjxw_1094',
                'id': '1094',
                'name': '在国（境）外脱离组织出走',
                'parentId': '994'
              },
              {
                'code': 'wjxw_1095',
                'id': '1095',
                'name': '故意为他人脱离组织出走提供方便条件',
                'parentId': '994'
              }
            ],
            'code': 'wjxw_994',
            'id': '994',
            'name': '违规办理因私出国（境）证件和在国（境）外擅自脱离组织',
            'parentId': '979'
          },
          {
            'children': [
              {
                'code': 'wjxw_2023',
                'id': '2023',
                'name': '违规组织、参加自发成立的老乡会、校友会、战友会等',
                'parentId': '2013'
              }
            ],
            'code': 'wjxw_2013',
            'id': '2013',
            'name': '违规组织参加老乡会等',
            'parentId': '979'
          },
          {
            'children': [
              {
                'code': 'wjxw_2016',
                'id': '2016',
                'name': '隐瞒不报个人有关事项',
                'parentId': '2912'
              },
              {
                'code': 'wjxw_2018',
                'id': '2018',
                'name': '谈话、函询时不如实说明问题',
                'parentId': '2912'
              },
              {
                'code': 'wjxw_2019',
                'id': '2019',
                'name': '不按要求报告或不如实报告个人去向',
                'parentId': '2912'
              },
              {
                'code': 'wjxw_2020',
                'id': '2020',
                'name': '不如实填报个人档案资料',
                'parentId': '2912'
              },
              {
                'code': 'wjxw_2021',
                'id': '2021',
                'name': '篡改、伪造个人档案资料',
                'parentId': '2912'
              },
              {
                'code': 'wjxw_2022',
                'id': '2022',
                'name': '隐瞒入党前严重错误',
                'parentId': '2912'
              }
            ],
            'code': 'wjxw_2912',
            'id': '2912',
            'name': '不按要求或不如实报告有关事项',
            'parentId': '979'
          }
        ],
        'code': 'wjxw_979',
        'id': '979',
        'name': '违反组织纪律',
        'parentId': '977'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjxw_1096',
                'id': '1096',
                'name': '为他人谋利、本人亲属和特定关系人收受对方财物',
                'parentId': '995'
              },
              {
                'code': 'wjxw_1097',
                'id': '1097',
                'name': '权权交易',
                'parentId': '995'
              },
              {
                'code': 'wjxw_1098',
                'id': '1098',
                'name': '纵容、默许亲属、身边工作人员和其他特定关系人违规谋利',
                'parentId': '995'
              },
              {
                'code': 'wjxw_1099',
                'id': '1099',
                'name': '对亲属和其他特定关系人违规取酬知情未予纠正',
                'parentId': '995'
              }
            ],
            'code': 'wjxw_995',
            'id': '995',
            'name': '以权谋私',
            'parentId': '980'
          },
          {
            'children': [
              {
                'code': 'wjxw_1100',
                'id': '1100',
                'name': '收受可能影响公正执行公务的礼品、礼金、消费卡、金融产品等财物',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1101',
                'id': '1101',
                'name': '收受明显超出正常礼尚往来的财物',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1102',
                'id': '1102',
                'name': '向从事公务的人员及其亲属和特定关系人违规赠送礼品、礼金、消费卡、金融产品等财物',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1103',
                'id': '1103',
                'name': '利用职权或职务上的影响操办婚丧喜庆事宜',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1104',
                'id': '1104',
                'name': '在操办婚丧喜庆事宜中借机敛财等',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1105',
                'id': '1105',
                'name': '接受、提供可能影响公正执行公务的宴请、旅游等',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1106',
                'id': '1106',
                'name': '违规取得、持有、使用消费卡',
                'parentId': '996'
              },
              {
                'code': 'wjxw_1107',
                'id': '1107',
                'name': '违规出入私人会所',
                'parentId': '996'
              },
              {
                'code': 'wjxw_2025',
                'id': '2025',
                'name': '借用管理和服务对象财物',
                'parentId': '996'
              },
              {
                'code': 'wjxw_2026',
                'id': '2026',
                'name': '通过民间借贷等金融活动获取大额回报',
                'parentId': '996'
              }
            ],
            'code': 'wjxw_996',
            'id': '996',
            'name': '违规接受礼品礼金和服务',
            'parentId': '980'
          },
          {
            'children': [
              {
                'code': 'wjxw_1108',
                'id': '1108',
                'name': '违规经商办企业',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1109',
                'id': '1109',
                'name': '违规拥有非上市公司（企业）股份或证劵',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1110',
                'id': '1110',
                'name': '违规买卖股票或其他证劵投资',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1111',
                'id': '1111',
                'name': '违规从事有偿中介活动',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1112',
                'id': '1112',
                'name': '违规在国（境）外注册公司或投资入股',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1113',
                'id': '1113',
                'name': '违规为亲属和特定关系人经营活动谋利',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1114',
                'id': '1114',
                'name': '违规兼职',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1115',
                'id': '1115',
                'name': '兼职取酬',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1116',
                'id': '1116',
                'name': '离职或退（离）休后违规接受聘任',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1117',
                'id': '1117',
                'name': '离职或退（离）休后违规从事营利活动',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1118',
                'id': '1118',
                'name': '离职或退（离）休后违规担任独立董事、独立监事',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1119',
                'id': '1119',
                'name': '对亲属违反从业限制规定应予纠正而拒不纠正',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1120',
                'id': '1120',
                'name': '党和国家机关违规经商办企业',
                'parentId': '997'
              },
              {
                'code': 'wjxw_1121',
                'id': '1121',
                'name': '其他违规从事营利活动',
                'parentId': '997'
              },
              {
                'code': 'wjxw_2027',
                'id': '2027',
                'name': '利用职权或者职务上的影响买卖股票、基金等金融产品',
                'parentId': '997'
              },
              {
                'code': 'wjxw_2028',
                'id': '2028',
                'name': '违规为亲属和特定关系人吸收存款、推销金融产品等谋利',
                'parentId': '997'
              }
            ],
            'code': 'wjxw_997',
            'id': '997',
            'name': '违规从事营利性活动',
            'parentId': '980'
          },
          {
            'children': [
              {
                'code': 'wjxw_1122',
                'id': '1122',
                'name': '违规谋求特殊待遇',
                'parentId': '998'
              },
              {
                'code': 'wjxw_1123',
                'id': '1123',
                'name': '在分配、购买住房中侵犯国家、集体利益',
                'parentId': '998'
              }
            ],
            'code': 'wjxw_998',
            'id': '998',
            'name': '违反工作生活待遇规定',
            'parentId': '980'
          },
          {
            'children': [
              {
                'code': 'wjxw_1124',
                'id': '1124',
                'name': '侵占非本人经营的公私财物等',
                'parentId': '999'
              },
              {
                'code': 'wjxw_1125',
                'id': '1125',
                'name': '以象征性支付钱款等方式侵占公私财物',
                'parentId': '999'
              },
              {
                'code': 'wjxw_1126',
                'id': '1126',
                'name': '无偿、象征性支付报酬接受服务、使用劳务',
                'parentId': '999'
              },
              {
                'code': 'wjxw_1127',
                'id': '1127',
                'name': '违规支付、报销应由本人或亲属承担的费用',
                'parentId': '999'
              },
              {
                'code': 'wjxw_1128',
                'id': '1128',
                'name': '违规占用公物归个人使用',
                'parentId': '999'
              },
              {
                'code': 'wjxw_1129',
                'id': '1129',
                'name': '占用公物进行营利活动',
                'parentId': '999'
              },
              {
                'code': 'wjxw_1130',
                'id': '1130',
                'name': '将公物借给他人进行营利活动',
                'parentId': '999'
              }
            ],
            'code': 'wjxw_999',
            'id': '999',
            'name': '违规占有使用公款公物',
            'parentId': '980'
          },
          {
            'children': [
              {
                'code': 'wjxw_1131',
                'id': '1131',
                'name': '违规组织、参加公款宴请、高消费娱乐、健身活动',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1132',
                'id': '1132',
                'name': '违规用公款购买赠送或发放礼品、消费卡(券)',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1133',
                'id': '1133',
                'name': '违规自定薪酬或滥发津贴、补贴、奖金等',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1134',
                'id': '1134',
                'name': '公款旅游或变相公款旅游',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1135',
                'id': '1135',
                'name': '变相用公款出国（境）旅游',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1136',
                'id': '1136',
                'name': '违规接待或借机大吃大喝',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1137',
                'id': '1137',
                'name': '违反公务用车管理规定',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1138',
                'id': '1138',
                'name': '违规到禁止开会的风景名胜区开会',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1139',
                'id': '1139',
                'name': '违规决定或批准举办节会、庆典活动',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1140',
                'id': '1140',
                'name': '擅自举办评比表彰活动或借机收费',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1141',
                'id': '1141',
                'name': '违规决定或批准兴建、装修楼堂馆所等',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1142',
                'id': '1142',
                'name': '超标准配备、使用办公用房',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_1143',
                'id': '1143',
                'name': '违规用公款包租、占用客房等供个人使用',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_2029',
                'id': '2029',
                'name': '改变公务行程和时间借机旅游',
                'parentId': '1000'
              },
              {
                'code': 'wjxw_2030',
                'id': '2030',
                'name': '参加所管理企业、下属单位组织的考察借机旅游',
                'parentId': '1000'
              }
            ],
            'code': 'wjxw_1000',
            'id': '1000',
            'name': '违反厉行节约反对浪费规定',
            'parentId': '980'
          },
          {
            'children': [
              {
                'code': 'wjxw_2031',
                'id': '2031',
                'name': '权色或钱色交易',
                'parentId': '1001'
              }
            ],
            'code': 'wjxw_1001',
            'id': '1001',
            'name': '权色或钱色交易',
            'parentId': '980'
          },
          {
            'code': 'wjxw_1002',
            'id': '1002',
            'name': '其他违反廉洁纪律行为',
            'parentId': '980'
          }
        ],
        'code': 'wjxw_980',
        'id': '980',
        'name': '违反廉洁纪律',
        'parentId': '977'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjxw_1144',
                'id': '1144',
                'name': '超标准、超范围筹资筹劳、摊派费用',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1145',
                'id': '1145',
                'name': '违规扣留、收缴群众款物或处罚群众',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1146',
                'id': '1146',
                'name': '克扣群众财物或违规拖欠群众钱款',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1147',
                'id': '1147',
                'name': '在管理、服务中违规收费',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1148',
                'id': '1148',
                'name': '在工作中刁难群众、吃拿卡要',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1149',
                'id': '1149',
                'name': '干涉群众生产经营自主权',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1150',
                'id': '1150',
                'name': '在社会保障等事项中优亲厚友、显失公平',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_1151',
                'id': '1151',
                'name': '其他侵害群众利益行为',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_2032',
                'id': '2032',
                'name': '利用宗族、黑恶势力欺压群众',
                'parentId': '1003'
              },
              {
                'code': 'wjxw_2033',
                'id': '2033',
                'name': '纵容涉黑涉恶活动或充当“保护伞”',
                'parentId': '1003'
              }
            ],
            'code': 'wjxw_1003',
            'id': '1003',
            'name': '侵害群众利益',
            'parentId': '981'
          },
          {
            'children': [
              {
                'code': 'wjxw_1152',
                'id': '1152',
                'name': '对群众切身利益问题能解决而不及时解决',
                'parentId': '1004'
              },
              {
                'code': 'wjxw_1153',
                'id': '1153',
                'name': '对符合政策的群众诉求消极应付、推诿扯皮',
                'parentId': '1004'
              },
              {
                'code': 'wjxw_1154',
                'id': '1154',
                'name': '对待群众态度恶劣、简单粗暴',
                'parentId': '1004'
              },
              {
                'code': 'wjxw_1155',
                'id': '1155',
                'name': '弄虚作假、欺上瞒下',
                'parentId': '1004'
              },
              {
                'code': 'wjxw_1156',
                'id': '1156',
                'name': '盲目铺摊子、上项目',
                'parentId': '1004'
              },
              {
                'code': 'wjxw_1157',
                'id': '1157',
                'name': '遇险能救而不救',
                'parentId': '1004'
              },
              {
                'code': 'wjxw_2034',
                'id': '2034',
                'name': '其他不作为、乱作为损害群众利益行为',
                'parentId': '1004'
              }
            ],
            'code': 'wjxw_1004',
            'id': '1004',
            'name': '漠视群众利益',
            'parentId': '981'
          },
          {
            'code': 'wjxw_1005',
            'id': '1005',
            'name': '侵犯群众知情权',
            'parentId': '981'
          },
          {
            'code': 'wjxw_1006',
            'id': '1006',
            'name': '其他违反群众纪律行为',
            'parentId': '981'
          }
        ],
        'code': 'wjxw_981',
        'id': '981',
        'name': '违反群众纪律',
        'parentId': '977'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjxw_1158',
                'id': '1158',
                'name': '工作失职失管贯彻上级部署不力导致损失',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_1159',
                'id': '1159',
                'name': '贯彻新发展理念不力失察失责导致损失',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_1160',
                'id': '1160',
                'name': '贯彻党中央决策部署只表态不落实',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_1161',
                'id': '1161',
                'name': '调查研究热衷于作秀、浮在表面',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_1162',
                'id': '1162',
                'name': '不按规定给予党纪处分',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_1163',
                'id': '1163',
                'name': '不按规定落实党纪处分决定或申诉复查决定',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_1164',
                'id': '1164',
                'name': '不按规定对受处分党员开展教育、管理和监督',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_2035',
                'id': '2035',
                'name': '单纯以会议贯彻会议、以文件落实文件',
                'parentId': '1007'
              },
              {
                'code': 'wjxw_2036',
                'id': '2036',
                'name': '其他形式主义、官僚主义行为',
                'parentId': '1007'
              }
            ],
            'code': 'wjxw_1007',
            'id': '1007',
            'name': '工作失职',
            'parentId': '982'
          },
          {
            'children': [
              {
                'code': 'wjxw_1165',
                'id': '1165',
                'name': '失职致所管理人员叛逃',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1166',
                'id': '1166',
                'name': '失职致所管理人员出走',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1167',
                'id': '1167',
                'name': '工作中不向或不如实向上级报告情况',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1168',
                'id': '1168',
                'name': '违规干预和插手建设工程、政府采购、房地产、矿产资源开发等',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1169',
                'id': '1169',
                'name': '违规干预和插手国企重组改制、兼并、破产、重大项目投资等',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1170',
                'id': '1170',
                'name': '违规干预和插手批办行政许可和资金借贷等',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1171',
                'id': '1171',
                'name': '违规干预和插手经济纠纷',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1172',
                'id': '1172',
                'name': '违规干预和插手集体三资使用、分配、承办、租赁等',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1173',
                'id': '1173',
                'name': '违规干预和插手司法、执纪执法活动等',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_1174',
                'id': '1174',
                'name': '违规干预和插手财政资金分配、使用等',
                'parentId': '1008'
              },
              {
                'code': 'wjxw_2037',
                'id': '2037',
                'name': '工作中唆使、强迫下级报假情',
                'parentId': '1008'
              }
            ],
            'code': 'wjxw_1008',
            'id': '1008',
            'name': '滥用职权和玩忽职守',
            'parentId': '982'
          },
          {
            'children': [
              {
                'code': 'wjxw_1175',
                'id': '1175',
                'name': '泄密、扩散或窃取党组织秘密',
                'parentId': '1009'
              },
              {
                'code': 'wjxw_1176',
                'id': '1176',
                'name': '私存党组织的相关资料',
                'parentId': '1009'
              },
              {
                'code': 'wjxw_1177',
                'id': '1177',
                'name': '在考试、录取工作中泄露试题等',
                'parentId': '1009'
              }
            ],
            'code': 'wjxw_1009',
            'id': '1009',
            'name': '失泄密',
            'parentId': '982'
          },
          {
            'children': [
              {
                'code': 'wjxw_1178',
                'id': '1178',
                'name': '以不正当方式谋求公款出国（境）',
                'parentId': '1010'
              },
              {
                'code': 'wjxw_1179',
                'id': '1179',
                'name': '擅自延长出国（境）期限',
                'parentId': '1010'
              },
              {
                'code': 'wjxw_1180',
                'id': '1180',
                'name': '擅自变更出国（境）路线',
                'parentId': '1010'
              },
              {
                'code': 'wjxw_1181',
                'id': '1181',
                'name': '触犯驻在国家、地区法律、法令',
                'parentId': '1010'
              },
              {
                'code': 'wjxw_1182',
                'id': '1182',
                'name': '不尊重驻在国家、地区宗教习俗',
                'parentId': '1010'
              }
            ],
            'code': 'wjxw_1010',
            'id': '1010',
            'name': '违反外事工作纪律',
            'parentId': '982'
          },
          {
            'code': 'wjxw_1011',
            'id': '1011',
            'name': '其他违反工作纪律行为',
            'parentId': '982'
          }
        ],
        'code': 'wjxw_982',
        'id': '982',
        'name': '违反工作纪律',
        'parentId': '977'
      },
      {
        'children': [
          {
            'code': 'wjxw_1012',
            'id': '1012',
            'name': '生活奢靡',
            'parentId': '983'
          },
          {
            'children': [
              {
                'code': 'wjxw_1183',
                'id': '1183',
                'name': '与他人发生不正当性关系',
                'parentId': '1013'
              },
              {
                'code': 'wjxw_1184',
                'id': '1184',
                'name': '违背社会公序良俗',
                'parentId': '1013'
              },
              {
                'code': 'wjxw_2038',
                'id': '2038',
                'name': '对家属失管失教',
                'parentId': '1013'
              }
            ],
            'code': 'wjxw_1013',
            'id': '1013',
            'name': '违背家庭伦理和社会道德',
            'parentId': '983'
          },
          {
            'code': 'wjxw_1014',
            'id': '1014',
            'name': '其他违反生活纪律行为',
            'parentId': '983'
          }
        ],
        'code': 'wjxw_983',
        'id': '983',
        'name': '违反生活纪律',
        'parentId': '977'
      },
      {
        'children': [
          {
            'code': 'wjxw_9251',
            'id': '9251',
            'name': '无',
            'parentId': '9250',
            'children': [
              {
                'code': 'wjxw_9252',
                'id': '9252',
                'name': '无',
                'parentId': '9251'
              },
            ],
          }
        ],
        'code': 'wjxw_9250',
        'id': '9250',
        'name': '无',
        'parentId': '977'
      }
    ],
    'code': 'wjxw',
    'id': '977',
    'name': '违纪行为',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'other_crime_1199',
            'id': '1199',
            'name': '挪用资金',
            'parentId': '1187'
          },
          {
            'code': 'other_crime_1200',
            'id': '1200',
            'name': '职务侵占',
            'parentId': '1187'
          },
          {
            'code': 'other_crime_1201',
            'id': '1201',
            'name': '非国家工作人员受贿',
            'parentId': '1187'
          },
          {
            'code': 'other_crime_1202',
            'id': '1202',
            'name': '私设“小金库”',
            'parentId': '1187'
          },
          {
            'code': 'other_crime_1203',
            'id': '1203',
            'name': '其他破坏社会主义经济秩序行为',
            'parentId': '1187'
          }
        ],
        'code': 'other_crime_1187',
        'id': '1187',
        'name': '破坏社会主义经济秩序',
        'parentId': '1185'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1204',
            'id': '1204',
            'name': '滥用职权',
            'parentId': '1188'
          },
          {
            'code': 'duty_crime_1205',
            'id': '1205',
            'name': '玩忽职守',
            'parentId': '1188'
          },
          {
            'code': 'duty_crime_1206',
            'id': '1206',
            'name': '徇私枉法',
            'parentId': '1188'
          },
          {
            'code': 'duty_crime_1207',
            'id': '1207',
            'name': '安全责任事故',
            'parentId': '1188'
          },
          {
            'code': 'duty_crime_1208',
            'id': '1208',
            'name': '其他失职渎职行为',
            'parentId': '1188'
          }
        ],
        'code': 'duty_crime_1188',
        'id': '1188',
        'name': '失职渎职',
        'parentId': '1185'
      },
      {
        'code': 'other_crime_1189',
        'id': '1189',
        'name': '侵犯公民人身权利民主权利',
        'parentId': '1185'
      },
      {
        'children': [
          {
            'code': 'other_crime_1209',
            'id': '1209',
            'name': '嫖娼',
            'parentId': '1190'
          },
          {
            'code': 'other_crime_1210',
            'id': '1210',
            'name': '赌博',
            'parentId': '1190'
          },
          {
            'code': 'other_crime_1211',
            'id': '1211',
            'name': '妨碍司法',
            'parentId': '1190'
          },
          {
            'code': 'other_crime_1212',
            'id': '1212',
            'name': '扰乱公共秩序',
            'parentId': '1190'
          },
          {
            'code': 'other_crime_1213',
            'id': '1213',
            'name': '违反人口与计划生育法规',
            'parentId': '1190'
          },
          {
            'code': 'other_crime_1214',
            'id': '1214',
            'name': '其他妨害社会管理秩序行为',
            'parentId': '1190'
          }
        ],
        'code': 'other_crime_1190',
        'id': '1190',
        'name': '妨害社会管理秩序',
        'parentId': '1185'
      },
      {
        'code': 'sfxw_1191',
        'id': '1191',
        'name': '其他涉法行为',
        'parentId': '1185'
      }
    ],
    'code': 'sfxw',
    'id': '1185',
    'name': '涉法行为',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'enterprisepost_1239',
        'id': '1239',
        'name': '生产经营',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1240',
        'id': '1240',
        'name': '销售采购',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1241',
        'id': '1241',
        'name': '项目管理',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1242',
        'id': '1242',
        'name': '财会管理',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1243',
        'id': '1243',
        'name': '涉外管理',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1244',
        'id': '1244',
        'name': '监督管理',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1245',
        'id': '1245',
        'name': '组织人事',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1246',
        'id': '1246',
        'name': '党群政工',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1247',
        'id': '1247',
        'name': '综合管理',
        'parentId': '1238'
      },
      {
        'code': 'enterprisepost_1248',
        'id': '1248',
        'name': '其他岗位',
        'parentId': '1238'
      }
    ],
    'code': 'enterprisepost',
    'id': '1238',
    'name': '企业岗位',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'beduty_1269',
        'id': '1269',
        'name': '是',
        'parentId': '1268'
      }
    ],
    'code': 'beduty',
    'id': '1268',
    'name': '是否责任追究',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'besecond_1271',
        'id': '1271',
        'name': '是',
        'parentId': '1270'
      },
      {
        'code': 'besecond_1272',
        'id': '1272',
        'name': '否',
        'parentId': '1270'
      }
    ],
    'code': 'besecond',
    'id': '1270',
    'name': '二次申诉件',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'besupervis_1274',
        'id': '1274',
        'name': '是',
        'parentId': '1273'
      },
      {
        'code': 'besupervis_1275',
        'id': '1275',
        'name': '否',
        'parentId': '1273'
      }
    ],
    'code': 'besupervis',
    'id': '1273',
    'name': '是否监察对象',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'casetype_1277',
        'id': '1277',
        'name': '是',
        'parentId': '1276'
      },
      {
        'code': 'casetype_1278',
        'id': '1278',
        'name': '否',
        'parentId': '1276'
      }
    ],
    'code': 'casetype',
    'id': '1276',
    'name': '是否单位或事件',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'isdelay_1280',
        'id': '1280',
        'name': '是',
        'parentId': '1279'
      },
      {
        'code': 'isdelay_1281',
        'id': '1281',
        'name': '否',
        'parentId': '1279'
      }
    ],
    'code': 'isdelay',
    'id': '1279',
    'name': '是否延期',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'mainmark_1283',
        'id': '1283',
        'name': '是',
        'parentId': '1282'
      }
    ],
    'code': 'mainmark',
    'id': '1282',
    'name': '统计标志记录',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'repeated_1285',
        'id': '1285',
        'name': '是',
        'parentId': '1284'
      }
    ],
    'code': 'repeated',
    'id': '1284',
    'name': '重复线索标识',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'servant_1287',
        'id': '1287',
        'name': '是',
        'parentId': '1286'
      },
      {
        'code': 'servant_1288',
        'id': '1288',
        'name': '否',
        'parentId': '1286'
      }
    ],
    'code': 'servant',
    'id': '1286',
    'name': '公务员',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'ischecked_1297',
        'id': '1297',
        'name': '是',
        'parentId': '1296'
      },
      {
        'code': 'ischecked_1298',
        'id': '1298',
        'name': '否',
        'parentId': '1296'
      }
    ],
    'code': 'ischecked',
    'id': '1296',
    'name': '是否与本人核实',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'shape_type_1307',
        'id': '1307',
        'name': '第一种形态',
        'parentId': '1306'
      },
      {
        'code': 'shape_type_1308',
        'id': '1308',
        'name': '第二种形态',
        'parentId': '1306'
      },
      {
        'code': 'shape_type_1309',
        'id': '1309',
        'name': '第三种形态',
        'parentId': '1306'
      },
      {
        'code': 'shape_type_1310',
        'id': '1310',
        'name': '第四种形态',
        'parentId': '1306'
      }
    ],
    'code': 'shape_type',
    'id': '1306',
    'name': '四种形态',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'work_unit_1312',
        'id': '1312',
        'name': '党委',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1313',
        'id': '1313',
        'name': '政府',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1314',
        'id': '1314',
        'name': '人大',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1315',
        'id': '1315',
        'name': '政协',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1316',
        'id': '1316',
        'name': '法院',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1317',
        'id': '1317',
        'name': '检察院',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1318',
        'id': '1318',
        'name': '地市',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1319',
        'id': '1319',
        'name': '省直',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1320',
        'id': '1320',
        'name': '国企',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1321',
        'id': '1321',
        'name': '高校',
        'parentId': '1311'
      },
      {
        'code': 'work_unit_1322',
        'id': '1322',
        'name': '其他',
        'parentId': '1311'
      }
    ],
    'code': 'work_unit',
    'id': '1311',
    'name': '工作单位',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'cadre_file_type_1324',
        'id': '1324',
        'name': '党廉回复记录',
        'parentId': '1323'
      },
      {
        'code': 'cadre_file_type_1325',
        'id': '1325',
        'name': '干部任免审批表或简历',
        'parentId': '1323'
      },
      {
        'code': 'cadre_file_type_1326',
        'id': '1326',
        'name': '其它信息',
        'parentId': '1323'
      },
      {
        'code': 'cadre_file_type_1327',
        'id': '1327',
        'name': '线索处置信息',
        'parentId': '1323'
      }
    ],
    'code': 'cadre_file_type',
    'id': '1323',
    'name': '档案类型',
    'parentId': '0'
  },
  {
    'children': [
      // {
      //   'code': 'gbglqx_454',
      //   'id': '454',
      //   'name': '中管干部',
      //   'parentId': '1328'
      // },
      {
        'code': 'gbglqx_455',
        'id': '455',
        'name': '省管干部',
        'parentId': '1328'
      },
      {
        'code': 'gbglqx_456',
        'id': '456',
        'name': '市管干部',
        'parentId': '1328'
      },
      {
        'code': 'gbglqx_457',
        'id': '457',
        'name': '县管干部',
        'parentId': '1328'
      },
      {
        'code': 'gbglqx_458',
        'id': '458',
        'name': '均不是',
        'parentId': '1328'
      }
    ],
    'code': 'gbglqx',
    'id': '1328',
    'name': '干部管理权限',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'userclass_1335',
            'id': '1335',
            'name': '书记',
            'parentId': '1332'
          },
          {
            'code': 'userclass_1336',
            'id': '1336',
            'name': '副书记',
            'parentId': '1332'
          },
          {
            'code': 'userclass_1337',
            'id': '1337',
            'name': '常委',
            'parentId': '1332'
          }
        ],
        'code': 'userclass_1332',
        'id': '1332',
        'name': '委领导',
        'parentId': '1331'
      },
      {
        'children': [
          {
            'code': 'userclass_1338',
            'id': '1338',
            'name': '主任',
            'parentId': '1333'
          },
          {
            'code': 'userclass_1339',
            'id': '1339',
            'name': '副主任',
            'parentId': '1333'
          },
          {
            'code': 'userclass_1340',
            'id': '1340',
            'name': '处长',
            'parentId': '1333'
          },
          {
            'code': 'userclass_1341',
            'id': '1341',
            'name': '副处长',
            'parentId': '1333'
          },
          {
            'code': 'userclass_1342',
            'id': '1342',
            'name': '科长',
            'parentId': '1333'
          },
          {
            'code': 'userclass_1343',
            'id': '1343',
            'name': '副科长',
            'parentId': '1333'
          }
        ],
        'code': 'userclass_1333',
        'id': '1333',
        'name': '室领导',
        'parentId': '1331'
      },
      {
        'children': [
          {
            'code': 'userclass_1344',
            'id': '1344',
            'name': '工作人员',
            'parentId': '1334'
          },
          {
            'code': 'userclass_1345',
            'id': '1345',
            'name': '内勤',
            'parentId': '1334'
          }
        ],
        'code': 'userclass_1334',
        'id': '1334',
        'name': '一般干部',
        'parentId': '1331'
      }
    ],
    'code': 'userclass',
    'id': '1331',
    'name': '用户分类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'istransferClue_1329',
        'id': '1329',
        'name': '是',
        'parentId': '1346'
      },
      {
        'code': 'istransferClue_1330',
        'id': '1330',
        'name': '否',
        'parentId': '1346'
      }
    ],
    'code': 'istransferClue',
    'id': '1346',
    'name': '是否移送线索信息',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'isCityCadre_1348',
        'id': '1348',
        'name': '是',
        'parentId': '1347'
      },
      {
        'code': 'isCityCadre_1349',
        'id': '1349',
        'name': '否',
        'parentId': '1347'
      }
    ],
    'code': 'isCityCadre',
    'id': '1347',
    'name': '是否市管干部',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'vpcRank_1351',
        'id': '1351',
        'name': '正局级',
        'parentId': '1350'
      },
      {
        'code': 'vpcRank_1352',
        'id': '1352',
        'name': '副局级',
        'parentId': '1350'
      }
    ],
    'code': 'vpcRank',
    'id': '1350',
    'name': '副省部级职级',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'flow_1354',
        'id': '1354',
        'name': '案管室通用',
        'parentId': '1353'
      },
      {
        'code': 'flow_1355',
        'id': '1355',
        'name': '提醒谈话',
        'parentId': '1353'
      },
      {
        'code': 'flow_1356',
        'id': '1356',
        'name': '谈话函询',
        'parentId': '1353'
      },
      {
        'code': 'flow_1357',
        'id': '1357',
        'name': '批评教育、诫勉谈话',
        'parentId': '1353'
      },
      {
        'code': 'flow_1358',
        'id': '1358',
        'name': '责令整改',
        'parentId': '1353'
      },
      {
        'code': 'flow_1359',
        'id': '1359',
        'name': '初步核实',
        'parentId': '1353'
      },
      {
        'code': 'flow_1360',
        'id': '1360',
        'name': '立案审查',
        'parentId': '1353'
      },
      {
        'code': 'flow_1361',
        'id': '1361',
        'name': '涉案款物',
        'parentId': '1353'
      },
      {
        'code': 'flow_1362',
        'id': '1362',
        'name': '监察室通用',
        'parentId': '1353'
      }
    ],
    'code': 'flow',
    'id': '1353',
    'name': '流程',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'isNecessary_1364',
        'id': '1364',
        'name': '是',
        'parentId': '1363'
      },
      {
        'code': 'isNecessary_1365',
        'id': '1365',
        'name': '否',
        'parentId': '1363'
      }
    ],
    'code': 'isNecessary',
    'id': '1363',
    'name': '是否是必须关联流程的文书',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'documentStatus_1367',
        'id': '1367',
        'name': '启用',
        'parentId': '1366'
      },
      {
        'code': 'documentStatus_1368',
        'id': '1368',
        'name': '待启用',
        'parentId': '1366'
      },
      {
        'code': 'documentStatus_1369',
        'id': '1369',
        'name': '停用',
        'parentId': '1366'
      }
    ],
    'code': 'documentStatus',
    'id': '1366',
    'name': '文书状态',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'defaultCPTable_1392',
        'id': '1392',
        'name': '是',
        'parentId': '1391'
      },
      {
        'code': 'defaultCPTable_1393',
        'id': '1393',
        'name': '否',
        'parentId': '1391'
      }
    ],
    'code': 'defaultCPTable',
    'id': '1391',
    'name': '是否默认呈批表',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'flowStatus_1398',
        'id': '1398',
        'name': '开始',
        'parentId': '1397'
      },
      {
        'code': 'flowStatus_1399',
        'id': '1399',
        'name': '进行中',
        'parentId': '1397'
      },
      {
        'code': 'flowStatus_1400',
        'id': '1400',
        'name': '结束',
        'parentId': '1397'
      }
    ],
    'code': 'flowStatus',
    'id': '1397',
    'name': '流程状态',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'isShow_1403',
        'id': '1403',
        'name': '是',
        'parentId': '1402'
      },
      {
        'code': 'isShow_1404',
        'id': '1404',
        'name': '否',
        'parentId': '1402'
      }
    ],
    'code': 'isShow',
    'id': '1402',
    'name': '是否显示重复件',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'id_card_type_1519',
        'id': '1519',
        'name': '身份证',
        'parentId': '1518'
      },
      {
        'code': 'id_card_type_1520',
        'id': '1520',
        'name': '其他',
        'parentId': '1518'
      }
    ],
    'code': 'id_card_type',
    'id': '1518',
    'name': '证件类型',
    'parentId': '0'
  },
  {
    'children': [
      // {
      //   'code': 'clue_handle_organ_1522',
      //   'id': '1522',
      //   'name': '中央纪委国家监委',
      //   'parentId': '1521'
      // },
      // {
      //   'code': 'clue_handle_organ_1523',
      //   'id': '1523',
      //   'name': '省区市纪委监委',
      //   'parentId': '1521'
      // },
      // {
      //   'code': 'clue_handle_organ_1524',
      //   'id': '1524',
      //   'name': '地市州盟纪委监委',
      //   'parentId': '1521'
      // },
      // {
      //   'code': 'clue_handle_organ_1525',
      //   'id': '1525',
      //   'name': '县市区旗纪委监委',
      //   'parentId': '1521'
      // },
      // {
      //   'code': 'clue_handle_organ_1526',
      //   'id': '1526',
      //   'name': '乡镇纪委',
      //   'parentId': '1521'
      // },
      // {
      //   'code': 'clue_handle_organ_1527',
      //   'id': '1527',
      //   'name': '军队纪委监委',
      //   'parentId': '1521'
      // },
      // {
      //   'code': 'clue_handle_organ_1528',
      //   'id': '1528',
      //   'name': '中央纪委国家监委派驻纪检监察组',
      //   'parentId': '1521'
      // },
      {
        'code': 'clue_handle_organ_1529',
        'id': '1529',
        'name': '省区市纪委监委派驻纪检监察组',
        'parentId': '1521'
      },
      {
        'code': 'clue_handle_organ_1530',
        'id': '1530',
        'name': '地市州盟纪委监委派驻纪检监察组',
        'parentId': '1521'
      },
      {
        'code': 'clue_handle_organ_1531',
        'id': '1531',
        'name': '县市区旗纪委监委派驻纪检监察组',
        'parentId': '1521'
      },
      {
        'code': 'clue_handle_organ_1532',
        'id': '1532',
        'name': '企业单位纪检监察机构',
        'parentId': '1521'
      },
      {
        'code': 'clue_handle_organ_1533',
        'id': '1533',
        'name': '事业单位纪检监察机构',
        'parentId': '1521'
      },
      {
        'code': 'clue_handle_organ_1534',
        'id': '1534',
        'name': '机关纪委',
        'parentId': '1521'
      },
      {
        'code': 'clue_handle_organ_1535',
        'id': '1535',
        'name': '其他',
        'parentId': '1521'
      }
    ],
    'code': 'clue_handle_organ',
    'id': '1521',
    'name': '线索办理机关',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'sc_case_organ_1537',
        'id': '1537',
        'name': '国家监委',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1538',
        'id': '1538',
        'name': '省区市监委',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1539',
        'id': '1539',
        'name': '地市州盟监委',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1540',
        'id': '1540',
        'name': '县市区旗监委',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1541',
        'id': '1541',
        'name': '军队监委',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1542',
        'id': '1542',
        'name': '国家监委派驻监察组',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1543',
        'id': '1543',
        'name': '省区市监委派驻监察组',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1544',
        'id': '1544',
        'name': '地市州盟监委派驻监察组',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1545',
        'id': '1545',
        'name': '县市区旗监委派驻监察组',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1546',
        'id': '1546',
        'name': '企业单位监察机构',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1547',
        'id': '1547',
        'name': '事业单位监察机构',
        'parentId': '1536'
      },
      {
        'code': 'sc_case_organ_1548',
        'id': '1548',
        'name': '其他',
        'parentId': '1536'
      }
    ],
    'code': 'sc_case_organ',
    'id': '1536',
    'name': '监委立案机关',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'other_co_transfer_1553',
            'id': '1553',
            'name': '由其他纪检机构移送',
            'parentId': '1550'
          },
          {
            'code': 'other_co_transfer_1554',
            'id': '1554',
            'name': '由其他监察机构移送',
            'parentId': '1550'
          }
        ],
        'code': 'is_oco_transfer_1550',
        'id': '1550',
        'name': '是',
        'parentId': '1549'
      },
      {
        'code': 'is_oco_transfer_1551',
        'id': '1551',
        'name': '否',
        'parentId': '1549'
      }
    ],
    'code': 'is_oco_transfer',
    'id': '1549',
    'name': '是否其他纪检监察机关立案后移送',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'is_eight_point_1556',
        'id': '1556',
        'name': '是',
        'parentId': '1555'
      },
      {
        'code': 'is_eight_point_1557',
        'id': '1557',
        'name': '否',
        'parentId': '1555'
      }
    ],
    'code': 'is_eight_point',
    'id': '1555',
    'name': '是否违反中央八项规定精神',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'ccp_representative_1561',
        'id': '1561',
        'name': '否',
        'parentId': '1559'
      },
      {
        'code': 'ccp_representative_1562',
        'id': '1562',
        'name': '全国党代会代表',
        'parentId': '1559'
      },
      {
        'code': 'ccp_representative_1563',
        'id': '1563',
        'name': '省级党代会代表',
        'parentId': '1559'
      },
      {
        'code': 'ccp_representative_1564',
        'id': '1564',
        'name': '市级党代会代表',
        'parentId': '1559'
      },
      {
        'code': 'ccp_representative_1565',
        'id': '1565',
        'name': '县级党代会代表',
        'parentId': '1559'
      },
      {
        'code': 'ccp_representative_1566',
        'id': '1566',
        'name': '乡级党代会代表',
        'parentId': '1559'
      }
    ],
    'code': 'ccp_representative',
    'id': '1559',
    'name': '中共党代表',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'other_crime_1570',
            'id': '1570',
            'name': '非公职人员职务侵占',
            'parentId': '1568'
          },
          {
            'code': 'other_crime_1571',
            'id': '1571',
            'name': '非公职人员挪用资金',
            'parentId': '1568'
          },
          {
            'code': 'other_crime_1572',
            'id': '1572',
            'name': '其他侵犯财产行为',
            'parentId': '1568'
          }
        ],
        'code': 'other_crime_1568',
        'id': '1568',
        'name': '侵犯财产',
        'parentId': '1567'
      },
      {
        'code': 'other_crime_1569',
        'id': '1569',
        'name': '其他',
        'parentId': '1567'
      },
      {
        'children': [
          {
            'code': 'other_crime_1634',
            'id': '1634',
            'name': '非国家工作人员受贿',
            'parentId': '1633'
          },
          {
            'code': 'other_crime_1635',
            'id': '1635',
            'name': '私设小金库',
            'parentId': '1633'
          },
          {
            'code': 'other_crime_1636',
            'id': '1636',
            'name': '其他破坏社会主义经济秩序行为',
            'parentId': '1633'
          }
        ],
        'code': 'other_crime_1633',
        'id': '1633',
        'name': '破坏社会主义市场经济秩序',
        'parentId': '1567'
      },
      {
        'children': [
          {
            'code': 'other_crime_1639',
            'id': '1639',
            'name': '嫖娼',
            'parentId': '1637'
          },
          {
            'code': 'other_crime_1640',
            'id': '1640',
            'name': '赌博',
            'parentId': '1637'
          },
          {
            'code': 'other_crime_1641',
            'id': '1641',
            'name': '妨碍司法',
            'parentId': '1637'
          },
          {
            'code': 'other_crime_1642',
            'id': '1642',
            'name': '扰乱公共秩序',
            'parentId': '1637'
          },
          {
            'code': 'other_crime_1643',
            'id': '1643',
            'name': '违反人口与计划生育法规',
            'parentId': '1637'
          },
          {
            'code': 'other_crime_1644',
            'id': '1644',
            'name': '其他妨害社会管理秩序行为',
            'parentId': '1637'
          }
        ],
        'code': 'other_crime_1637',
        'id': '1637',
        'name': '妨害社会管理秩序',
        'parentId': '1567'
      },
      {
        'code': 'other_crime_1638',
        'id': '1638',
        'name': '侵犯公民人身权利民主权利',
        'parentId': '1567',
        'children': [
          {
            'code': 'other_crime_9259',
            'id': '9259',
            'name': '无',
            'parentId': '1567',
          }
        ],
      },
      {
        'children': [
          {
            'code': 'wjxw_9254',
            'id': '9254',
            'name': '无',
            'parentId': '9253',
            'children': [
              {
                'code': 'wjxw_9255',
                'id': '9255',
                'name': '无',
                'parentId': '9254'
              },
            ],
          }
        ],
        'code': 'wjxw_9253',
        'id': '9253',
        'name': '无',
        'parentId': '1567'
      }
    ],
    'code': 'other_crime',
    'id': '1567',
    'name': '其他违法犯罪行为',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'duty_crime_1192',
            'id': '1192',
            'name': '贪污',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1193',
            'id': '1193',
            'name': '私分国有资产',
            'parentId': '1186'
          },
          {
            'children': [
              {
                'code': 'duty_crime_1215',
                'id': '1215',
                'name': '受贿',
                'parentId': '1194'
              },
              {
                'code': 'duty_crime_1216',
                'id': '1216',
                'name': '单位受贿',
                'parentId': '1194'
              },
              {
                'code': 'duty_crime_1217',
                'id': '1217',
                'name': '利用影响力受贿',
                'parentId': '1194'
              }
            ],
            'code': 'duty_crime_1194',
            'id': '1194',
            'name': '受贿',
            'parentId': '1186'
          },
          {
            'children': [
              {
                'code': 'duty_crime_1218',
                'id': '1218',
                'name': '行贿',
                'parentId': '1195'
              },
              {
                'code': 'duty_crime_1219',
                'id': '1219',
                'name': '对有影响力的人行贿',
                'parentId': '1195'
              },
              {
                'code': 'duty_crime_1220',
                'id': '1220',
                'name': '对单位行贿',
                'parentId': '1195'
              },
              {
                'code': 'duty_crime_1221',
                'id': '1221',
                'name': '介绍行贿',
                'parentId': '1195'
              },
              {
                'code': 'duty_crime_1222',
                'id': '1222',
                'name': '单位行贿',
                'parentId': '1195'
              }
            ],
            'code': 'duty_crime_1195',
            'id': '1195',
            'name': '行贿',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1196',
            'id': '1196',
            'name': '挪用公款',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1197',
            'id': '1197',
            'name': '巨额财产来源不明',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1198',
            'id': '1198',
            'name': '其他贪污贿赂行为',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1630',
            'id': '1630',
            'name': '隐瞒境外存款',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1631',
            'id': '1631',
            'name': '集体私分',
            'parentId': '1186'
          },
          {
            'code': 'duty_crime_1632',
            'id': '1632',
            'name': '其他贪污贿赂行为',
            'parentId': '1186'
          }
        ],
        'code': 'duty_crime_1186',
        'id': '1186',
        'name': '贪污贿赂',
        'parentId': '1573'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1575',
            'id': '1575',
            'name': '非法同业经营',
            'parentId': '1574'
          },
          {
            'code': 'duty_crime_1576',
            'id': '1576',
            'name': '为亲友非法牟利',
            'parentId': '1574'
          },
          {
            'code': 'duty_crime_1577',
            'id': '1577',
            'name': '国有企事业人员失职和滥用职权',
            'parentId': '1574'
          },
          {
            'code': 'duty_crime_1578',
            'id': '1578',
            'name': '包庇犯罪分子',
            'parentId': '1574'
          },
          {
            'code': 'duty_crime_1579',
            'id': '1579',
            'name': '其他',
            'parentId': '1574'
          }
        ],
        'code': 'duty_crime_1574',
        'id': '1574',
        'name': '其他职务违法犯罪',
        'parentId': '1573'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1625',
            'id': '1625',
            'name': '滥用职权',
            'parentId': '1624'
          },
          {
            'code': 'duty_crime_1626',
            'id': '1626',
            'name': '玩忽职守',
            'parentId': '1624'
          },
          {
            'code': 'duty_crime_1627',
            'id': '1627',
            'name': '徇私舞弊',
            'parentId': '1624'
          },
          {
            'code': 'duty_crime_1628',
            'id': '1628',
            'name': '利用职权侵犯公民权利',
            'parentId': '1624'
          },
          {
            'code': 'duty_crime_1629',
            'id': '1629',
            'name': '其他渎职侵权行为',
            'parentId': '1624'
          }
        ],
        'code': 'duty_crime_1624',
        'id': '1624',
        'name': '渎职侵权',
        'parentId': '1573'
      }
    ],
    'code': 'duty_crime',
    'id': '1573',
    'name': '职务违法犯罪',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'lien_level_1581',
        'id': '1581',
        'name': '国家监委',
        'parentId': '1580'
      },
      {
        'code': 'lien_level_1582',
        'id': '1582',
        'name': '省区市监委',
        'parentId': '1580'
      },
      {
        'code': 'lien_level_1583',
        'id': '1583',
        'name': '地市州盟监委',
        'parentId': '1580'
      },
      {
        'code': 'lien_level_1584',
        'id': '1584',
        'name': '县市区旗监委',
        'parentId': '1580'
      },
      {
        'code': 'lien_level_1618',
        'id': '1618',
        'name': '其他',
        'parentId': '1580'
      }
    ],
    'code': 'lien_level',
    'id': '1580',
    'name': '采取留置措施单位级别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'lien_place_1586',
        'id': '1586',
        'name': '本监委留置场所',
        'parentId': '1585'
      },
      {
        'code': 'lien_place_1587',
        'id': '1587',
        'name': '上级监委留置场所',
        'parentId': '1585'
      },
      {
        'code': 'lien_place_1588',
        'id': '1588',
        'name': '其他',
        'parentId': '1585'
      },
      {
        'code': 'lien_place_1649',
        'id': '1649',
        'name': '看守所',
        'parentId': '1585'
      },
      {
        'code': 'lien_place_2589',
        'id': '2589',
        'name': '其他监委的留置场所',
        'parentId': '1585'
      }
    ],
    'code': 'lien_place',
    'id': '1585',
    'name': '采取留置措施地点',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'pccm_1591',
        'id': '1591',
        'name': '否',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1592',
        'id': '1592',
        'name': '中央委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1593',
        'id': '1593',
        'name': '中央候补委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1594',
        'id': '1594',
        'name': '省委委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1595',
        'id': '1595',
        'name': '省委候补委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1596',
        'id': '1596',
        'name': '市委委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1597',
        'id': '1597',
        'name': '市委候补委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1598',
        'id': '1598',
        'name': '县委委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1599',
        'id': '1599',
        'name': '县委候补委员',
        'parentId': '1589'
      },
      {
        'code': 'pccm_1600',
        'id': '1600',
        'name': '乡镇党委委员',
        'parentId': '1589'
      }
    ],
    'code': 'pccm',
    'id': '1589',
    'name': '党委委员',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'diccm_1603',
        'id': '1603',
        'name': '否',
        'parentId': '1601'
      },
      {
        'code': 'diccm_1604',
        'id': '1604',
        'name': '中央纪委委员',
        'parentId': '1601'
      },
      {
        'code': 'diccm_1605',
        'id': '1605',
        'name': '省纪委委员',
        'parentId': '1601'
      },
      {
        'code': 'diccm_1606',
        'id': '1606',
        'name': '市纪委委员',
        'parentId': '1601'
      },
      {
        'code': 'diccm_1607',
        'id': '1607',
        'name': '县纪委委员',
        'parentId': '1601'
      },
      {
        'code': 'diccm_1608',
        'id': '1608',
        'name': '乡镇纪委委员',
        'parentId': '1601'
      }
    ],
    'code': 'diccm',
    'id': '1601',
    'name': '纪委委员',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'is_party_1610',
        'id': '1610',
        'name': '是',
        'parentId': '1609'
      },
      {
        'code': 'is_party_1611',
        'id': '1611',
        'name': '否',
        'parentId': '1609'
      }
    ],
    'code': 'is_party',
    'id': '1609',
    'name': '是否党员',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'second_supervisory_1505',
            'id': '1505',
            'name': '公务员及参公管理人员',
            'parentId': '1613'
          },
          {
            'code': 'second_supervisory_1506',
            'id': '1506',
            'name': '授权或受委托从事公务人员',
            'parentId': '1613'
          },
          {
            'code': 'second_supervisory_1507',
            'id': '1507',
            'name': '国有企业管理人员',
            'parentId': '1613'
          },
          {
            'code': 'second_supervisory_1508',
            'id': '1508',
            'name': '公办事业单位管理人员',
            'parentId': '1613'
          },
          {
            'code': 'second_supervisory_1509',
            'id': '1509',
            'name': '自治组织管理人员',
            'parentId': '1613'
          },
          {
            'code': 'second_supervisory_1510',
            'id': '1510',
            'name': '其他履行公职人员',
            'parentId': '1613'
          },
          {
            'code': 'second_supervisory_1514',
            'id': '1514',
            'name': '非监察对象',
            'parentId': '1613'
          }
        ],
        'code': 'is_supervisory_1613',
        'id': '1613',
        'name': '是',
        'parentId': '1612'
      },
      {
        'code': 'is_supervisory_1614',
        'id': '1614',
        'name': '否',
        'parentId': '1612'
      }
    ],
    'code': 'is_supervisory',
    'id': '1612',
    'name': '是否国家监察对象',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'is_belong_blame_1616',
        'id': '1616',
        'name': '是',
        'parentId': '1615'
      },
      {
        'code': 'is_belong_blame_1617',
        'id': '1617',
        'name': '否',
        'parentId': '1615'
      }
    ],
    'code': 'is_belong_blame',
    'id': '1615',
    'name': '是否属于问责',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'two_details_1620',
        'id': '1620',
        'name': '党委',
        'parentId': '1619'
      },
      {
        'code': 'two_details_1621',
        'id': '1621',
        'name': '党委所属部委办局',
        'parentId': '1619'
      },
      {
        'code': 'two_details_1622',
        'id': '1622',
        'name': '政府',
        'parentId': '1619'
      },
      {
        'code': 'two_details_1623',
        'id': '1623',
        'name': '政府所属部委办局',
        'parentId': '1619'
      }
    ],
    'code': 'two_details',
    'id': '1619',
    'name': '二把手细节',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'accountability_1652',
        'id': '1652',
        'name': '是',
        'parentId': '1651'
      },
      {
        'code': 'accountability_1653',
        'id': '1653',
        'name': '否',
        'parentId': '1651'
      }
    ],
    'code': 'accountability',
    'id': '1651',
    'name': '责任追究',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'lztype_1655',
        'id': '1655',
        'name': '留置',
        'parentId': '1654'
      }
    ],
    'code': 'lztype',
    'id': '1654',
    'name': '措施种类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'diccm1_1657',
        'id': '1657',
        'name': '是',
        'parentId': '1656'
      },
      {
        'code': 'diccm1_1658',
        'id': '1658',
        'name': '否',
        'parentId': '1656'
      }
    ],
    'code': 'diccm1',
    'id': '1656',
    'name': '是否二次申诉',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'deal_type_1681',
        'id': '1681',
        'name': '原值',
        'parentId': '1680'
      },
      {
        'code': 'deal_type_1682',
        'id': '1682',
        'name': '数字',
        'parentId': '1680'
      },
      {
        'code': 'deal_type_1683',
        'id': '1683',
        'name': '日期',
        'parentId': '1680'
      },
      {
        'code': 'deal_type_1684',
        'id': '1684',
        'name': '加密',
        'parentId': '1680'
      }
    ],
    'code': 'deal_type',
    'id': '1680',
    'name': '处理方式',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'link_type_1686',
        'id': '1686',
        'name': '线索',
        'parentId': '1685'
      },
      {
        'code': 'link_type_1687',
        'id': '1687',
        'name': '初核',
        'parentId': '1685'
      },
      {
        'code': 'link_type_1688',
        'id': '1688',
        'name': '立案',
        'parentId': '1685'
      },
      {
        'code': 'link_type_1689',
        'id': '1689',
        'name': '申诉',
        'parentId': '1685'
      },
      {
        'code': 'link_type_1690',
        'id': '1690',
        'name': '留置',
        'parentId': '1685'
      },
      {
        'code': 'link_type_1999',
        'id': '1999',
        'name': '通用',
        'parentId': '1685'
      },
      {
        'code': 'link_type_2918',
        'id': '2918',
        'name': '谈话函询',
        'parentId': '1685'
      }
    ],
    'code': 'link_type',
    'id': '1685',
    'name': '所属模块',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'status_1692',
        'id': '1692',
        'name': '是',
        'parentId': '1691'
      },
      {
        'code': 'status_1693',
        'id': '1693',
        'name': '否',
        'parentId': '1691'
      }
    ],
    'code': 'status',
    'id': '1691',
    'name': '是否显示',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'permission_rule_1695',
        'id': '1695',
        'name': '单位规则',
        'parentId': '1694'
      },
      {
        'code': 'permission_rule_1696',
        'id': '1696',
        'name': '部门规则',
        'parentId': '1694'
      },
      {
        'code': 'permission_rule_1697',
        'id': '1697',
        'name': '用户身份规则',
        'parentId': '1694'
      },
      {
        'code': 'permission_rule_1698',
        'id': '1698',
        'name': '用户规则',
        'parentId': '1694'
      },
      {
        'code': 'permission_rule_1699',
        'id': '1699',
        'name': '私人规则',
        'parentId': '1694'
      },
      {
        'code': 'permission_rule_1700',
        'id': '1700',
        'name': '其他规则',
        'parentId': '1694'
      }
    ],
    'code': 'permission_rule',
    'id': '1694',
    'name': '权限类型',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'second_rule_1707',
            'id': '1707',
            'name': '案管室内勤',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1708',
            'id': '1708',
            'name': '案管室工作人员',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1709',
            'id': '1709',
            'name': '案管室领导',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1710',
            'id': '1710',
            'name': '监督检查室内勤',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1711',
            'id': '1711',
            'name': '监督检查室工作人员',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1712',
            'id': '1712',
            'name': '监督检查室领导',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1713',
            'id': '1713',
            'name': '审查调查室内勤',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1714',
            'id': '1714',
            'name': '审查调查室工作人员',
            'parentId': '1702'
          },
          {
            'code': 'second_rule_1715',
            'id': '1715',
            'name': '审查调查室领导',
            'parentId': '1702'
          }
        ],
        'code': 'first_rule_1702',
        'id': '1702',
        'name': '授权管理规则',
        'parentId': '1701'
      },
      {
        'children': [
          {
            'code': 'second_rule_1716',
            'id': '1716',
            'name': '案管室',
            'parentId': '1703'
          },
          {
            'code': 'second_rule_1717',
            'id': '1717',
            'name': '监督室',
            'parentId': '1703'
          },
          {
            'code': 'second_rule_1718',
            'id': '1718',
            'name': '审查调查室',
            'parentId': '1703'
          },
          {
            'children': [
              {
                'code': 'second_rule_1728',
                'id': '1728',
                'name': '用户规则',
                'parentId': '1727'
              },
              {
                'code': 'second_rule_1729',
                'id': '1729',
                'name': '部门规则',
                'parentId': '1727'
              }
            ],
            'code': 'second_rule_1727',
            'id': '1727',
            'name': '自定义规则',
            'parentId': '1703'
          }
        ],
        'code': 'first_rule_1703',
        'id': '1703',
        'name': '流程管理规则',
        'parentId': '1701'
      },
      {
        'code': 'first_rule_1704',
        'id': '1704',
        'name': '标签使用规则',
        'parentId': '1701'
      },
      {
        'code': 'first_rule_1705',
        'id': '1705',
        'name': '文书使用规则',
        'parentId': '1701'
      }
    ],
    'code': 'first_rule',
    'id': '1701',
    'name': '授权规则',
    'parentId': '0'
  },
  {
    'code': 'second_rule',
    'id': '1706',
    'name': '规则明细',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'rule_type_1720',
        'id': '1720',
        'name': '用户类型',
        'parentId': '1719'
      },
      {
        'code': 'rule_type_1721',
        'id': '1721',
        'name': '单位类型',
        'parentId': '1719'
      },
      {
        'code': 'rule_type_1722',
        'id': '1722',
        'name': '部门类型',
        'parentId': '1719'
      }
    ],
    'code': 'rule_type',
    'id': '1719',
    'name': '授权对象类型',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'source_type_1724',
        'id': '1724',
        'name': '用户类型',
        'parentId': '1723'
      },
      {
        'code': 'source_type_1725',
        'id': '1725',
        'name': '部门类型',
        'parentId': '1723'
      },
      {
        'code': 'source_type_1726',
        'id': '1726',
        'name': '单位类型',
        'parentId': '1723'
      }
    ],
    'code': 'source_type',
    'id': '1723',
    'name': '被授权对象类型',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'document_permission_1731',
        'id': '1731',
        'name': '部门私有',
        'parentId': '1730'
      },
      {
        'code': 'document_permission_1733',
        'id': '1733',
        'name': '全市（盟）公用',
        'parentId': '1730'
      },
      {
        'code': 'document_permission_1732',
        'id': '1732',
        'name': '全省（区）公用',
        'parentId': '1730'
      },
      {
        'code': 'document_permission_1734',
        'id': '1734',
        'name': '全县（旗）公用',
        'parentId': '1730'
      }
    ],
    'code': 'document_permission',
    'id': '1730',
    'name': '文书权限',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'duty_crime_1_1806',
            'id': '1806',
            'name': '贪污',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1807',
            'id': '1807',
            'name': '挪用公款',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1808',
            'id': '1808',
            'name': '受贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1809',
            'id': '1809',
            'name': '单位受贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1810',
            'id': '1810',
            'name': '利用影响力受贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1811',
            'id': '1811',
            'name': '非国家工作人员受贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1812',
            'id': '1812',
            'name': '行贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1813',
            'id': '1813',
            'name': '对有影响力的人行贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1814',
            'id': '1814',
            'name': '对单位行贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1815',
            'id': '1815',
            'name': '介绍贿赂',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1816',
            'id': '1816',
            'name': '单位行贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1817',
            'id': '1817',
            'name': '对非国家工作人员行贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1818',
            'id': '1818',
            'name': '对外国公职人员、国际公共组织官员行贿',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1819',
            'id': '1819',
            'name': '巨额财产来源不明',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1820',
            'id': '1820',
            'name': '隐瞒境外存款',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1821',
            'id': '1821',
            'name': '私分国有资产',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1822',
            'id': '1822',
            'name': '私分罚没财物',
            'parentId': '1800'
          },
          {
            'code': 'duty_crime_1_1823',
            'id': '1823',
            'name': '其他',
            'parentId': '1800'
          }
        ],
        'code': 'duty_crime_1_1800',
        'id': '1800',
        'name': '贪污贿赂',
        'parentId': '1799'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1_1824',
            'id': '1824',
            'name': '滥用职权',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1825',
            'id': '1825',
            'name': '滥用管理公司、证券职权',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1826',
            'id': '1826',
            'name': '食品监管渎职',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1827',
            'id': '1827',
            'name': '故意泄露国家秘密',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1828',
            'id': '1828',
            'name': '阻碍解救被拐卖、绑架妇女、儿童',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1829',
            'id': '1829',
            'name': '帮助犯罪分子逃避处罚',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1830',
            'id': '1830',
            'name': '违法发放林木采伐许可证',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1831',
            'id': '1831',
            'name': '办理偷越国（边）境人员出入境证件',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1832',
            'id': '1832',
            'name': '放行偷越国（边）境人员',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1833',
            'id': '1833',
            'name': '国有公司、企业、事业单位人员滥用职权',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1834',
            'id': '1834',
            'name': '报复陷害',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1835',
            'id': '1835',
            'name': '非法剥夺公民宗教信仰自由',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1836',
            'id': '1836',
            'name': '侵犯少数民族风俗习惯',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1837',
            'id': '1837',
            'name': '打击报复会计、统计人员',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1838',
            'id': '1838',
            'name': '挪用特定款物',
            'parentId': '1801'
          },
          {
            'code': 'duty_crime_1_1839',
            'id': '1839',
            'name': '其他',
            'parentId': '1801'
          }
        ],
        'code': 'duty_crime_1_1801',
        'id': '1801',
        'name': '滥用职权',
        'parentId': '1799'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1_1840',
            'id': '1840',
            'name': '玩忽职守',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1841',
            'id': '1841',
            'name': '国家机关工作人员签订、履行合同失职被骗',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1842',
            'id': '1842',
            'name': '环境监管失职',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1843',
            'id': '1843',
            'name': '传染病防治失职',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1844',
            'id': '1844',
            'name': '商检失职',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1845',
            'id': '1845',
            'name': '动植物检疫失职',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1846',
            'id': '1846',
            'name': '不解救被拐卖、绑架妇女、儿童',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1847',
            'id': '1847',
            'name': '失职造成珍贵文物损毁、流失',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1848',
            'id': '1848',
            'name': '过失泄露国家秘密',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1849',
            'id': '1849',
            'name': '国有公司、企业、事业单位人员失职',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1850',
            'id': '1850',
            'name': '签订、履行合同失职被骗',
            'parentId': '1802'
          },
          {
            'code': 'duty_crime_1_1851',
            'id': '1851',
            'name': '其他',
            'parentId': '1802'
          }
        ],
        'code': 'duty_crime_1_1802',
        'id': '1802',
        'name': '玩忽职守',
        'parentId': '1799'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1_1852',
            'id': '1852',
            'name': '非法批准征收、征用、占用土地',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1853',
            'id': '1853',
            'name': '非法低价出让国有土地使用权',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1854',
            'id': '1854',
            'name': '枉法仲裁',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1855',
            'id': '1855',
            'name': '徇私舞弊发售发票、抵扣税款、出口退税',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1856',
            'id': '1856',
            'name': '商检徇私舞弊',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1857',
            'id': '1857',
            'name': '动植物检疫徇私舞弊',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1858',
            'id': '1858',
            'name': '放纵走私',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1859',
            'id': '1859',
            'name': '放纵制售伪劣商品犯罪行为',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1860',
            'id': '1860',
            'name': '招收公务员、学生徇私舞弊',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1861',
            'id': '1861',
            'name': '徇私舞弊不移交刑事案件',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1862',
            'id': '1862',
            'name': '违法提供出口退税凭证',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1863',
            'id': '1863',
            'name': '徇私舞弊不征、少征税款',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1864',
            'id': '1864',
            'name': '徇私舞弊低价折股、出售国有资产',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1865',
            'id': '1865',
            'name': '非法经营同类营业',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1866',
            'id': '1866',
            'name': '为亲友非法牟利',
            'parentId': '1803'
          },
          {
            'code': 'duty_crime_1_1867',
            'id': '1867',
            'name': '其他',
            'parentId': '1803'
          }
        ],
        'code': 'duty_crime_1_1803',
        'id': '1803',
        'name': '徇私舞弊',
        'parentId': '1799'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1_1868',
            'id': '1868',
            'name': '重大责任事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1869',
            'id': '1869',
            'name': '教育设施重大安全事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1870',
            'id': '1870',
            'name': '消防责任事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1871',
            'id': '1871',
            'name': '重大劳动安全事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1872',
            'id': '1872',
            'name': '强令违章冒险作业',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1873',
            'id': '1873',
            'name': '不报、谎报安全事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1874',
            'id': '1874',
            'name': '铁路运营安全事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1875',
            'id': '1875',
            'name': '重大飞行事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1876',
            'id': '1876',
            'name': '大型群众性活动重大安全事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1877',
            'id': '1877',
            'name': '危险物品肇事',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1878',
            'id': '1878',
            'name': '工程重大安全事故',
            'parentId': '1804'
          },
          {
            'code': 'duty_crime_1_1879',
            'id': '1879',
            'name': '其他',
            'parentId': '1804'
          }
        ],
        'code': 'duty_crime_1_1804',
        'id': '1804',
        'name': '重大责任事故',
        'parentId': '1799'
      },
      {
        'children': [
          {
            'code': 'duty_crime_1_1880',
            'id': '1880',
            'name': '背信损害上市公司利益',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1881',
            'id': '1881',
            'name': '金融工作人员购买假币、以假币换取货币',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1882',
            'id': '1882',
            'name': '利用未公开信息交易',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1883',
            'id': '1883',
            'name': '诱骗投资者买卖证券、期货合约',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1884',
            'id': '1884',
            'name': '背信运用受托财产',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1885',
            'id': '1885',
            'name': '违法运用资金',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1886',
            'id': '1886',
            'name': '违法发放贷款',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1887',
            'id': '1887',
            'name': '吸收客户资金不入账',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1888',
            'id': '1888',
            'name': '违规出具金融票证',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1889',
            'id': '1889',
            'name': '对违法票据承兑、付款、保证',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1890',
            'id': '1890',
            'name': '非法转让、倒卖土地使用权',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1891',
            'id': '1891',
            'name': '职务侵占',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1892',
            'id': '1892',
            'name': '挪用资金',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1893',
            'id': '1893',
            'name': '破坏选举',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1894',
            'id': '1894',
            'name': '私自开拆、隐匿、毁弃邮件、电报',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1895',
            'id': '1895',
            'name': '故意延误投递邮件',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1896',
            'id': '1896',
            'name': '泄露不应公开的案件信息',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1897',
            'id': '1897',
            'name': '披露、报道不应公开的案件信息',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1898',
            'id': '1898',
            'name': '接送不合格兵员',
            'parentId': '1805'
          },
          {
            'code': 'duty_crime_1_1899',
            'id': '1899',
            'name': '其他',
            'parentId': '1805'
          }
        ],
        'code': 'duty_crime_1_1805',
        'id': '1805',
        'name': '行使公权力过程中发生的其他犯罪行为',
        'parentId': '1799'
      },
      {
        'children': [
          {
            'code': 'wjxw_9257',
            'id': '9257',
            'name': '无',
            'parentId': '9256',
            'children': [
              {
                'code': 'wjxw_9258',
                'id': '9258',
                'name': '无',
                'parentId': '9257'
              },
            ],
          }
        ],
        'code': 'wjxw_9256',
        'id': '9256',
        'name': '无',
        'parentId': '1799'
      }
    ],
    'code': 'duty_crime_1',
    'id': '1799',
    'name': '职务违法犯罪',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'overdue_type_1901',
        'id': '1901',
        'name': '线索',
        'parentId': '1900'
      },
      {
        'code': 'overdue_type_1902',
        'id': '1902',
        'name': '初核',
        'parentId': '1900'
      },
      {
        'code': 'overdue_type_1903',
        'id': '1903',
        'name': '立案',
        'parentId': '1900'
      },
      {
        'code': 'overdue_type_1904',
        'id': '1904',
        'name': '留置',
        'parentId': '1900'
      }
    ],
    'code': 'overdue_type',
    'id': '1900',
    'name': '超期类型',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'earlywarning_level_1906',
        'id': '1906',
        'name': '一级预警',
        'parentId': '1905'
      },
      {
        'code': 'earlywarning_level_1907',
        'id': '1907',
        'name': '二级预警',
        'parentId': '1905'
      },
      {
        'code': 'earlywarning_level_1908',
        'id': '1908',
        'name': '三级预警',
        'parentId': '1905'
      }
    ],
    'code': 'earlywarning_level',
    'id': '1905',
    'name': '预警级别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'handleResult_1910',
        'id': '1910',
        'name': '立案审查调查',
        'parentId': '1909'
      },
      {
        'code': 'handleResult_1911',
        'id': '1911',
        'name': '暂存待查',
        'parentId': '1909'
      },
      {
        'code': 'handleResult_1912',
        'id': '1912',
        'name': '了结',
        'parentId': '1909'
      },
      {
        'code': 'handleResult_2917',
        'id': '2917',
        'name': '移送有关党组织',
        'parentId': '1909'
      },
      {
        'code': 'handleResult_2916',
        'id': '2916',
        'name': '谈话提醒',
        'parentId': '1909'
      }
    ],
    'code': 'handleResult',
    'id': '1909',
    'name': '核实结果',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'is_active_explanation_2914',
        'id': '2914',
        'name': '是',
        'parentId': '2913'
      },
      {
        'code': 'is_active_explanation_2915',
        'id': '2915',
        'name': '否',
        'parentId': '2913'
      }
    ],
    'code': 'is_active_explanation',
    'id': '2913',
    'name': '是否主动交代问题',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'wjlx_59',
            'id': '59',
            'name': '嫖娼',
            'parentId': '11'
          },
          {
            'code': 'wjlx_60',
            'id': '60',
            'name': '赌博',
            'parentId': '11'
          },
          {
            'code': 'wjlx_61',
            'id': '61',
            'name': '妨碍执行公务',
            'parentId': '11'
          },
          {
            'code': 'wjlx_62',
            'id': '62',
            'name': '扰乱公共秩序',
            'parentId': '11'
          },
          {
            'code': 'wjlx_63',
            'id': '63',
            'name': '违反人口与计划生育法规',
            'parentId': '11'
          },
          {
            'children': [
              {
                'code': 'wjlx_211',
                'id': '211',
                'name': '色情活动',
                'parentId': '64'
              },
              {
                'code': 'wjlx_212',
                'id': '212',
                'name': '制黄贩黄',
                'parentId': '64'
              },
              {
                'code': 'wjlx_213',
                'id': '213',
                'name': '观看淫秽影视书画表演',
                'parentId': '64'
              },
              {
                'code': 'wjlx_214',
                'id': '214',
                'name': '淫乱活动',
                'parentId': '64'
              },
              {
                'code': 'wjlx_215',
                'id': '215',
                'name': '猥亵侮辱妇女',
                'parentId': '64'
              },
              {
                'code': 'wjlx_216',
                'id': '216',
                'name': '吸毒贩毒',
                'parentId': '64'
              },
              {
                'code': 'wjlx_217',
                'id': '217',
                'name': '侵犯公私财产',
                'parentId': '64'
              },
              {
                'code': 'wjlx_218',
                'id': '218',
                'name': '伪造买卖使用假公文证件',
                'parentId': '64'
              },
              {
                'code': 'wjlx_219',
                'id': '219',
                'name': '违反保护环境资源文物等法律法规',
                'parentId': '64'
              },
              {
                'code': 'wjlx_220',
                'id': '220',
                'name': '编造散播虚假有害信息',
                'parentId': '64'
              },
              {
                'code': 'wjlx_221',
                'id': '221',
                'name': '非法侵入计算机系统',
                'parentId': '64'
              },
              {
                'code': 'wjlx_222',
                'id': '222',
                'name': '包庇犯罪分子',
                'parentId': '64'
              },
              {
                'code': 'wjlx_223',
                'id': '223',
                'name': '包庇恐怖分子',
                'parentId': '64'
              },
              {
                'code': 'wjlx_224',
                'id': '224',
                'name': '包庇黑社会组织成员',
                'parentId': '64'
              },
              {
                'code': 'wjlx_225',
                'id': '225',
                'name': '包庇违纪人员',
                'parentId': '64'
              },
              {
                'code': 'wjlx_226',
                'id': '226',
                'name': '被蒙骗为犯罪行为提供便利',
                'parentId': '64'
              },
              {
                'code': 'wjlx_227',
                'id': '227',
                'name': '违反驻在国法律法规',
                'parentId': '64'
              },
              {
                'code': 'wjlx_228',
                'id': '228',
                'name': '偷越国（边）境',
                'parentId': '64'
              },
              {
                'code': 'wjlx_229',
                'id': '229',
                'name': '其他妨害社会管理秩序行为',
                'parentId': '64'
              }
            ],
            'code': 'wjlx_64',
            'id': '64',
            'name': '妨害其他社会管理秩序',
            'parentId': '11'
          }
        ],
        'code': 'wjlx_11',
        'id': '11',
        'name': '妨害社会管理秩序',
        'parentId': '1'
      },
      {
        'code': 'wjlx_12',
        'id': '12',
        'name': '其他违纪行为',
        'parentId': '1'
      },
      {
        'children': [
          {
            'code': 'wjlx_13',
            'id': '13',
            'name': '组织参加支持反党活动',
            'parentId': '2'
          },
          {
            'code': 'wjlx_14',
            'id': '14',
            'name': '发表刊登有政治问题的文章',
            'parentId': '2'
          },
          {
            'children': [
              {
                'code': 'wjlx_65',
                'id': '65',
                'name': '组织领导或参加反动组织',
                'parentId': '15'
              },
              {
                'code': 'wjlx_66',
                'id': '66',
                'name': '组织领导或参加邪教组织',
                'parentId': '15'
              }
            ],
            'code': 'wjlx_15',
            'id': '15',
            'name': '参加非法组织',
            'parentId': '2'
          },
          {
            'code': 'wjlx_16',
            'id': '16',
            'name': '不执行党和国家方针政策',
            'parentId': '2'
          },
          {
            'code': 'wjlx_17',
            'id': '17',
            'name': '非法提供情报',
            'parentId': '2'
          },
          {
            'code': 'wjlx_18',
            'id': '18',
            'name': '叛逃出走',
            'parentId': '2'
          },
          {
            'children': [
              {
                'code': 'wjlx_67',
                'id': '67',
                'name': '携带反动出版物入境',
                'parentId': '19'
              },
              {
                'code': 'wjlx_68',
                'id': '68',
                'name': '组织参加秘密集团',
                'parentId': '19'
              },
              {
                'code': 'wjlx_69',
                'id': '69',
                'name': '违反民族政策',
                'parentId': '19'
              },
              {
                'code': 'wjlx_70',
                'id': '70',
                'name': '违反宗教政策',
                'parentId': '19'
              },
              {
                'code': 'wjlx_71',
                'id': '71',
                'name': '利用宗族势力反党',
                'parentId': '19'
              },
              {
                'code': 'wjlx_72',
                'id': '72',
                'name': '造谣传播丑化党和国家形象',
                'parentId': '19'
              },
              {
                'code': 'wjlx_73',
                'id': '73',
                'name': '涉外活动造成恶劣政治影响',
                'parentId': '19'
              },
              {
                'code': 'wjlx_74',
                'id': '74',
                'name': '其他违反政治纪律行为',
                'parentId': '19'
              }
            ],
            'code': 'wjlx_19',
            'id': '19',
            'name': '违反其他政治纪律',
            'parentId': '2'
          }
        ],
        'code': 'wjlx_2',
        'id': '2',
        'name': '违反政治纪律',
        'parentId': '1'
      },
      {
        'children': [
          {
            'code': 'wjlx_20',
            'id': '20',
            'name': '违反民主集中制',
            'parentId': '3'
          },
          {
            'children': [
              {
                'code': 'wjlx_75',
                'id': '75',
                'name': '违反干部选拨任用规定',
                'parentId': '21'
              },
              {
                'code': 'wjlx_76',
                'id': '76',
                'name': '违反党和国家法规',
                'parentId': '21'
              },
              {
                'code': 'wjlx_77',
                'id': '77',
                'name': '用人失察',
                'parentId': '21'
              }
            ],
            'code': 'wjlx_21',
            'id': '21',
            'name': '违反干部选拔任用制度',
            'parentId': '3'
          },
          {
            'children': [
              {
                'code': 'wjlx_78',
                'id': '78',
                'name': '违规发展党员',
                'parentId': '22'
              },
              {
                'code': 'wjlx_79',
                'id': '79',
                'name': '搞非组织活动',
                'parentId': '22'
              },
              {
                'code': 'wjlx_80',
                'id': '80',
                'name': '不执行组织分配调动交流',
                'parentId': '22'
              },
              {
                'code': 'wjlx_81',
                'id': '81',
                'name': '违反干部人事劳动规定谋取利益',
                'parentId': '22'
              },
              {
                'code': 'wjlx_82',
                'id': '82',
                'name': '考试录取中弄虚作假',
                'parentId': '22'
              },
              {
                'code': 'wjlx_83',
                'id': '83',
                'name': '以不正当方式谋求公款出国（境）',
                'parentId': '22'
              },
              {
                'code': 'wjlx_84',
                'id': '84',
                'name': '擅改出国（境）计划',
                'parentId': '22'
              },
              {
                'code': 'wjlx_85',
                'id': '85',
                'name': '擅离组织或违规交往',
                'parentId': '22'
              },
              {
                'code': 'wjlx_86',
                'id': '86',
                'name': '脱离组织出走',
                'parentId': '22'
              },
              {
                'code': 'wjlx_87',
                'id': '87',
                'name': '为出走提供方便',
                'parentId': '22'
              },
              {
                'code': 'wjlx_88',
                'id': '88',
                'name': '其他违反组织人事纪律行为',
                'parentId': '22'
              }
            ],
            'code': 'wjlx_22',
            'id': '22',
            'name': '违反其他组织人事纪律',
            'parentId': '3'
          }
        ],
        'code': 'wjlx_3',
        'id': '3',
        'name': '违反组织人事纪律',
        'parentId': '1'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjlx_89',
                'id': '89',
                'name': '非法占有非本人经管财务',
                'parentId': '23'
              },
              {
                'code': 'wjlx_90',
                'id': '90',
                'name': '违规报销个人费用',
                'parentId': '23'
              },
              {
                'code': 'wjlx_91',
                'id': '91',
                'name': '违规报销近亲属出国费用',
                'parentId': '23'
              },
              {
                'code': 'wjlx_92',
                'id': '92',
                'name': '非法占有公物',
                'parentId': '23'
              },
              {
                'code': 'wjlx_93',
                'id': '93',
                'name': '占用公物营利或非法活动',
                'parentId': '23'
              }
            ],
            'code': 'wjlx_23',
            'id': '23',
            'name': '非法占有',
            'parentId': '4'
          },
          {
            'children': [
              {
                'code': 'wjlx_94',
                'id': '94',
                'name': '接受礼品馈赠',
                'parentId': '24'
              },
              {
                'code': 'wjlx_95',
                'id': '95',
                'name': '亲属收受财物',
                'parentId': '24'
              },
              {
                'code': 'wjlx_96',
                'id': '96',
                'name': '第三人收受财物',
                'parentId': '24'
              }
            ],
            'code': 'wjlx_24',
            'id': '24',
            'name': '受礼',
            'parentId': '4'
          },
          {
            'code': 'wjlx_25',
            'id': '25',
            'name': '违反从业限制规定',
            'parentId': '4'
          },
          {
            'children': [
              {
                'code': 'wjlx_97',
                'id': '97',
                'name': '违规经商办企业',
                'parentId': '26'
              },
              {
                'code': 'wjlx_98',
                'id': '98',
                'name': '违规从事证券投资',
                'parentId': '26'
              },
              {
                'code': 'wjlx_99',
                'id': '99',
                'name': '有偿中介活动',
                'parentId': '26'
              },
              {
                'code': 'wjlx_100',
                'id': '100',
                'name': '国（境）外投资',
                'parentId': '26'
              },
              {
                'code': 'wjlx_101',
                'id': '101',
                'name': '为亲友经营活动谋利',
                'parentId': '26'
              },
              {
                'code': 'wjlx_102',
                'id': '102',
                'name': '违规兼职',
                'parentId': '26'
              },
              {
                'code': 'wjlx_103',
                'id': '103',
                'name': '其他违规营利活动',
                'parentId': '26'
              }
            ],
            'code': 'wjlx_26',
            'id': '26',
            'name': '违规从事营利活动',
            'parentId': '4'
          },
          {
            'children': [
              {
                'code': 'wjlx_104',
                'id': '104',
                'name': '公款旅游',
                'parentId': '27'
              },
              {
                'code': 'wjlx_105',
                'id': '105',
                'name': '公款高消费娱乐',
                'parentId': '27'
              },
              {
                'code': 'wjlx_106',
                'id': '106',
                'name': '违规配备使用小汽车',
                'parentId': '27'
              },
              {
                'code': 'wjlx_107',
                'id': '107',
                'name': '其他挥霍浪费公共财产行为',
                'parentId': '27'
              }
            ],
            'code': 'wjlx_27',
            'id': '27',
            'name': '挥霍浪费公共财产',
            'parentId': '4'
          },
          {
            'children': [
              {
                'code': 'wjlx_108',
                'id': '108',
                'name': '其他违规营利活动',
                'parentId': '28'
              },
              {
                'code': 'wjlx_109',
                'id': '109',
                'name': '违规接受宴请',
                'parentId': '28'
              },
              {
                'code': 'wjlx_110',
                'id': '110',
                'name': '违规操办婚丧喜庆事宜',
                'parentId': '28'
              },
              {
                'code': 'wjlx_111',
                'id': '111',
                'name': '其他违反廉洁自律规定行为',
                'parentId': '28'
              },
              {
                'code': 'wjlx_813',
                'id': '813',
                'name': '违反住房规定',
                'parentId': '28'
              }
            ],
            'code': 'wjlx_28',
            'id': '28',
            'name': '违反其他廉洁自律规定',
            'parentId': '4'
          }
        ],
        'code': 'wjlx_4',
        'id': '4',
        'name': '违反廉洁自律规定',
        'parentId': '1'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjlx_112',
                'id': '112',
                'name': '党和国家工作人员贪污',
                'parentId': '29'
              },
              {
                'code': 'wjlx_113',
                'id': '113',
                'name': '贪污特殊款物',
                'parentId': '29'
              },
              {
                'code': 'wjlx_114',
                'id': '114',
                'name': '不按规定上交礼品',
                'parentId': '29'
              },
              {
                'code': 'wjlx_115',
                'id': '115',
                'name': '基层组织党员贪污',
                'parentId': '29'
              },
              {
                'code': 'wjlx_116',
                'id': '116',
                'name': '公款购房归个人所有',
                'parentId': '29'
              }
            ],
            'code': 'wjlx_29',
            'id': '29',
            'name': '贪污',
            'parentId': '5'
          },
          {
            'children': [
              {
                'code': 'wjlx_117',
                'id': '117',
                'name': '集体私分国有资产',
                'parentId': '30'
              },
              {
                'code': 'wjlx_118',
                'id': '118',
                'name': '集体私分罚没财物',
                'parentId': '30'
              },
              {
                'code': 'wjlx_119',
                'id': '119',
                'name': '集体私分应交礼品',
                'parentId': '30'
              }
            ],
            'code': 'wjlx_30',
            'id': '30',
            'name': '私分国有资产',
            'parentId': '5'
          },
          {
            'children': [
              {
                'code': 'wjlx_120',
                'id': '120',
                'name': '索贿受贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_121',
                'id': '121',
                'name': '索贿未遂刁难报复',
                'parentId': '31'
              },
              {
                'code': 'wjlx_122',
                'id': '122',
                'name': '违规收受回扣手续费',
                'parentId': '31'
              },
              {
                'code': 'wjlx_123',
                'id': '123',
                'name': '利用他人职务行为受贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_124',
                'id': '124',
                'name': '通过亲属受贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_125',
                'id': '125',
                'name': '退（离）休人员利用职务影响受贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_126',
                'id': '126',
                'name': '单位受贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_127',
                'id': '127',
                'name': '基层组织党员受贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_128',
                'id': '128',
                'name': '行贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_129',
                'id': '129',
                'name': '对单位行贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_130',
                'id': '130',
                'name': '单位行贿',
                'parentId': '31'
              },
              {
                'code': 'wjlx_131',
                'id': '131',
                'name': '介绍贿赂',
                'parentId': '31'
              }
            ],
            'code': 'wjlx_31',
            'id': '31',
            'name': '贿赂',
            'parentId': '5'
          },
          {
            'children': [
              {
                'code': 'wjlx_132',
                'id': '132',
                'name': '党和国家工作人员挪用公款',
                'parentId': '32'
              },
              {
                'code': 'wjlx_133',
                'id': '133',
                'name': '基层组织党员挪用公款',
                'parentId': '32'
              }
            ],
            'code': 'wjlx_32',
            'id': '32',
            'name': '挪用公款',
            'parentId': '5'
          },
          {
            'code': 'wjlx_33',
            'id': '33',
            'name': '巨额财产来源不明',
            'parentId': '5'
          },
          {
            'code': 'wjlx_34',
            'id': '34',
            'name': '其他贪污贿赂',
            'parentId': '5'
          }
        ],
        'code': 'wjlx_5',
        'id': '5',
        'name': '贪污贿赂',
        'parentId': '1'
      },
      {
        'children': [
          {
            'children': [
              {
                'code': 'wjlx_134',
                'id': '134',
                'name': '非国家工作人员挪用资金',
                'parentId': '35'
              },
              {
                'code': 'wjlx_135',
                'id': '135',
                'name': '单位挪用资金',
                'parentId': '35'
              }
            ],
            'code': 'wjlx_35',
            'id': '35',
            'name': '挪用资金',
            'parentId': '6'
          },
          {
            'children': [
              {
                'code': 'wjlx_136',
                'id': '136',
                'name': '非国家工作人员索取收受财物',
                'parentId': '36'
              },
              {
                'code': 'wjlx_137',
                'id': '137',
                'name': '给予非国家工作人员财物',
                'parentId': '36'
              },
              {
                'code': 'wjlx_138',
                'id': '138',
                'name': '为亲友经营牟利',
                'parentId': '36'
              }
            ],
            'code': 'wjlx_36',
            'id': '36',
            'name': '妨害公司企业管理秩序',
            'parentId': '6'
          },
          {
            'code': 'wjlx_37',
            'id': '37',
            'name': '违反金融管理法规',
            'parentId': '6'
          },
          {
            'children': [
              {
                'code': 'wjlx_139',
                'id': '139',
                'name': '不履行纳税义务',
                'parentId': '38'
              },
              {
                'code': 'wjlx_140',
                'id': '140',
                'name': '违反票据管理规定',
                'parentId': '38'
              }
            ],
            'code': 'wjlx_38',
            'id': '38',
            'name': '违反税收管理法规',
            'parentId': '6'
          },
          {
            'code': 'wjlx_39',
            'id': '39',
            'name': '违反土地管理法规',
            'parentId': '6'
          },
          {
            'children': [
              {
                'code': 'wjlx_141',
                'id': '141',
                'name': '制售假冒伪劣产品',
                'parentId': '40'
              },
              {
                'code': 'wjlx_142',
                'id': '142',
                'name': '违规进行证券期货交易',
                'parentId': '40'
              },
              {
                'code': 'wjlx_143',
                'id': '143',
                'name': '不正当手段竞争',
                'parentId': '40'
              }
            ],
            'code': 'wjlx_40',
            'id': '40',
            'name': '扰乱市场经济活动',
            'parentId': '6'
          },
          {
            'children': [
              {
                'code': 'wjlx_144',
                'id': '144',
                'name': '走私',
                'parentId': '41'
              },
              {
                'code': 'wjlx_145',
                'id': '145',
                'name': '职务侵占',
                'parentId': '41'
              },
              {
                'code': 'wjlx_146',
                'id': '146',
                'name': '非法经营同类业务',
                'parentId': '41'
              },
              {
                'code': 'wjlx_147',
                'id': '147',
                'name': '党和国家机关违规办企业',
                'parentId': '41'
              },
              {
                'code': 'wjlx_148',
                'id': '148',
                'name': '中介组织出具虚假文件',
                'parentId': '41'
              },
              {
                'code': 'wjlx_149',
                'id': '149',
                'name': '其他破坏经济秩序行为',
                'parentId': '41'
              }
            ],
            'code': 'wjlx_41',
            'id': '41',
            'name': '其他破坏社会主义经济秩序',
            'parentId': '6'
          }
        ],
        'code': 'wjlx_6',
        'id': '6',
        'name': '破坏社会主义经济秩序',
        'parentId': '1'
      },
      {
        'children': [
          {
            'code': 'wjlx_42',
            'id': '42',
            'name': '国有资产流失',
            'parentId': '7'
          },
          {
            'children': [
              {
                'code': 'wjlx_150',
                'id': '150',
                'name': '私设小金库',
                'parentId': '43'
              },
              {
                'code': 'wjlx_151',
                'id': '151',
                'name': '其他违反“收支两条线”行为',
                'parentId': '43'
              }
            ],
            'code': 'wjlx_43',
            'id': '43',
            'name': '违反收支两条线',
            'parentId': '7'
          },
          {
            'code': 'wjlx_44',
            'id': '44',
            'name': '违反政府采购和招投标',
            'parentId': '7'
          },
          {
            'children': [
              {
                'code': 'wjlx_152',
                'id': '152',
                'name': '隐瞒截留坐支财政收入',
                'parentId': '45'
              },
              {
                'code': 'wjlx_153',
                'id': '153',
                'name': '骗取国家拨款',
                'parentId': '45'
              },
              {
                'code': 'wjlx_154',
                'id': '154',
                'name': '违规核拨动用国家资金',
                'parentId': '45'
              },
              {
                'code': 'wjlx_155',
                'id': '155',
                'name': '借用公款不还',
                'parentId': '45'
              },
              {
                'code': 'wjlx_156',
                'id': '156',
                'name': '借用公款营利或非法活动',
                'parentId': '45'
              },
              {
                'code': 'wjlx_157',
                'id': '157',
                'name': '违规将公款借予他人',
                'parentId': '45'
              },
              {
                'code': 'wjlx_158',
                'id': '158',
                'name': '公款私存',
                'parentId': '45'
              },
              {
                'code': 'wjlx_159',
                'id': '159',
                'name': '单位收受礼品拒不交公',
                'parentId': '45'
              },
              {
                'code': 'wjlx_160',
                'id': '160',
                'name': '擅自开设银行账户',
                'parentId': '45'
              },
              {
                'code': 'wjlx_161',
                'id': '161',
                'name': '擅自动用查封冻结财物',
                'parentId': '45'
              },
              {
                'code': 'wjlx_162',
                'id': '162',
                'name': '违规担保',
                'parentId': '45'
              },
              {
                'code': 'wjlx_163',
                'id': '163',
                'name': '违反会计法规',
                'parentId': '45'
              },
              {
                'code': 'wjlx_164',
                'id': '164',
                'name': '其他违反财经纪律行为',
                'parentId': '45'
              }
            ],
            'code': 'wjlx_45',
            'id': '45',
            'name': '违反其他财经纪律',
            'parentId': '7'
          }
        ],
        'code': 'wjlx_7',
        'id': '7',
        'name': '违反财经纪律',
        'parentId': '1'
      },
      {
        'children': [
          {
            'code': 'wjlx_46',
            'id': '46',
            'name': '行政机关失职渎职',
            'parentId': '8'
          },
          {
            'code': 'wjlx_47',
            'id': '47',
            'name': '生产经营管理失职渎职',
            'parentId': '8'
          },
          {
            'children': [
              {
                'code': 'wjlx_165',
                'id': '165',
                'name': '不认真执行安全防护法律法规',
                'parentId': '48'
              },
              {
                'code': 'wjlx_166',
                'id': '166',
                'name': '组织群众性活动发生事故',
                'parentId': '48'
              },
              {
                'code': 'wjlx_167',
                'id': '167',
                'name': '公共场所事故',
                'parentId': '48'
              },
              {
                'code': 'wjlx_168',
                'id': '168',
                'name': '食品药品事故',
                'parentId': '48'
              }
            ],
            'code': 'wjlx_48',
            'id': '48',
            'name': '安全事故',
            'parentId': '8'
          },
          {
            'children': [
              {
                'code': 'wjlx_169',
                'id': '169',
                'name': '瞒案不报压案不办',
                'parentId': '49'
              },
              {
                'code': 'wjlx_170',
                'id': '170',
                'name': '对保护合法权益申请不作为',
                'parentId': '49'
              },
              {
                'code': 'wjlx_171',
                'id': '171',
                'name': '违规保全',
                'parentId': '49'
              },
              {
                'code': 'wjlx_172',
                'id': '172',
                'name': '不履行法定执行职责',
                'parentId': '49'
              },
              {
                'code': 'wjlx_173',
                'id': '173',
                'name': '不移交案件',
                'parentId': '49'
              },
              {
                'code': 'wjlx_174',
                'id': '174',
                'name': '办案安全事故',
                'parentId': '49'
              },
              {
                'code': 'wjlx_175',
                'id': '175',
                'name': '徇私舞弊枉法裁判',
                'parentId': '49'
              },
              {
                'code': 'wjlx_176',
                'id': '176',
                'name': '刑讯逼供暴力取证',
                'parentId': '49'
              },
              {
                'code': 'wjlx_177',
                'id': '177',
                'name': '不纠正冤假错案',
                'parentId': '49'
              }
            ],
            'code': 'wjlx_49',
            'id': '49',
            'name': '执纪执法司法失职渎职',
            'parentId': '8'
          },
          {
            'children': [
              {
                'code': 'wjlx_178',
                'id': '178',
                'name': '党组织负责人失职渎职',
                'parentId': '50'
              },
              {
                'code': 'wjlx_179',
                'id': '179',
                'name': '决定基建项目失误',
                'parentId': '50'
              },
              {
                'code': 'wjlx_180',
                'id': '180',
                'name': '社会管理和服务事故',
                'parentId': '50'
              },
              {
                'code': 'wjlx_181',
                'id': '181',
                'name': '处理灾害事故失职',
                'parentId': '50'
              },
              {
                'code': 'wjlx_182',
                'id': '182',
                'name': '瞒报谎报缓报漏报重要情况',
                'parentId': '50'
              },
              {
                'code': 'wjlx_183',
                'id': '183',
                'name': '解决群众切身利益问题失职',
                'parentId': '50'
              },
              {
                'code': 'wjlx_184',
                'id': '184',
                'name': '放任反党活动',
                'parentId': '50'
              },
              {
                'code': 'wjlx_185',
                'id': '185',
                'name': '不认真解决问题造成重大事件',
                'parentId': '50'
              },
              {
                'code': 'wjlx_186',
                'id': '186',
                'name': '不制止不查处不正之风',
                'parentId': '50'
              },
              {
                'code': 'wjlx_187',
                'id': '187',
                'name': '重大事件不及时作为',
                'parentId': '50'
              },
              {
                'code': 'wjlx_188',
                'id': '188',
                'name': '乱收费乱摊派',
                'parentId': '50'
              },
              {
                'code': 'wjlx_189',
                'id': '189',
                'name': '强令公职人员违规行使职权',
                'parentId': '50'
              },
              {
                'code': 'wjlx_190',
                'id': '190',
                'name': '强令实施违法行为',
                'parentId': '50'
              },
              {
                'code': 'wjlx_191',
                'id': '191',
                'name': '失职致使所属人员叛逃出走',
                'parentId': '50'
              },
              {
                'code': 'wjlx_192',
                'id': '192',
                'name': '失密泄密',
                'parentId': '50'
              },
              {
                'code': 'wjlx_193',
                'id': '193',
                'name': '其他失职渎职行为',
                'parentId': '50'
              }
            ],
            'code': 'wjlx_50',
            'id': '50',
            'name': '其他失职渎职',
            'parentId': '8'
          }
        ],
        'code': 'wjlx_8',
        'id': '8',
        'name': '失职渎职',
        'parentId': '1'
      },
      {
        'children': [
          {
            'code': 'wjlx_51',
            'id': '51',
            'name': '打击报复',
            'parentId': '9'
          },
          {
            'children': [
              {
                'code': 'wjlx_194',
                'id': '194',
                'name': '压制申辩等权利',
                'parentId': '52'
              },
              {
                'code': 'wjlx_195',
                'id': '195',
                'name': '侵犯选举权被选举权表决权',
                'parentId': '52'
              },
              {
                'code': 'wjlx_196',
                'id': '196',
                'name': '妨害选举权被选举权表决权',
                'parentId': '52'
              }
            ],
            'code': 'wjlx_52',
            'id': '52',
            'name': '侵犯民主权利',
            'parentId': '9'
          },
          {
            'children': [
              {
                'code': 'wjlx_197',
                'id': '197',
                'name': '侮辱诽谤',
                'parentId': '53'
              },
              {
                'code': 'wjlx_198',
                'id': '198',
                'name': '殴打体罚非法拘禁搜查',
                'parentId': '53'
              },
              {
                'code': 'wjlx_199',
                'id': '199',
                'name': '其他侵犯人身权利行为',
                'parentId': '53'
              }
            ],
            'code': 'wjlx_53',
            'id': '53',
            'name': '侵犯人身权利',
            'parentId': '9'
          },
          {
            'code': 'wjlx_54',
            'id': '54',
            'name': '诬告陷害',
            'parentId': '9'
          },
          {
            'children': [
              {
                'code': 'wjlx_200',
                'id': '200',
                'name': '违反劳动管理法律法规侵权',
                'parentId': '55'
              },
              {
                'code': 'wjlx_201',
                'id': '201',
                'name': '侵犯通信自由',
                'parentId': '55'
              },
              {
                'code': 'wjlx_202',
                'id': '202',
                'name': '干涉婚姻自由',
                'parentId': '55'
              },
              {
                'code': 'wjlx_203',
                'id': '203',
                'name': '其他侵权行为',
                'parentId': '55'
              }
            ],
            'code': 'wjlx_55',
            'id': '55',
            'name': '其他侵犯党员或公民权利',
            'parentId': '9'
          }
        ],
        'code': 'wjlx_9',
        'id': '9',
        'name': '侵犯党员权利公民权利',
        'parentId': '1'
      },
      {
        'children': [
          {
            'code': 'wjlx_56',
            'id': '56',
            'name': '弄虚作假骗取荣誉',
            'parentId': '10'
          },
          {
            'children': [
              {
                'code': 'wjlx_204',
                'id': '204',
                'name': '通奸',
                'parentId': '57'
              },
              {
                'code': 'wjlx_205',
                'id': '205',
                'name': '重婚或包养',
                'parentId': '57'
              }
            ],
            'code': 'wjlx_57',
            'id': '57',
            'name': '通奸重婚包养情人',
            'parentId': '10'
          },
          {
            'children': [
              {
                'code': 'wjlx_206',
                'id': '206',
                'name': '利用职权、教养、从属关系发生性行为',
                'parentId': '58'
              },
              {
                'code': 'wjlx_207',
                'id': '207',
                'name': '不履行抚养教育赡养义务',
                'parentId': '58'
              },
              {
                'code': 'wjlx_208',
                'id': '208',
                'name': '虐待遗弃',
                'parentId': '58'
              },
              {
                'code': 'wjlx_209',
                'id': '209',
                'name': '遇险能救不救',
                'parentId': '58'
              },
              {
                'code': 'wjlx_210',
                'id': '210',
                'name': '其他违反道德行为',
                'parentId': '58'
              }
            ],
            'code': 'wjlx_58',
            'id': '58',
            'name': '其他严重违反社会主义道德行为',
            'parentId': '10'
          }
        ],
        'code': 'wjlx_10',
        'id': '10',
        'name': '严重违反社会主义道德',
        'parentId': '1'
      }
    ],
    'code': 'wjlx',
    'id': '1',
    'name': '违纪行为',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'party_style_2946',
        'id': '2946',
        'name': '三务公开(3W)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2936',
        'id': '2936',
        'name': '八项规定(8X)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2954',
        'id': '2954',
        'name': '十个全覆盖(10)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2950',
        'id': '2950',
        'name': '大棚会所(DP)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2938',
        'id': '2938',
        'name': '小官大贪(XG)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2937',
        'id': '2937',
        'name': '形式官僚(GL)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2943',
        'id': '2943',
        'name': '扫黑除恶(SH)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2945',
        'id': '2945',
        'name': '扶贫领域(FP)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2944',
        'id': '2944',
        'name': '拍苍蝇(CY)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2948',
        'id': '2948',
        'name': '政府债务(ZW)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2949',
        'id': '2949',
        'name': '文物保护(WW)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2947',
        'id': '2947',
        'name': '环境保护(HB)',
        'parentId': '2935'
      },
      {
        'code': 'party_style_2942',
        'id': '2942',
        'name': '雁过拔毛(BM)',
        'parentId': '2935'
      }
    ],
    'code': 'party_style',
    'id': '2935',
    'name': '党风政风线索标签',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'handle_style_2922',
        'id': '2922',
        'name': '不督办(ND)',
        'parentId': '2920'
      },
      {
        'code': 'handle_style_2921',
        'id': '2921',
        'name': '督办(D)',
        'parentId': '2920'
      }
    ],
    'code': 'handle_style',
    'id': '2920',
    'name': '办理分类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'casereso_nm_2925',
        'id': '2925',
        'name': '上级交办(S)',
        'parentId': '2923'
      },
      {
        'code': 'casereso_nm_2924',
        'id': '2924',
        'name': '书记交办(A)',
        'parentId': '2923'
      },
      {
        'code': 'casereso_nm_2927',
        'id': '2927',
        'name': '外单位移交(W)',
        'parentId': '2923'
      },
      {
        'code': 'casereso_nm_2928',
        'id': '2928',
        'name': '其他(Q)',
        'parentId': '2923'
      },
      {
        'code': 'casereso_nm_2926',
        'id': '2926',
        'name': '巡视移交(X)',
        'parentId': '2923'
      }
    ],
    'code': 'casereso_nm',
    'id': '2923',
    'name': '案件来源',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'secondhandlemethod_2960',
            'id': '2960',
            'name': '暂存',
            'parentId': '2956'
          },
          {
            'code': 'secondhandlemethod_2961',
            'id': '2961',
            'name': '谈话',
            'parentId': '2956'
          },
          {
            'code': 'secondhandlemethod_2962',
            'id': '2962',
            'name': '函询',
            'parentId': '2956'
          },
          {
            'code': 'secondhandlemethod_2963',
            'id': '2963',
            'name': '初核',
            'parentId': '2956'
          },
          {
            'code': 'secondhandlemethod_2964',
            'id': '2964',
            'name': '立案',
            'parentId': '2956'
          },
          {
            'code': 'secondhandlemethod_2965',
            'id': '2965',
            'name': '了结',
            'parentId': '2956'
          }
        ],
        'code': 'handlemethod_2956',
        'id': '2956',
        'name': '自办',
        'parentId': '2955'
      },
      {
        'children': [
          {
            'code': 'secondhandlemethod_2966',
            'id': '2966',
            'name': '组团',
            'parentId': '2957'
          },
          {
            'code': 'secondhandlemethod_2967',
            'id': '2967',
            'name': '领办',
            'parentId': '2957'
          }
        ],
        'code': 'handlemethod_2957',
        'id': '2957',
        'name': '合办',
        'parentId': '2955'
      },
      {
        'children': [
          {
            'code': 'secondhandlemethod_2968',
            'id': '2968',
            'name': '处置待报',
            'parentId': '2958'
          },
          {
            'code': 'secondhandlemethod_2969',
            'id': '2969',
            'name': '正在审核',
            'parentId': '2958'
          },
          {
            'code': 'secondhandlemethod_2970',
            'id': '2970',
            'name': '退回补查',
            'parentId': '2958'
          }
        ],
        'code': 'handlemethod_2958',
        'id': '2958',
        'name': '交办',
        'parentId': '2955'
      }
    ],
    'code': 'handlemethod',
    'id': '2955',
    'name': '办理方式',
    'parentId': '0'
  },
  {
    'code': 'secondhandlemethod',
    'id': '2959',
    'name': '办理方式二级',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'jointmode_2972',
        'id': '2972',
        'name': '主办部门',
        'parentId': '2971'
      },
      {
        'code': 'jointmode_2973',
        'id': '2973',
        'name': '协办部门',
        'parentId': '2971'
      },
      {
        'code': 'jointmode_2974',
        'id': '2974',
        'name': '交办部门',
        'parentId': '2971'
      },
      {
        'code': 'jointmode_2975',
        'id': '2975',
        'name': '承办部门',
        'parentId': '2971'
      }
    ],
    'code': 'jointmode',
    'id': '2971',
    'name': '合办方式',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'disposalResult_2977',
        'id': '2977',
        'name': '属实',
        'parentId': '2976'
      },
      {
        'code': 'disposalResult_2978',
        'id': '2978',
        'name': '不属实',
        'parentId': '2976'
      },
      {
        'code': 'disposalResult_2979',
        'id': '2979',
        'name': '部分属实',
        'parentId': '2976'
      },
      {
        'code': 'disposalResult_2980',
        'id': '2980',
        'name': '谈话函询后予以采信',
        'parentId': '2976'
      },
      {
        'code': 'disposalResult_2981',
        'id': '2981',
        'name': '直接了结',
        'parentId': '2976'
      },
      {
        'code': 'disposalResult_2982',
        'id': '2982',
        'name': '其他',
        'parentId': '2976'
      }
    ],
    'code': 'disposalResult',
    'id': '2976',
    'name': '核实结果',
    'parentId': '0'
  },
  {
    'children': [
      {
        'children': [
          {
            'code': 'is_supervisory_party_1515',
            'id': '1515',
            'name': '涉嫌行贿的人员',
            'parentId': '1512'
          },
          {
            'code': 'is_supervisory_party_1516',
            'id': '1516',
            'name': '涉嫌共同职务违法犯罪的人员',
            'parentId': '1512'
          },
          {
            'code': 'is_supervisory_party_1517',
            'id': '1517',
            'name': '其他',
            'parentId': '1512'
          }
        ],
        'code': 'is_supervisory_party_1512',
        'id': '1512',
        'name': '是',
        'parentId': '1511'
      },
      {
        'code': 'is_supervisory_party_1513',
        'id': '1513',
        'name': '否',
        'parentId': '1511'
      }
    ],
    'code': 'is_supervisory_party',
    'id': '1511',
    'name': '是否非党员非监察对象',
    'parentId': '0'
  },
  {
    'code': '0',
    'id': '9999',
    'name': '监察对象二级，双非二级空白选项',
    'parentId': '0'
  },
  { // 形式主义官僚主义 id: 9000-9031
    'children': [
      {
        'children': [
          {
            'code': 'double_doctrines_9006',
            'id': '9006',
            'name': '落实中央精神缺乏实际行动',
            'parentId': '9001'
          },
          {
            'code': 'double_doctrines_9007',
            'id': '9007',
            'name': '贯彻中央重大决策部署打折扣搞变通类',
            'parentId': '9001'
          },
          {
            'code': 'double_doctrines_9008',
            'id': '9008',
            'name': '搞"政绩工程""形象工程"',
            'parentId': '9001'
          },
          {
            'code': 'double_doctrines_9009',
            'id': '9009',
            'name': '对监督检查整改落实不力',
            'parentId': '9001'
          },
          {
            'code': 'double_doctrines_9010',
            'id': '90010',
            'name': '其他问题',
            'parentId': '9001'
          }
        ],
        'code': 'double_doctrines_9001',
        'id': '9001',
        'name': '贯彻落实党的路线方针政策、中央重大决策部署方面',
        'parentId': '9000'
      },
      {
        'children': [
          {
            'code': 'double_doctrines_9011',
            'id': '9011',
            'name': '漠视群众利益和疾苦类',
            'parentId': '9002'
          },
          {
            'code': 'double_doctrines_9012',
            'id': '9012',
            'name': '态度差效率低',
            'parentId': '9002'
          },
          {
            'code': 'double_doctrines_9013',
            'id': '9013',
            'name': '言而无信影响营商环境',
            'parentId': '9002'
          },
          {
            'code': 'double_doctrines_9014',
            'id': '9014',
            'name': '对存在的问题消极对待',
            'parentId': '9002'
          },
          {
            'code': 'double_doctrines_9015',
            'id': '9015',
            'name': '其他问题',
            'parentId': '9002'
          }
        ],
        'code': 'double_doctrines_9002',
        'id': '9002',
        'name': '联系群众、服务群众方面',
        'parentId': '9000'
      },
      {
        'children': [
          {
            'code': 'double_doctrines_9016',
            'id': '9016',
            'name': '乱决策乱拍板乱作为',
            'parentId': '9003'
          },
          {
            'code': 'double_doctrines_9017',
            'id': '9017',
            'name': '不担当不作为不负责',
            'parentId': '9003'
          },
          {
            'code': 'double_doctrines_9018',
            'id': '9018',
            'name': '弄虚作假',
            'parentId': '9003'
          },
          {
            'code': 'double_doctrines_9019',
            'id': '9019',
            'name': '吃拿卡要',
            'parentId': '9003'
          },
          {
            'code': 'double_doctrines_9020',
            'id': '9020',
            'name': '其他问题',
            'parentId': '9003'
          }
        ],
        'code': 'double_doctrines_9003',
        'id': '9003',
        'name': '履职尽责、服务经济社会发展方面',
        'parentId': '9000'
      },
      {
        'children': [
          {
            'code': 'double_doctrines_9021',
            'id': '9021',
            'name': '学风漂浮',
            'parentId': '9004'
          },
          {
            'code': 'double_doctrines_9022',
            'id': '9022',
            'name': '会风不实',
            'parentId': '9004'
          },
          {
            'code': 'double_doctrines_9023',
            'id': '9023',
            'name': '文风不正',
            'parentId': '9004'
          },
          {
            'code': 'double_doctrines_9024',
            'id': '9024',
            'name': '调查研究搞形式走过场',
            'parentId': '9004'
          },
          {
            'code': 'double_doctrines_9025',
            'id': '9025',
            'name': '检查考核过多过滥',
            'parentId': '9004'
          },
          {
            'code': 'double_doctrines_9026',
            'id': '9026',
            'name': '虚假应对检查',
            'parentId': '9004'
          },
          {
            'code': 'double_doctrines_9027',
            'id': '9027',
            'name': '其他问题',
            'parentId': '9004'
          }
        ],
        'code': 'double_doctrines_9004',
        'id': '9004',
        'name': '学风会风文风及检查调研方面',
        'parentId': '9000'
      },
      {
        'children': [
          {
            'code': 'double_doctrines_9028',
            'id': '9028',
            'name': '党内政治生活不严肃',
            'parentId': '9005'
          },
          {
            'code': 'double_doctrines_9029',
            'id': '9029',
            'name': '全面从严治党责任落实不力',
            'parentId': '9005'
          },
          {
            'code': 'double_doctrines_9030',
            'id': '9030',
            'name': '推动基层党组织建设不扎实',
            'parentId': '9005'
          },
          {
            'code': 'double_doctrines_9031',
            'id': '9031',
            'name': '其他问题',
            'parentId': '9005'
          }
        ],
        'code': 'double_doctrines_9005',
        'id': '9005',
        'name': '管党治党方面',
        'parentId': '9000'
      }
    ],
    'code': 'double_doctrines',
    'id': '9000',
    'name': '形式主义官僚主义',
    'parentId': '0'
  },
  { // 扶贫领域 id: 9040-9057
    'children': [
      {
        'children': [
          {
            'code': 'support_poverty_9044',
            'id': '9044',
            'name': '贪污、侵占类',
            'parentId': '9041'
          },
          {
            'code': 'support_poverty_9045',
            'id': '9045',
            'name': '行贿类',
            'parentId': '9041'
          },
          {
            'code': 'support_poverty_9046',
            'id': '9046',
            'name': '受贿类',
            'parentId': '9041'
          },
          {
            'code': 'support_poverty_9047',
            'id': '9047',
            'name': '挪用类',
            'parentId': '9041'
          },
          {
            'code': 'support_poverty_9048',
            'id': '9048',
            'name': '优亲厚友类',
            'parentId': '9041'
          },
          {
            'code': 'support_poverty_9049',
            'id': '9049',
            'name': '吃拿卡要类',
            'parentId': '9041'
          },
          {
            'code': 'support_poverty_905',
            'id': '9050',
            'name': '其他腐败问题',
            'parentId': '9041'
          }
        ],
        'code': 'support_poverty_9041',
        'id': '9041',
        'name': '腐败问题',
        'parentId': '9040'
      },
      {
        'children': [
          {
            'code': 'support_poverty_9051',
            'id': '9051',
            'name': '违规决策类',
            'parentId': '9042'
          },
          {
            'code': 'support_poverty_9052',
            'id': '9052',
            'name': '弄虚作假类',
            'parentId': '9042'
          },
          {
            'code': 'support_poverty_9053',
            'id': '9053',
            'name': '做表面文章类',
            'parentId': '9042'
          },
          {
            'code': 'support_poverty_9054',
            'id': '9054',
            'name': '其他形式主义、官僚主义问题',
            'parentId': '9042'
          }
        ],
        'code': 'support_poverty_9042',
        'id': '9042',
        'name': '作风问题',
        'parentId': '9040'
      },
      {
        'children': [
          {
            'code': 'support_poverty_9055',
            'id': '9055',
            'name': '主体责任类',
            'parentId': '9043'
          },
          {
            'code': 'support_poverty_9056',
            'id': '9056',
            'name': '监督责任类',
            'parentId': '9043'
          },
          {
            'code': 'support_poverty_9057',
            'id': '9057',
            'name': '监管职责类',
            'parentId': '9043'
          }
        ],
        'code': 'support_poverty_9043',
        'id': '9043',
        'name': '失职失责问题',
        'parentId': '9040'
      }
    ],
    'code': 'support_poverty',
    'id': '9040',
    'name': '扶贫领域',
    'parentId': '0'
  },
  { // 民生领域 id: 9060-9063
    'children': [
      {
        'code': 'livelihood_9061',
        'id': '9061',
        'name': '腐败问题',
        'parentId': '9060'
      },
      {
        'code': 'livelihood_9062',
        'id': '9062',
        'name': '作风问题',
        'parentId': '9060'
      },
      {
        'code': 'livelihood_9063',
        'id': '9063',
        'name': '履行责任问题',
        'parentId': '9060'
      }
    ],
    'code': 'livelihood',
    'id': '9060',
    'name': '民生领域',
    'parentId': '0'
  },
  { // 政治面貌 id: 9070-9076
    'children': [
      {
        'code': 'political_status_9071',
        'id': '9071',
        'name': '中共党员',
        'parentId': '9070'
      },
      {
        'code': 'political_status_9072',
        'id': '9072',
        'name': '中共预备党员',
        'parentId': '9070'
      },
      {
        'code': 'political_status_9073',
        'id': '9073',
        'name': '共青团员',
        'parentId': '9070'
      },
      {
        'code': 'political_status_9074',
        'id': '9074',
        'name': '民主党派',
        'parentId': '9070'
      },
      {
        'code': 'political_status_9075',
        'id': '9075',
        'name': '无党派人士',
        'parentId': '9070'
      },
      {
        'code': 'political_status_9076',
        'id': '9076',
        'name': '其他',
        'parentId': '9070'
      }
    ],
    'code': 'political_status',
    'id': '9070',
    'name': '政治面貌',
    'parentId': '0'
  },
  { // 是否督办件 id: 9080-9085
    'children': [
      {
        'code': 'is_supervision_9081',
        'id': '9081',
        'name': '中央纪委督办',
        'parentId': '9080'
      },
      {
        'code': 'is_supervision_9082',
        'id': '9082',
        'name': '自治区纪委督办',
        'parentId': '9080'
      },
      {
        'code': 'is_supervision_9083',
        'id': '9083',
        'name': '盟市纪委督办',
        'parentId': '9080'
      },
      {
        'code': 'is_supervision_9084',
        'id': '9084',
        'name': '旗县纪委督办',
        'parentId': '9080'
      },
      {
        'code': 'is_supervision_9085',
        'id': '9085',
        'name': '否',
        'parentId': '9080'
      }
    ],
    'code': 'is_supervision',
    'id': '9080',
    'name': '是否督办件',
    'parentId': '0'
  },
  { // 追究责任 id: 9090-9092
    'children': [
      {
        'code': 'accountability_9091',
        'id': '9091',
        'name': '追究主体责任',
        'parentId': '9090'
      },
      {
        'code': 'accountability_9092',
        'id': '9092',
        'name': '追究监督责任',
        'parentId': '9090'
      }
    ],
    'code': 'accountability',
    'id': '9090',
    'name': '追究责任',
    'parentId': '0'
  },
  { // 干部层级 id: 9100-9105
    'children': [
      {
        'code': 'cadreLevel_9101',
        'id': '9101',
        'name': '省级',
        'parentId': '9100'
      },
      {
        'code': 'cadreLevel_9102',
        'id': '9102',
        'name': '地市级',
        'parentId': '9100'
      },
      {
        'code': 'cadreLevel_9103',
        'id': '9103',
        'name': '县级',
        'parentId': '9100'
      },
      {
        'code': 'cadreLevel_9104',
        'id': '9104',
        'name': '乡镇级',
        'parentId': '9100'
      },
      {
        'code': 'cadreLevel_9105',
        'id': '9105',
        'name': '村社级',
        'parentId': '9100'
      }
    ],
    'code': 'cadreLevel',
    'id': '9100',
    'name': '干部层级',
    'parentId': '0'
  },
  { // 干部层级 id: 9110-9117
    'children': [
      {
        'code': 'basicCadre_9111',
        'id': '9111',
        'name': '村社干部',
        'parentId': '9110'
      },
      {
        'code': 'basicCadre_9112',
        'id': '9112',
        'name': '城市社区干部',
        'parentId': '9110'
      },
      {
        'code': 'basicCadre_9113',
        'id': '9113',
        'name': '村党支部书记',
        'parentId': '9110'
      },
      {
        'code': 'basicCadre_9114',
        'id': '9114',
        'name': '村主任',
        'parentId': '9110'
      },
      {
        'code': 'basicCadre_9115',
        'id': '9115',
        'name': '城市社区党支部书记',
        'parentId': '9110'
      },
      {
        'code': 'basicCadre_9116',
        'id': '9116',
        'name': '居委会主任',
        'parentId': '9110'
      },
      {
        'code': 'basicCadre_9117',
        'id': '9117',
        'name': '站所干部(如派出所、水利站、经营站等)',
        'parentId': '9110'
      }
    ],
    'code': 'basicCadre',
    'id': '9110',
    'name': '基层干部',
    'parentId': '0'
  },
  { // 呈批件分类 id: 9120 - 9168
    'children': [
      {
        'code': 'cadreLevel_9121',
        'id': '9121',
        'name': '会议类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9169',
            'id': '9169',
            'name': '集体会商请示',
            'parentId': '9121'
          },
          {
            'code': 'cpclassify_9127',
            'id': '9127',
            'name': '集体会商纪要',
            'parentId': '9121'
          },
          {
            'code': 'cpclassify_9175',
            'id': '9175',
            'name': '专题会请示',
            'parentId': '9121'
          },
          {
            'code': 'cpclassify_9176',
            'id': '9176',
            'name': '专题会纪要',
            'parentId': '9121'
          },
          // {
          //   'code': 'cpclassify_9177',
          //   'id': '9177',
          //   'name': '室务会请示',
          //   'parentId': '9121' ,
          // },
          {
            'code': 'cpclassify_9178',
            'id': '9178',
            'name': '书记专题会请示',
            'parentId': '9121'
          },
          {
            'code': 'cpclassify_9179',
            'id': '9179',
            'name': '书记专题会纪要',
            'parentId': '9121'
          },
          {
            'code': 'cpclassify_9180',
            'id': '9180',
            'name': '其他',
            'parentId': '9121'
          }
        ]
      },
      {
        'code': 'cadreLevel_9189',
        'id': '9189',
        'name': '线索处置类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9190',
            'id': '9190',
            'name': '问题线索处置请示',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9168',
            'id': '9168',
            'name': '了结报告',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9172',
            'id': '9172',
            'name': '暂存待查',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9174',
            'id': '9174',
            'name': '判重/取消判重',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9304',
            'id': '9304',
            'name': '合并办理请示',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9305',
            'id': '9305',
            'name': '新增线索请示',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9306',
            'id': '9306',
            'name': '转外单位',
            'parentId': '9189'
          },
          {
            'code': 'cpclassify_9181',
            'id': '9188',
            'name': '其他',
            'parentId': '9189'
          }
        ]
      },
      {
        'code': 'cadreLevel_9122',
        'id': '9122',
        'name': '谈话函询类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9129',
            'id': '9129',
            'name': '谈话方案',
            'parentId': '9122'
          },
          {
            'code': 'cpclassify_9130',
            'id': '9130',
            'name': '函询方案',
            'parentId': '9122'
          },
          {
            'code': 'cpclassify_9131',
            'id': '9131',
            'name': '谈话函询情况报告和处理意见',
            'parentId': '9122'
          },
          {
            'code': 'cpclassify_9132',
            'id': '9132',
            'name': '诫勉谈话方案',
            'parentId': '9122'
          },
          {
            'code': 'cpclassify_9133',
            'id': '9133',
            'name': '轻微处理方案',
            'parentId': '9122'
          },
          {
            'code': 'cpclassify_9134',
            'id': '9134',
            'name': '委托了解核实函',
            'parentId': '9122'
          },
          {
            'code': 'cpclassify_9181',
            'id': '9181',
            'name': '其他',
            'parentId': '9122'
          }
        ]
      },
      {
        'code': 'cadreLevel_9123',
        'id': '9123',
        'name': '初步核实类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9135',
            'id': '9135',
            'name': '初核请示报告',
            'parentId': '9123'
          },
          {
            'code': 'cpclassify_9136',
            'id': '9136',
            'name': '初核情况报告',
            'parentId': '9123'
          },
          {
            'code': 'cpclassify_9137',
            'id': '9137',
            'name': '谈话提醒方案',
            'parentId': '9123'
          },
          // {
          //   'code': 'cpclassify_9138',
          //   'id': '9138',
          //   'name': '移送函',
          //   'parentId': '9123' ,
          // },
          {
            'code': 'cpclassify_9139',
            'id': '9139',
            'name': '委托了解核实函',
            'parentId': '9123'
          },
          {
            'code': 'cpclassify_9182',
            'id': '9182',
            'name': '其他',
            'parentId': '9123'
          }
        ]
      },
      {
        'code': 'cadreLevel_9124',
        'id': '9124',
        'name': '立案审查调查类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9140',
            'id': '9140',
            'name': '立案审查调查的请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9141',
            'id': '9141',
            'name': '立案审查调查方案',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9142',
            'id': '9142',
            'name': '审查调查工作方案请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9143',
            'id': '9143',
            'name': '立案情况通报',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9144',
            'id': '9144',
            'name': '成立临时党支部的请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9145',
            'id': '9145',
            'name': '延长留置期限请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9146',
            'id': '9146',
            'name': '解除留置措施请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9151',
            'id': '9151',
            'name': '提请审理提前介入请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9153',
            'id': '9153',
            'name': '审查调查报告',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9149',
            'id': '9149',
            'name': '涉案款物处理请示',
            'parentId': '9124'
          },
          {
            'code': 'cpclassify_9147',
            'id': '9147',
            'name': '移送审理请示',
            'parentId': '9124'
          },
          // {
          //   'code': 'cpclassify_9148',
          //   'id': '9148',
          //   'name': '阶段性情况报告',
          //   'parentId': '9124' ,
          // },
          // {
          //   'code': 'cpclassify_9150',
          //   'id': '9150',
          //   'name': '检举问题线索处置的请示',
          //   'parentId': '9124' ,
          // },
          //
          // {
          //   'code': 'cpclassify_9152',
          //   'id': '9152',
          //   'name': '移送审理审批表',
          //   'parentId': '9124' ,
          // },
          //
          // {
          //   'code': 'cpclassify_9154',
          //   'id': '9154',
          //   'name': '撤案报告',
          //   'parentId': '9124' ,
          // },
          {
            'code': 'cpclassify_9183',
            'id': '9183',
            'name': '其他',
            'parentId': '9124'
          }
        ]
      },
      {
        'code': 'cadreLevel_9125',
        'id': '9125',
        'name': '业务文书类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9155',
            'id': '9155',
            'name': '措施文书申请',
            'parentId': '9125'
          },
          {
            'code': 'cpclassify_9188',
            'id': '9156',
            'name': '程序文书申请',
            'parentId': '9125'
          },
          {
            'code': 'cpclassify_9189',
            'id': '9157',
            'name': '外部协助文书申请',
            'parentId': '9125'
          },
          {
            'code': 'cpclassify_9184',
            'id': '9184',
            'name': '其他',
            'parentId': '9125'
          }
        ]
      },
      {
        'code': 'cadreLevel_9126',
        'id': '9126',
        'name': '检举控告类',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9158',
            'id': '9158',
            'name': '留存归档请示',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9159',
            'id': '9159',
            'name': '转问题线索请示',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9160',
            'id': '9160',
            'name': '退信访请示',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9161',
            'id': '9161',
            'name': '集体会商纪要',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9163',
            'id': '9163',
            'name': '专题会纪要',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9164',
            'id': '9164',
            'name': '判重/取消判重',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9303',
            'id': '9303',
            'name': '合并办理请示',
            'parentId': '9126'
          },
          {
            'code': 'cpclassify_9162',
            'id': '9162',
            'name': '其他',
            'parentId': '9126'
          }
        ]
      },
      { // 240-245
        'code': 'cadreLevel_9240',
        'id': '9240',
        'name': '纪检监察建议书',
        'parentId': '9120',
        'children': [
          {
            'code': 'cpclassify_9241',
            'id': '9241',
            'name': '纪律检查建议',
            'parentId': '9240'
          },
          {
            'code': 'cpclassify_9242',
            'id': '9242',
            'name': '监察建议',
            'parentId': '9240'
          },
          {
            'code': 'cpclassify_9243',
            'id': '9243',
            'name': '纪检监察建议',
            'parentId': '9240'
          }
        ]
      }
    ],
    'code': 'cpclassify',
    'id': '9120',
    'name': '呈批件分类',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'rank_detail_9191',
        'id': '9191',
        'name': '省管正职',
        'parentId': '9190'
      },
      {
        'code': 'rank_detail_9192',
        'id': '9192',
        'name': '省管副职',
        'parentId': '9190'
      },
      {
        'code': 'rank_detail_9193',
        'id': '9193',
        'name': '其他省管干部',
        'parentId': '9190'
      },
      {
        'code': 'rank_detail_9194',
        'id': '9194',
        'name': '非省管干部',
        'parentId': '9190'
      }
    ],
    'code': 'rank_detail_province',
    'id': '9190',
    'name': '职级详情',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'is_Eight_Point_detail_9196',
        'id': '9196',
        'name': '无',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9197',
        'id': '9197',
        'name': '违规公款吃喝',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9198',
        'id': '9198',
        'name': '公款国内旅游',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9199',
        'id': '9199',
        'name': '公款出国（境）旅游',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9200',
        'id': '9200',
        'name': '违规配备使用公务用车',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9201',
        'id': '9201',
        'name': '楼堂馆所违规问题',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9202',
        'id': '9202',
        'name': '违规发放津贴补贴或福利',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9203',
        'id': '9203',
        'name': '违规收送礼品礼金',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9204',
        'id': '9204',
        'name': '大办婚丧喜庆',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9205',
        'id': '9205',
        'name': '提供或接受超标准接待',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9206',
        'id': '9206',
        'name': '接受或用公款参与高消费娱乐健身活动',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9207',
        'id': '9207',
        'name': '违规出入私人会所',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9208',
        'id': '9208',
        'name': '领导干部住房违规',
        'parentId': '9195'
      },
      {
        'code': 'is_Eight_Point_detail_9209',
        'id': '9209',
        'name': '违规接受管理服务对象宴请',
        'parentId': '9195'
      }
    ],
    'code': 'is_Eight_Point_detail',
    'id': '9195',
    'name': '是否反映违反中央八项规定精神',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': 'is_gangs_involved_9211',
        'id': '9211',
        'name': '无',
        'parentId': '9210'
      },
      {
        'code': 'is_gangs_involved_9212',
        'id': '9212',
        'name': '涉黑涉恶背后腐败问题',
        'parentId': '9210'
      },
      {
        'code': 'is_gangs_involved_9213',
        'id': '9213',
        'name': '保护伞问题',
        'parentId': '9210'
      }
    ],
    'code': 'is_gangs_involved',
    'id': '9210',
    'name': '涉黑涉恶背后腐败',
    'parentId': '0'
  },
  { // 职级详情(市级)
    'children': [
      {
        'code': 'rank_detail_9221',
        'id': '9221',
        'name': '市管正职',
        'parentId': '9220'
      },
      {
        'code': 'rank_detail_9222',
        'id': '9222',
        'name': '市管副职',
        'parentId': '9220'
      },
      {
        'code': 'rank_detail_9223',
        'id': '9223',
        'name': '其他市管干部',
        'parentId': '9220'
      },
      {
        'code': 'rank_detail_9224',
        'id': '9224',
        'name': '非市管干部',
        'parentId': '9220'
      }
    ],
    'code': 'rank_detail_city',
    'id': '9220',
    'name': '职级详情',
    'parentId': '0'
  },
  { // 职级详情(区县级)
    'children': [
      {
        'code': 'rank_detail_9226',
        'id': '9226',
        'name': '县(市、区)管正职',
        'parentId': '9225'
      },
      {
        'code': 'rank_detail_9227',
        'id': '9227',
        'name': '县(市、区)管副职',
        'parentId': '9225'
      },
      {
        'code': 'rank_detail_9228',
        'id': '9228',
        'name': '其他县(市、区)管干部',
        'parentId': '9225'
      },
      {
        'code': 'rank_detail_9229',
        'id': '9229',
        'name': '非县(市、区)管干部',
        'parentId': '9225'
      }
    ],
    'code': 'rank_detail_county',
    'id': '9225',
    'name': '职级详情',
    'parentId': '0'
  },
  { // 任职情况
    'children': [
      {
        'code': 'rank_position_9231',
        'id': '9231',
        'name': '现职',
        'parentId': '9230'
      },
      {
        'code': 'rank_position_9232',
        'id': '9232',
        'name': '前任职',
        'parentId': '9230'
      },
      {
        'code': 'rank_position_9233',
        'id': '9233',
        'name': '退休',
        'parentId': '9230'
      }
    ],
    'code': 'rank_position',
    'id': '9230',
    'name': '任职情况',
    'parentId': '0'
  },
  { // 处罚情况 9236-9239
    'children': [
      {
        'code': 'punishments_9237',
        'id': '9237',
        'name': '已罚不诉',
        'parentId': '9236'
      },
      {
        'code': 'punishments_9238',
        'id': '9238',
        'name': '判决生效',
        'parentId': '9236'
      },
      {
        'code': 'punishments_9239',
        'id': '9239',
        'name': '其他',
        'parentId': '9236'
      }
    ],
    'code': 'punishments',
    'id': '9236',
    'name': '任职情况',
    'parentId': '0'
  },
  { // 处置结果  9246-9252
    'children': [
      {
        'children': [
          {
            'code': 'transacmode_963_1',
            'id': '9247_1',
            'name': '谈话函询',
            'parentId': '9247'
          },
          {
            'code': 'transacmode_963_2',
            'id': '9247_2',
            'name': '了结',
            'parentId': '9247'
          },
          {
            'code': 'transacmode_963_3',
            'id': '9247_3',
            'name': '适当处理',
            'parentId': '9247'
          },
          {
            'code': 'transacmode_963_4',
            'id': '9247_4',
            'name': '转初步核实',
            'parentId': '9247'
          },
          {
            'code': 'transacmode_963_5',
            'id': '9247_5',
            'name': '暂存待查',
            'parentId': '9247'
          }
        ],
        'code': 'transacmode_963',
        'id': '9247',
        'name': '谈话函询',
        'parentId': '9246'
      },
      {
        'children': [
          {
            'code': 'transacmode_865_1',
            'id': '9248_1',
            'name': '予以了结',
            'parentId': '9248'
          },
          {
            'code': 'transacmode_865_2',
            'id': '9248_2',
            'name': '谈话提醒',
            'parentId': '9248'
          },
          {
            'code': 'transacmode_865_3',
            'id': '9248_3',
            'name': '暂存待查',
            'parentId': '9248'
          },
          {
            'code': 'transacmode_865_4',
            'id': '9248_4',
            'name': '移送有关党组织',
            'parentId': '9248'
          },
          {
            'code': 'transacmode_865_5',
            'id': '9248_5',
            'name': '立案审查',
            'parentId': '9248'
          }
        ],
        'code': 'transacmode_865',
        'id': '9248',
        'name': '初步核实',
        'parentId': '9246'
      },
      {
        'code': 'transacmode_866',
        'id': '9249',
        'name': '暂存',
        'parentId': '9246'
      },
      {
        'code': 'transacmode_868',
        'id': '9250',
        'name': '了结',
        'parentId': '9246'
      },
      {
        'children': [
          {
            'code': 'transacmode_864_1',
            'id': '9251_1',
            'name': '移送审理',
            'parentId': '9251'
          },
          {
            'code': 'transacmode_864_2',
            'id': '9251_2',
            'name': '撤销案件',
            'parentId': '9251'
          },
          {
            'code': 'transacmode_864_3',
            'id': '9251_3',
            'name': '添加留置',
            'parentId': '9251'
          }
        ],
        'code': 'transacmode_864',
        'id': '9251',
        'name': '拟立案',
        'parentId': '9246'
      },
      {
        'children': [
          {
            'code': 'transacmode_891_1',
            'id': '9252_1',
            'name': '移送审理',
            'parentId': '9252'
          }
        ],
        'code': 'transacmode_891',
        'id': '9252',
        'name': '不立案',
        'parentId': '9246'
      }
    ],
    'code': 'final_handle_result',
    'id': '9246',
    'name': '处置结果',
    'parentId': '0'
  },
  { // 退回补充调查原因 1002-1009
    'children': [
      {
      'code': 'backreason_1',
      'id': '1003',
      'name': '事实不清',
      'parentId': '1'
      },
      {
      'code': 'backreason_2',
      'id': '1004',
      'name': '证据不足',
      'parentId': '2'
      },
      {
      'code': 'backreason_3',
      'id': '1005',
      'name': '程序不规范',
      'parentId': '3'
      },
      {
      'code': 'backreason_4',
      'id': '1006',
      'name': '手续不完备',
      'parentId': '4'
      },
      {
      'code': 'backreason_5',
      'id': '1007',
      'name': '检察机关借审限',
      'parentId': '5'
      },
      {
      'code': 'backreason_6',
      'id': '1008',
      'name': '并案处理',
      'parentId': '6'
      },
      {
      'code': 'backreason_7',
      'id': '1009',
      'name': '其他',
      'parentId': '7'
      },
    ],
    'code': 'return_supplement_inquireReason',
    'id': '1002',
    'name': '退回补充调查原因',
    'parentId': '0'
  },
  { // 退回补充调查原因 1002-1009
    'children': [
      {
      'code': 'twicereason_1',
      'id': '1144',
      'name': '事实不清',
      'parentId': '1'
      },
      {
      'code': 'twicereason_2',
      'id': '1145',
      'name': '证据不足',
      'parentId': '2'
      },
      {
      'code': 'twicereason_3',
      'id': '1146',
      'name': '程序不规范',
      'parentId': '3'
      },
      {
      'code': 'twicereason_4',
      'id': '1147',
      'name': '手续不完备',
      'parentId': '4'
      },
      {
      'code': 'twicereason_5',
      'id': '1148',
      'name': '检察机关借审限',
      'parentId': '5'
      },
      {
      'code': 'twicereason_6',
      'id': '1149',
      'name': '并案处理',
      'parentId': '6'
      },
      {
      'code': 'twicereason_7',
      'id': '1150',
      'name': '其他',
      'parentId': '7'
      },
    ],
    'code': 'SRSIReason',
    'id': '1143',
    'name': '二次退回补充调查原因',
    'parentId': '0'
  },
  { //不起诉原因  1010-1013
    'children': [
      {
      'code': 'notsuereason_1',
      'id': '1011',
      // 'name': '事实不清',
      'name': '法定不起诉',
      'parentId': '1'
      },
      {
      'code': 'notsuereason_2',
      'id': '1012',
      // 'name': '证据不足',
      'name': '证据不足不起诉',
      'parentId': '2'
      },
      {
      'code': 'notsuereason_3',
      'id': '1013',
      // 'name': '程序不规范',
      'name': '酌定不起诉',
      'parentId': '3'
      }
    ],
    'code': 'notToProsecuteReason',
    'id': '1011',
    'name': '不起诉原因',
    'parentId': '0'
  },
  { //公安等其他行政执法机关处罚  828-830
    'children': [
      {
      'code': 'qtcf_1',
      'id': '829',
      'name': '行政拘留',
      'parentId': '1'
      },
      {
      'code': 'qtcf_2',
      'id': '830',
      'name': '其他处罚',
      'parentId': '2'
      }
    ],
    'code': 'otherPenalties',
    'id': '828',
    'name': '其他处罚',
    'parentId': '0'
  },
  { //新党纪处分  1151-1156
    'children': [
      {
      'code': 'newPartypunis_1',
      'id': '1152',
      'name': '警告',
      'parentId': '1'
      },
      {
      'code': 'newPartypunis_2',
      'id': '1153',
      'name': '警告',
      'parentId': '2'
      },
      {
      'code': 'newPartypunis_3',
      'id': '1154',
      'name': '撤销党内职务',
      'parentId': '3'
      },
      {
      'code': 'newPartypunis_4',
      'id': '1155',
      'name': '留党察看',
      'parentId': '4'
      },
      {
      'code': 'newPartypunis_5',
      'id': '1156',
      'name': '开除党籍',
      'parentId': '5'
      }
    ],
    'code': 'newPartyPunishment',
    'id': '1151',
    'name': '新党纪处分',
    'parentId': '0'
  },
  { //新留党察看  1157-1159
    'children': [
      {
      'code': 'newlLdckyear_1',
      'id': '1158',
      'name': '一年',
      'parentId': '1'
      },
      {
      'code': 'newlLdckyear_2',
      'id': '1159',
      'name': '两年',
      'parentId': '2'
      }
    ],
    'code': 'newPartyInspectionYear',
    'id': '1157',
    'name': '新留党察看',
    'parentId': '0'
  },
  { //新政务处分  1160-1168
    'children': [
      {
      'code': 'newAdminpunis_1',
      'id': '1161',
      'name': '警告',
      'parentId': '1'
      },
      {
      'code': 'newAdminpunis_2',
      'id': '1162',
      'name': '记过',
      'parentId': '2'
      },
      {
      'code': 'newAdminpunis_3',
      'id': '1163',
      'name': '记大过',
      'parentId': '3'
      },
      {
      'code': 'newAdminpunis_4',
      'id': '1164',
      'name': '降级',
      'parentId': '4'
      },
      {
      'code': 'newAdminpunis_5',
      'id': '1165',
      'name': '降职',
      'parentId': '5'
      },
      {
      'code': 'newAdminpunis_6',
      'id': '1166',
      'name': '撤职',
      'parentId': '6'
      },
      {
      'code': 'newAdminpunis_7',
      'id': '1167',
      'name': '开除留用察看',
      'parentId': '7'
      },
      {
      'code': 'newAdminpunis_8',
      'id': '1168',
      'name': '开除',
      'parentId': '8'
      }
    ],
    'code': 'newDisciplinaryAction',
    'id': '1157',
    'name': '新政务处分',
    'parentId': '0'
  },
  { //新留党察看  1157-1159
    'children': [
      {
      'code': 'newOthertreat_1',
      'id': '1170',
      'name': '免予党纪处分',
      'parentId': '1'
      },
      {
      'code': 'newOthertreat_2',
      'id': '1171',
      'name': '免予政务处分',
      'parentId': '2'
      },
      {
      'code': 'newOthertreat_3',
      'id': '1172',
      'name': '不予处分',
      'parentId': '3'
      },
      {
      'code': 'newOthertreat_4',
      'id': '1173',
      'name': '改组党组织',
      'parentId': '4'
      },
      {
      'code': 'newOthertreat_5',
      'id': '1174',
      'name': '解散党组织',
      'parentId': '5'
      },
      {
      'code': 'newOthertreat_6',
      'id': '1175',
      'name': '处分有关人员',
      'parentId': '6'
      },
      {
      'code': 'newOthertreat_7',
      'id': '1176',
      'name': '对两非人员不予移送检察机关',
      'parentId': '7'
      },
      {
      'code': 'newOthertreat_8',
      'id': '1177',
      'name': '移送其他纪检监察机关立案审查调查',
      'parentId': '8'
      }
    ],
    'code': 'newOtherSanctions',
    'id': '1169',
    'name': '新留党察看',
    'parentId': '0'
  },
  { //新组织措施  1178-1212
    'children': [
      {
      'code': 'transacmode_1232',
      'id': '1179',
      'name': '提醒谈话',
      'parentId': '1'
      },
      {
      'code': 'transacmode_1233',
      'id': '1180',
      'name': '警示谈话',
      'parentId': '2'
      },
      {
      'code': 'transacmode_1231',
      'id': '1181',
      'name': '批评教育',
      'parentId': '3'
      },
      {
      'code': 'transacmode_1229',
      'id': '1182',
      'name': '纠正或责令停止违纪行为',
      'parentId': '4'
      },
      {
      'code': 'transacmode_1230',
      'id': '1183',
      'name': '责成退出违纪所得',
      'parentId': '5'
      },
      {
      'code': 'transacmode_1236',
      'id': '1184',
      'name': '限期整改',
      'parentId': '6'
      },
      {
      'code': 'transacmode_1235',
      'id': '1185',
      'name': '责令作出口头或书面检查',
      'parentId': '7'
      },
      {
      'code': 'transacmode_1234',
      'id': '1186',
      'name': '召开民主生活会批评帮助',
      'parentId': '8'
      },
      {
      'code': 'transacmode_894',
      'id': '1187',
      'name': '责令公开道歉（检讨）',
      'parentId': '9'
      },
      {
      'code': 'transacmode_885',
      'id': '1188',
      'name': '通报（通报批评）',
      'parentId': '10'
      },
      {
      'code': 'transacmode_892',
      'id': '1190',
      'name': '诫勉（诫勉谈话）',
      'parentId': '11'
      },
      {
      'code': 'transacmode_897',
      'id': '1191',
      'name': '其它批评教育类措施',
      'parentId': '12'
      },
      {
      'code': 'transacmode_1237',
      'id': '1192',
      'name': '取消荣誉称号',
      'parentId': '13'
      },
      {
      'code': 'transacmode_1225',
      'id': '1193',
      'name': '撤销政协委员资格',
      'parentId': '14'
      },
      {
      'code': 'transacmode_1224',
      'id': '1194',
      'name': '终止（罢免、撤销、责令辞去）人大代表资格',
      'parentId': '15'
      },
      {
      'code': 'transacmode_890',
      'id': '1195',
      'name': '取消预备党员资格',
      'parentId': '16'
      },
      {
      'code': 'transacmode_1226',
      'id': '1196',
      'name': '取消（罢免）当选资格',
      'parentId': '17'
      },
      {
      'code': 'transacmode_1223',
      'id': '1197',
      'name': '终止党代表资格',
      'parentId': '18'
      },
      {
      'code': 'transacmode_893',
      'id': '1198',
      'name': '停职（停职检查）',
      'parentId': '19'
      },
      {
      'code': 'transacmode_888',
      'id': '1199',
      'name': '调整（调离）职务（岗位）',
      'parentId': '20'
      },
      {
      'code': 'transacmode_889',
      'id': '1200',
      'name': '免职',
      'parentId': '21'
      },
      {
      'code': 'transacmode_895',
      'id': '1201',
      'name': '引咎辞职',
      'parentId': '22'
      },
      {
      'code': 'transacmode_896',
      'id': '1202',
      'name': '责令辞职',
      'parentId': '23'
      },
      {
      'code': 'transacmode_1228',
      'id': '1202',
      'name': '改任非领导职务',
      'parentId': '24'
      },
      {
      'code': 'transacmode_1227',
      'id': '1203',
      'name': '安排提前退休',
      'parentId': '25'
      },
      {
      'code': 'transacmode_1303',
      'id': '1204',
      'name': '降低退休待遇',
      'parentId': '26'
      },
      {
      'code': 'transacmode_1305',
      'id': '1205',
      'name': '其它组织调整类措施',
      'parentId': '27'
      },
      {
      'code': 'transacmode_1299',
      'id': '1206',
      'name': '降职',
      'parentId': '28'
      },
      {
      'code': 'transacmode_1304',
      'id': '1207',
      'name': '取消退休待遇',
      'parentId': '29'
      },
      {
      'code': 'transacmode_886',
      'id': '1208',
      'name': '解聘',
      'parentId': '30'
      },
      {
      'code': 'transacmode_1302',
      'id': '1209',
      'name': '解除劳动合同',
      'parentId': '31'
      },
      {
      'code': 'transacmode_887',
      'id': '1210',
      'name': '辞退',
      'parentId': '32'
      },
      {
      'code': 'transacmode_1301',
      'id': '1211',
      'name': '组织除名（劝退）',
      'parentId': '33'
      },
      {
      'code': 'transacmode_1300',
      'id': '1212',
      'name': '其它重大职务调整类措施',
      'parentId': '34'
      }
    ],
    'code': 'newOrganizationalMeasures',
    'id': '1178',
    'name': '新组织措施',
    'parentId': '0'
  },
  { //变更、撤消理由  960-965
    'children': [
      {
      'code': 'rerebcreas_1',
      'id': '961',
      'name': '事实不符',
      'parentId': '1'
      },
      {
      'code': 'rerebcreas_2',
      'id': '962',
      'name': '证据不足',
      'parentId': '2'
      },
      {
      'code': 'rerebcreas_3',
      'id': '963',
      'name': '定性不准',
      'parentId': '3'
      },
      {
      'code': 'rerebcreas_4',
      'id': '964',
      'name': '处分不当',
      'parentId': '4'
      },
      {
      'code': 'rerebcreas_5',
      'id': '965',
      'name': '违反程序',
      'parentId': '5'
      },
      {
      'code': 'rerebcreas_6',
      'id': '966',
      'name': '适用纪律法律不当',
      'parentId': '6'
      },
    ],
    'code': 'changeDispositionReason',
    'id': '960',
    'name': '变更、撤消理由',
    'parentId': '0'
  },
  { //法院判决罪名一级  1034-1042
    'children': [
      {
      'code': 'crimename_1',
      'id': '1035',
      'name': '无罪',
      'parentId': '1'
      },
      {
      'code': 'crimename_2',
      'id': '1036',
      'name': '贪污贿赂',
      'parentId': '2',
      'children': [
        {
          'code': 'crimename_2_1',
          'id': '1044',
          'name': '贪污',
          'parentId': '1',
        },
        {
          'code': 'crimename_2_2',
          'id': '1045',
          'name': '挪用公款',
          'parentId': '2',
        },
        {
          'code': 'crimename_2_3',
          'id': '1046',
          'name': '受贿',
          'parentId': '3',
        },
        {
          'code': 'crimename_2_4',
          'id': '1047',
          'name': '单位受贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_5',
          'id': '1048',
          'name': '利用影响力受贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_6',
          'id': '1049',
          'name': '非国家工作人员受贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_7',
          'id': '1050',
          'name': '行贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_8',
          'id': '1051',
          'name': '对有影响力的人行贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_9',
          'id': '1052',
          'name': '对单位行贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_10',
          'id': '1053',
          'name': '介绍贿赂',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_11',
          'id': '1054',
          'name': '单位行贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_12',
          'id': '1055',
          'name': '对非国家工作人员行贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_13',
          'id': '1056',
          'name': '对外国公职人员、国际公共组织官员行贿',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_14',
          'id': '1057',
          'name': '巨额财产来源不明',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_15',
          'id': '1058',
          'name': '隐瞒境外存款',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_16',
          'id': '1059',
          'name': '私分国有资产',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_17',
          'id': '1060',
          'name': '私分罚没财物',
          'parentId': '4',
        },
        {
          'code': 'crimename_2_18',
          'id': '1061',
          'name': '其他',
          'parentId': '4',
        },
      ]
      },
      {
      'code': 'crimename_3',
      'id': '1037',
      'name': '滥用职权',
      'parentId': '3',
      'children':[
        {
          'code': 'crimename_3_1',
          'id': '1063',
          'name': '滥用职权',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_2',
          'id': '1064',
          'name': '滥用管理公司、证券职权',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_3',
          'id': '1065',
          'name': '食品监管渎职',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_4',
          'id': '1066',
          'name': '故意泄露国家秘密',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_5',
          'id': '1067',
          'name': '阻碍解救被拐卖、绑架妇女、儿童',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_6',
          'id': '1068',
          'name': '帮助犯罪分子逃避处罚',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_7',
          'id': '1069',
          'name': '违法发放林木采伐许可证',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_8',
          'id': '1070',
          'name': '办理偷越国（边）境人员出入境证件',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_9',
          'id': '1071',
          'name': '放行偷越国（边）境人员',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_10',
          'id': '1072',
          'name': '国有公司、企业、事业单位人员滥用职权',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_11',
          'id': '1073',
          'name': '报复陷害',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_12',
          'id': '1074',
          'name': '非法剥夺公民宗教信仰自由',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_13',
          'id': '1075',
          'name': '侵犯少数民族风俗习惯',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_14',
          'id': '1076',
          'name': '打击报复会计、统计人员',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_15',
          'id': '1077',
          'name': '挪用特定款物',
          'parentId': '4',
        },
        {
          'code': 'crimename_3_16',
          'id': '1078',
          'name': '其他',
          'parentId': '4',
        },
      ]
      },
      {
      'code': 'crimename_4',
      'id': '1038',
      'name': '玩忽职守',
      'parentId': '4',
      'children':[
        {
          'code': 'crimename_4_1',
          'id': '1080',
          'name': '玩忽职守',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_2',
          'id': '1081',
          'name': '国家机关工作人员签订、履行合同失职被骗',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_3',
          'id': '1082',
          'name': '环境监管失职',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_4',
          'id': '1083',
          'name': '传染病防治失职',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_5',
          'id': '1084',
          'name': '商检失职',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_6',
          'id': '1085',
          'name': '动植物检疫失职',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_7',
          'id': '1086',
          'name': '不解救被拐卖、绑架妇女、儿童',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_8',
          'id': '1087',
          'name': '失职造成珍贵文物损毁、流失',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_9',
          'id': '1088',
          'name': '过失泄露国家秘密',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_10',
          'id': '1089',
          'name': '国有公司、企业、事业单位人员失职',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_11',
          'id': '1090',
          'name': '签订、履行合同失职被骗',
          'parentId': '4',
        },
        {
          'code': 'crimename_4_12',
          'id': '1091',
          'name': '其他',
          'parentId': '4',
        },
      ]
      },
      {
      'code': 'crimename_5',
      'id': '1093',
      'name': '徇私舞弊',
      'parentId': '5',
      'children':[
        {
          'code': 'crimename_5_1',
          'id': '1093',
          'name': '非法批准征收、征用、占用土地',
          'parentId': '1',
        },
        {
          'code': 'crimename_5_2',
          'id': '1094',
          'name': '非法低价出让国有土地使用权',
          'parentId': '2',
        },
        {
          'code': 'crimename_5_3',
          'id': '1095',
          'name': '枉法仲裁',
          'parentId': '3',
        },
        {
          'code': 'crimename_5_4',
          'id': '1096',
          'name': '徇私舞弊发售发票、抵扣税款、出口退税',
          'parentId': '4',
        },
        {
          'code': 'crimename_5_5',
          'id': '1097',
          'name': '商检徇私舞弊',
          'parentId': '5',
        },
        {
          'code': 'crimename_5_6',
          'id': '1098',
          'name': '动植物检疫徇私舞弊',
          'parentId': '6',
        },
        {
          'code': 'crimename_5_7',
          'id': '1099',
          'name': '放纵走私',
          'parentId': '7',
        },
        {
          'code': 'crimename_5_8',
          'id': '1100',
          'name': '放纵制售伪劣商品犯罪行为',
          'parentId': '8',
        },
        {
          'code': 'crimename_5_9',
          'id': '1101',
          'name': '招收公务员、学生徇私舞弊',
          'parentId': '9',
        },
        {
          'code': 'crimename_5_10',
          'id': '1102',
          'name': '徇私舞弊不移交刑事案件',
          'parentId': '10',
        },
        {
          'code': 'crimename_5_11',
          'id': '1103',
          'name': '违法提供出口退税凭证',
          'parentId': '11',
        },
        {
          'code': 'crimename_5_12',
          'id': '1104',
          'name': '徇私舞弊不征、少征税款',
          'parentId': '12',
        },
        {
          'code': 'crimename_5_13',
          'id': '1105',
          'name': '徇私舞弊低价折股、出售国有资产',
          'parentId': '13',
        },
        {
          'code': 'crimename_5_14',
          'id': '1106',
          'name': '非法经营同类营业',
          'parentId': '14',
        },
        {
          'code': 'crimename_5_15',
          'id': '1107',
          'name': '为亲友非法牟利',
          'parentId': '15',
        },
        {
          'code': 'crimename_5_16',
          'id': '1108',
          'name': '其他',
          'parentId': '16',
        },
      ]
      },
      {
      'code': 'crimename_6',
      'id': '1040',
      'name': '重大责任事故',
      'parentId': '6',
      'children':[
        {
          'code': 'crimename_6_1',
          'id': '1110',
          'name': '重大责任事故',
          'parentId': '1',
        },
        {
          'code': 'crimename_6_2',
          'id': '1111',
          'name': '教育设施重大安全事故',
          'parentId': '2',
        },
        {
          'code': 'crimename_6_3',
          'id': '1112',
          'name': '消防责任事故',
          'parentId': '3',
        },
        {
          'code': 'crimename_6_4',
          'id': '1113',
          'name': '重大劳动安全事故',
          'parentId': '4',
        },
        {
          'code': 'crimename_6_5',
          'id': '1114',
          'name': '强令违章冒险作业',
          'parentId': '5',
        },
        {
          'code': 'crimename_6_6',
          'id': '1115',
          'name': '不报、谎报安全事故',
          'parentId': '6',
        },
        {
          'code': 'crimename_6_7',
          'id': '1116',
          'name': '铁路运营安全事故',
          'parentId': '7',
        },
        {
          'code': 'crimename_6_8',
          'id': '1117',
          'name': '重大飞行事故',
          'parentId': '8',
        },
        {
          'code': 'crimename_6_9',
          'id': '1118',
          'name': '大型群众性活动重大安全事故',
          'parentId': '9',
        },
        {
          'code': 'crimename_6_10',
          'id': '1119',
          'name': '危险物品肇事',
          'parentId': '10',
        },
        {
          'code': 'crimename_6_11',
          'id': '1120',
          'name': '工程重大安全事故',
          'parentId': '11',
        },
        {
          'code': 'crimename_6_12',
          'id': '1121',
          'name': '其他',
          'parentId': '12',
        },
      ]
      },
      {
      'code': 'crimename_7',
      'id': '1041',
      'name': '其他职务违法犯罪',
      'parentId': '7',
      'children':[
        {
          'code': 'crimename_7_1',
          'id': '1123',
          'name': '背信损害上市公司利益',
          'parentId': '1',
        },
        {
          'code': 'crimename_7_2',
          'id': '1124',
          'name': '金融工作人员购买假币、以假币换取货币',
          'parentId': '2',
        },
        {
          'code': 'crimename_7_3',
          'id': '1125',
          'name': '利用未公开信息交易',
          'parentId': '3',
        },
        {
          'code': 'crimename_7_4',
          'id': '1126',
          'name': '诱骗投资者买卖证券、期货合约',
          'parentId': '4',
        },
        {
          'code': 'crimename_7_5',
          'id': '1127',
          'name': '背信运用受托财产',
          'parentId': '5',
        },
        {
          'code': 'crimename_7_6',
          'id': '1128',
          'name': '违法运用资金',
          'parentId': '6',
        },
        {
          'code': 'crimename_7_7',
          'id': '1129',
          'name': '违法发放贷款',
          'parentId': '7',
        },
        {
          'code': 'crimename_7_8',
          'id': '1130',
          'name': '吸收客户资金不入账',
          'parentId': '8',
        },
        {
          'code': 'crimename_7_9',
          'id': '1131',
          'name': '违规出具金融票证',
          'parentId': '9',
        },
        {
          'code': 'crimename_7_10',
          'id': '1132',
          'name': '对违法票据承兑、付款、保证',
          'parentId': '10',
        },
        {
          'code': 'crimename_7_11',
          'id': '1133',
          'name': '非法转让、倒卖土地使用权',
          'parentId': '11',
        },
        {
          'code': 'crimename_7_12',
          'id': '1134',
          'name': '职务侵占',
          'parentId': '12',
        },
        {
          'code': 'crimename_7_13',
          'id': '1135',
          'name': '挪用资金',
          'parentId': '13',
        },
        {
          'code': 'crimename_7_14',
          'id': '1136',
          'name': '破坏选举',
          'parentId': '14',
        },
        {
          'code': 'crimename_7_15',
          'id': '1137',
          'name': '私自开拆、隐匿、毁弃邮件、电报',
          'parentId': '15',
        },
        {
          'code': 'crimename_7_16',
          'id': '1138',
          'name': '故意延误投递邮件',
          'parentId': '16',
        },
        {
          'code': 'crimename_7_17',
          'id': '1139',
          'name': '泄露不应公开的案件信息',
          'parentId': '17',
        },
        {
          'code': 'crimename_7_18',
          'id': '1140',
          'name': '披露、道不应公开的案件信息',
          'parentId': '18',
        },
        {
          'code': 'crimename_7_19',
          'id': '1141',
          'name': '接送不合格兵员',
          'parentId': '19',
        },
        {
          'code': 'crimename_7_20',
          'id': '1142',
          'name': '其他',
          'parentId': '20',
        },
      ]
      },
      {
      'code': 'crimename_8',
      'id': '1042',
      'name': '其他非职务违法犯罪',
      'parentId': '8'
      },
    ],
    'code': 'crimename',
    'id': '1034',
    'name': '法院判决罪名一级',
    'parentId': '0'
  },
  { //建议文书类型
    'children': [
      {
        'code': 'jytype_1',
        'id': '993',
        'name': '纪律检查建议',
        'parentId': '1'
      },
      {
        'code': 'jytype_2',
        'id': '994',
        'name': '监察建议',
        'parentId': '2'
      },
    ],
    'code': 'proposeType',
    'id': '992',
    'name': '建议文书类型',
    'parentId': '0'
  },
]



// WEBPACK FOOTER //
// ./src/js/CategoryMapNeimeng.js